import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import { OCULTAR_GESTION_VACACIONES_FICHA } from '../../../config/flags';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { TextAreaa } from './FormCrearCategoriaPublicacion';
import { AlertTriangle, Anchor, Boxes, Briefcase, Building2, Calendar, CalendarClock, ClipboardList, Copy, ExternalLink, Eye, GraduationCap, IdCard, KeyRound, Landmark, Laptop, Lock, Mail, MapPin, Monitor, Phone, Send, Server, Trash2, Umbrella, Users, Wrench } from 'lucide-react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import ImagenDefault from './../../img/imgDefault.png';
import IconosGenerales from "../iconos/IconosGenerales";
import { useParams, useLocation, useNavigate } from "react-router-dom";
// Fase 11 §2.bis — la baja desde la ficha. EL MISMO diálogo que usa la pestaña de Bajas.
import CrearBajaDialog, { AvisoRevertirBaja } from '../../componentes/incorporaciones/CrearBajaDialog';
import { bajaAbiertaDePersona, cancelarBaja, altasDePersona, fechaManualDePersona } from '../../componentes/incorporaciones/api';
import EditarAltaDialog from '../../componentes/incorporaciones/EditarAltaDialog';
import EditarBajaDialog from '../../componentes/incorporaciones/EditarBajaDialog';
import { rutaAlta, rutaBaja } from '../../componentes/incorporaciones/rutasProceso';
import { rutaDeVuelta } from '../../../funciones/rutaDeVuelta';
import { puedeAbrirFichas, puedeVerSoporte } from '../../providers/rolesFicha';
import { handleChangeErrors, handleSubmitErrorsPersonas, todosDatosCorrectos } from '../../validacion/ValidationFormPersona';
import { fetchEditarPersona, fetchPersonaData, fetchAdjuntosData, fetchPersonasData, fetchDatosSoporte, fetchTiposContrato } from '../../../peticiones_API/PeticionesGestionPersonasPersonas';
// El contador ya no vive aquí: subió al candado de la barra (CandadoVentana).
import { PuertaSegundoFactor, useVentanaSegundoFactor, Modal } from '../../componentes/ui-v2.5';
import { BloqueAccesoSeguridad } from '../../componentes/incorporaciones/BloqueAccesoSeguridad';
import { PestanaRrhh } from '../../componentes/incorporaciones/PestanaRrhh';
import { PestanaFormacion } from '../../componentes/incorporaciones/PestanaFormacion';
import { PestanaCredenciales } from '../../componentes/incorporaciones/PestanaCredenciales';
import { PestanaInventario } from '../../componentes/incorporaciones/PestanaInventario';
import BloqueCorreosFicha from '../../componentes/correos/BloqueCorreosFicha';
import { PestanaCitasTecnicas } from '../../componentes/intervenciones/ficha/PestanaCitasTecnicas';
import { fetchAccesos } from '../../../peticiones_API/PeticionesFichaAccesos';
import { fetchEditarPersonaColaboradora, fetchPersonaColaboradoraData, fetchCandidatosSupervisorColab } from '../../../peticiones_API/PeticionesPersonasColaboradoras';
import { fetchOficinasData } from '../../../peticiones_API/PeticionesGestionPersonasOficinas';
import { fetchEmpresasData } from '../../../peticiones_API/PeticionesGestionPersonasEmpresas';
import { fetchCalendariosLaborales } from '../../../peticiones_API/PeticionesCalendariosLaborales';
import { fetchCalendariosLaboralesColab } from '../../../peticiones_API/PeticionesCalendariosLaboralesColab';
import { fetchEmpresasColaboradorasData } from '../../../peticiones_API/PeticionesEmpresasColaboradoras';
import { fetchCrearLinkBitWarden } from '../../../peticiones_API/PeticionesBitWarden'; //Peticiones para la generación de links
import { fetchSolicitarUrlBitWarden} from '../../../peticiones_API/PeticionesAuth'; //Petición para solicitar el envío del correo con el link de BitWarden
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { DatosCorrectosPersona, ServerNoCreoPersona, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import LogoAnyDesk from './../../img/anydesk_logo.png';
import LogoAnyDeskMovil from './../../img/anydesk_movil.png';
import Switch from '@mui/material/Switch';


import ErrorForm from '../eventos/avisos/Alerta';
// MUI, para el banner de proceso de salida abierto. `ErrorForm` es para errores de campo.
import Alert from '@mui/material/Alert';
import CustomTooltip from '../eventos/avisos/Tooltip';
// MUI, para envolver las pestañas deshabilitadas. `CustomTooltip` es otro componente.
import Tooltip from '@mui/material/Tooltip';
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { UsuarioContext } from "../../providers/personaContext";
import { getProvincias, getMunicipios, buscarDireccionPorCP, buscarCPPorPoblacion, buscarProvinciaPorNombre } from '../../../utils/direccionesUtils';
import { CAMPOS_SOPORTE, soporteDe, mezclarCargaFicha, soporteCargadoBien, quitarSoporteSiNoCargado } from './soporteFicha';

/**
 * Fase B · quién alcanza la PANTALLA de Soporte.
 *
 * Eran sólo `super administrador`, y la pestaña no protegía nada: el backend concede los datos de
 * soporte a los dos roles —`services/camposListado.js`, `ROLES_CON_SECRETOS`—, así que un
 * Administrador podía pedirlos por API y no verlos en pantalla.
 *
 * Esa es la peor combinación posible: **la restricción molesta a quien trabaja y no detiene a
 * quien no**. Lo que se abre aquí es el acceso a la PANTALLA, no a los secretos: las credenciales
 * siguen detrás de la puerta del segundo factor, y el servidor sigue exigiéndola.
 *
 * Se escribe una sola vez porque vive en VARIOS sitios —la pestaña, su panel, la corrección del
 * `?tab=` de más abajo y el enlace a la ficha del panel del técnico (LinkFichaPersona)— y tenerlo
 * copiado a mano es cómo se abre uno y se olvida el otro. Desde el 3/11 vive en rolesFicha.js
 * (`ROLES_SOPORTE`, `puedeVerSoporte`), junto a quién abre fichas.
 */

/* ── LA INSIGNIA LA DECIDE EL SERVIDOR ─────────────────────────────────────────────────────
 *
 * Aquí había una función que la componía a partir del estado y la presencia. Se fue, y con ella
 * una copia de la regla: **qué insignia ve cada rol es una decisión del servidor**, porque
 * esconder un chip en el frontend no es no mandarlo — quien mire la pestaña de red lo vería igual.
 *
 * Ahora llega hecha en `personaData.insignia`: `{ clave, texto, tono }`, o `null` si a quien mira
 * no le toca verla. Y `null` es **sin insignia**, no una insignia gris: no se miente, sencillamente
 * no se dice, que es distinto de decir «Inactivo» — eso ya sería información.
 */
/* Los estados del ALTA —no los de la persona—. El ENUM viaja en ingles de maquina y la
 * pantalla tiene que decirlo en castellano, igual que los tipos de contrato. */
// Los cuatro estados son los MISMOS en altas y en bajas, así que el mapa sirve a los dos. Se
// llamaba `ESTADO_ALTA_TEXTO` y desde que la tabla trae bajas ese nombre mentía.
const ESTADO_PROCESO_TEXTO = { borrador: 'Borrador', en_curso: 'En curso', completada: 'Completada', cancelada: 'Cancelada' };

const TONO_A_COLOR = { verde: 'success', azul: 'info', ambar: 'warning', gris: 'default' };


// Los mismos tres que pueden elegir el grupo `laboral` de la exportación: con quién firma alguien
// su contrato es un dato de la relación laboral. `general` edita fichas y NO entra.
const ROLES_CON_EMPRESA_CONTRATANTE = ['administrador', 'super administrador', 'recursos humanos'];

/**
 * Fase 12 · §6.6 — LAS PESTAÑAS SE IDENTIFICAN POR NOMBRE, NO POR POSICIÓN.
 *
 * MUI numera los `<Tab>` sin `value` por su posición ENTRE LOS RENDERIZADOS. Con pestañas
 * condicionales eso tiene dos consecuencias, y la segunda es la grave:
 *
 *   · el índice YA dependía del rol — tres pestañas sin Soporte, cuatro con ella
 *   · al insertar Formación y RRHH, Soporte pasaría a ser la 5, y **hay tres sitios que la
 *     enlazan por el número**: `DetalleAlta.jsx`, `LinkFichaPersona.jsx` y esta misma ficha
 *
 * Y con RRHH condicionada al PERMISO, el número dependería además del permiso de quien mira: **dos
 * personas con el mismo enlace irían a pestañas distintas.** No daría ningún error.
 *
 * Con `value` por nombre, la posición deja de significar nada.
 */
const TAB = {
  PERSONAL: 'personal',
  EMPRESA: 'empresa',
  VACACIONES: 'vacaciones',
  FORMACION: 'formacion',
  RRHH: 'rrhh',
  CREDENCIALES: 'credenciales',
  INVENTARIO: 'inventario',
  CITAS: 'citas_tecnicas',
  SOPORTE: 'soporte',
};

/**
 * Los enlaces que ya circulan usan `?tab=3`. Se traducen al leer la URL, así que **siguen
 * funcionando** — y los nuevos pueden escribir el nombre.
 *
 * Los números son los de ANTES de esta fase: 0-3, cuando Soporte era la última.
 */
const TAB_POR_NUMERO = { 0: TAB.PERSONAL, 1: TAB.EMPRESA, 2: TAB.VACACIONES, 3: TAB.SOPORTE };

/**
 * Fase 12 · §6.10 — LAS PESTAÑAS QUE GUARDA EL `PUT` DE LA FICHA.
 *
 * ── QUÉ PROBLEMA RESUELVE ─────────────────────────────────────────────────────────────────
 *
 * Había DOS botones que decían «Guardar» en la misma pantalla: el grande de abajo, que lleva
 * años significando «guarda esta ficha», y el de las pestañas nuevas. El grande mandaba
 * `PUT /editarPersona/:id` con los campos que conoce, **devolvía 200 y no se quejaba**, y dejaba
 * atrás lo escrito en RRHH y en Formación, que viven en otras tablas con sus propios endpoints.
 *
 * Quien escribía un IBAN y pulsaba el grande veía un guardado correcto y perdía el dato.
 *
 * > **El fallo no era que el botón estuviera: era que guardaba a medias y sin decirlo.**
 *
 * Esconderlo en esas dos pestañas —lo que se probó en §6.9— quitaba la ambigüedad quitando la
 * función, y de paso dejaba dos pestañas con una pantalla distinta de las otras cuatro. Así que
 * el botón se queda en las seis y **guarda lo de la pestaña que se esté viendo**.
 *
 * ── PARA QUÉ SIRVE ESTA LISTA, ENTONCES ───────────────────────────────────────────────────
 *
 * Ya no decide si el botón se pinta: decide **por dónde guarda**. Las de aquí van por el `PUT`
 * de `personas`; las demás, por la función que cada pestaña registra en `guardadoDePestana`.
 *
 * Y sigue siendo lista blanca, no negra, por lo mismo que la exportación: la pestaña que se
 * añada mañana no entrará sola en el `PUT` de la ficha. Si no registra su guardado, su botón no
 * hace nada — que es visible al probarla. Al revés, una lista negra la metería en el `PUT`
 * general en silencio, y volveríamos al fallo que esto arregla.
 *
 * Qué guarda cada una, comprobado:
 *   PERSONAL, EMPRESA, VACACIONES → campos de `personas`, en `personaData`.
 *   SOPORTE                       → también: `usuario_nas`, `password_nas`, `password_m365`…
 *                                   viajan en el mismo cuerpo, y `handleSubmit` incluso los
 *                                   BORRA del payload si la puerta está cerrada.
 *   FORMACION, RRHH               → tablas propias y endpoints propios. Registran su guardado.
 *   CREDENCIALES, INVENTARIO      → sin panel todavía. Nada que guardar, y nada registrado.
 */
const TABS_QUE_GUARDA_LA_FICHA = [TAB.PERSONAL, TAB.EMPRESA, TAB.VACACIONES, TAB.SOPORTE];

/**
 * Fase 13 · LAS PESTAÑAS DONDE NO HAY NADA QUE GUARDAR, NUNCA.
 *
 * Inventario es de **solo lectura por diseño**: asignar y devolver material es del módulo de
 * Inventario, no de la ficha. No es un estado temporal a la espera de que llegue la función.
 *
 * ── POR QUÉ DESHABILITADOS Y NO QUITADOS ──────────────────────────────────────────────────
 *
 * Los tres botones se quedan en las seis pestañas: **si cuatro tienen tres, las seis los tienen.**
 * Quitarlos aquí devolvería la pantalla que cambia de forma según dónde estés, y obliga a mirar
 * dónde está cada cosa cada vez.
 *
 * Pero dejarlos ACTIVOS sería literalmente el fallo de la Fase 12: un «Guardar» que se pulsa, no
 * hace nada y no lo dice. Y sacar un aviso cada vez que alguien lo pulsa enseña a ignorar los
 * avisos.
 *
 * Así que salen **deshabilitados con su motivo**, que es lo mismo que se hizo con estas dos
 * pestañas en la Fase 12 un nivel más arriba: existir dice que el sitio es ése; estar en gris dice
 * que aquí no toca.
 *
 * `Cancelar` NO se deshabilita: es navegación, no guardado, y funciona igual en todas.
 */
// Citas técnicas (24/10), igual: es un historial; las personas se gestionan en sus lotes, desde el
// resumen de la campaña.
const TABS_SOLO_LECTURA = [TAB.INVENTARIO, TAB.CITAS];

/** Traduce lo que venga en `?tab=`: un nombre, un número viejo, o nada. */
function tabDeParametro(valor) {
  if (!valor) return TAB.PERSONAL;
  const texto = String(valor);
  if (Object.values(TAB).includes(texto)) return texto;
  return TAB_POR_NUMERO[texto] || TAB.PERSONAL;
}


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ pt: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
}

/**
 * ── LO QUE EL SERVIDOR RECALCULA AL GUARDAR ───────────────────────────────────────────────
 *
 * Tras el PUT, `estado` ya es el nuevo —es estado del formulario— pero la insignia, el acceso,
 * la coherencia y la presencia eran los que trajo el GET al entrar. La ficha enseñaba a la vez
 * «Suspendido» y «Activo · Con acceso · Trabajando»: **no una pantalla desactualizada, una
 * pantalla que se contradice a sí misma y afirma lo contrario de lo que se acaba de guardar.**
 *
 * Y no era que «Guardar y Salir» funcionase: **es que te obligaba a salir para no ver la mentira.**
 *
 * ── POR QUÉ SÓLO ESTOS CUATRO, Y NO LA RESPUESTA ENTERA ───────────────────────────────────
 *
 * Pisar `personaData` con lo que devuelve el servidor se llevaría por delante **lo que el
 * usuario tenga escrito en otras pestañas** y todavía no haya guardado. Se funden los cuatro
 * campos calculados y nada más: son justo los que esta pantalla no sabe calcular.
 *
 * `acceso` y `presencia` pueden NO venir —a los roles que no ven la situación no se les manda—,
 * así que se copia **lo que llegue**, sin inventar `undefined` donde no había clave. Por eso se
 * recorre lo presente en la respuesta en lugar de asignar los cuatro a ciegas.
 */
const CAMPOS_QUE_RECALCULA_EL_SERVIDOR = ['insignia', 'acceso', 'acceso_coherente', 'presencia'];

/* ── LO QUE ESCRIBE UN PROCESO, Y LA FICHA TIENE QUE ACEPTAR ──────────────────────────────────
 *
 * Crear una baja con fecha de hoy o pasada escribe `estado`, `activo` y `fecha_baja` EN EL ACTO,
 * en la misma transacción que el proceso (Fase 11). Estos son los campos que deja de mandar el
 * formulario y pasa a mandar el proceso, y por eso al volver se cogen de la respuesta fresca y no
 * de lo que hubiera en pantalla: «un estado que un proceso escribe no se elige a mano».
 *
 * Lista BLANCA y no «toda la persona»: recargarla entera pisaría lo que quien mira tenga a medio
 * escribir en el formulario. Se acepta lo que el proceso posee, y nada más.
 */
const CAMPOS_QUE_ESCRIBE_UN_PROCESO = ['estado', 'activo', 'fecha_baja', 'fecha_alta'];
const FECHAS_DE_ESA_LISTA = ['fecha_baja', 'fecha_alta'];

const fundirCalculados = (setPersonaData, respuesta) => {
    const cuerpo = respuesta && respuesta.data;
    if (!cuerpo || typeof cuerpo !== 'object') return;
    const recalculado = {};
    for (const campo of CAMPOS_QUE_RECALCULA_EL_SERVIDOR) {
        if (campo in cuerpo) recalculado[campo] = cuerpo[campo];
    }
    if (Object.keys(recalculado).length === 0) return;
    setPersonaData((anterior) => ({ ...anterior, ...recalculado }));
};

const FormEditarPersona = ({ departamentos, roles, negocios, estados, tipo = "empleado" }) => {

    const { Id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const persona = useContext(UsuarioContext);
    const API_URL = process.env.REACT_APP_API_URL;

    const parametrosBusqueda = new URLSearchParams(location.search);
    const tabDesdeURL = parametrosBusqueda.get('tab');
    /* ── `?volver=`: de dónde vienes, para volver allí al guardar ─────────────────────────────
     *
     * Lo pone la pantalla del proceso de alta o de baja al mandarte aquí a corregir un dato
     * (FASE_PANTALLA_DE_ALTA_Y_BAJA.md, §6, pieza 2). Sólo se usa VALIDADO: es un valor que viene
     * en la URL y lo puede escribir cualquiera, y sin validar sería un redirect abierto (ver
     * `rutaDeVuelta`). Si no es válido vale `null` y la ficha hace lo de siempre: el listado.
     *
     * Lo usan las TRES salidas de la ficha: «Guardar y salir» por la pestaña (más abajo, en
     * `handleSubmit`), «Guardar y salir» por Personal (`DatosCorrectosPersona`) y «Cancelar». Si
     * una de las tres lo ignorara, salir por ella te dejaría en el listado sin camino de vuelta. */
    const volver = rutaDeVuelta(parametrosBusqueda.get('volver'));
    /* Si llegaste desde el proceso NAVEGANDO (lo marca `ESTADO_DESDE_PROCESO`), volver es
     * retroceder: el historial queda «listado → proceso» y el «Volver» del proceso sigue llevando al
     * listado. Si no (URL pegada, otra pestaña), se navega a `volver` SUSTITUYENDO esta entrada, por
     * lo mismo. En los dos casos el proceso se monta de nuevo y pide el detalle: el dato corregido
     * sale sin recargar. Los cambios de pestaña de esta ficha conservan la marca (`state`). */
    const vueltaPorHistorial = !!(location.state && location.state.vueltaPorHistorial);
    const salirAlProceso = () => (vueltaPorHistorial ? navigate(-1) : navigate(volver, { replace: true }));
    const [personaData, setPersonaData] = useState({
        id: Id,
        Rol: {}
    });
    // ── Fase 11 §2.bis · la baja se crea desde la ficha ──────────────────────────────────
    // `estadoOriginal` es el estado CARGADO DE LA BASE, y no el del formulario. El diálogo
    // dispara en la TRANSICIÓN —pasar a Baja—, no en el valor. Hay cuatro filas heredadas con
    // `estado = Baja` y `activo = 1`, declaradas fuera de alcance: si se mirase el valor,
    // entrarían por la puerta de atrás y quien fuese a cambiarle el teléfono a alguien ya dado
    // de baja se encontraría un diálogo pidiéndole fecha y motivo de una salida que no gestiona.
    const [estadoOriginal, setEstadoOriginal] = useState(null);
    const [dlgBaja, setDlgBaja] = useState(null);           // diálogo de creación abierto
    const [avisoRevertir, setAvisoRevertir] = useState(null); // baja abierta al salir de "Baja"
    // Fase 12 · §6.6 — el proceso de salida abierto, si lo hay. Se consulta AL CARGAR y no sólo al
    // cambiar de estado: quien abre la ficha tiene que verlo sin tener que tocar nada.
    const [bajaAbierta, setBajaAbierta] = useState(null);

    /**
     * Fase 13 · los contadores de Credenciales e Inventario.
     *
     * Salen de UNA sola lectura —`GET /personas/:id/accesos`, 3,1 ms medidos—, la misma que
     * alimenta las dos pestañas. Dos llamadas ejecutarían el mismo servicio dos veces para
     * responder a la misma pregunta.
     *
     * Y **no bloquean el pintado**: si tarda o falla, las pestañas salen sin número. Un contador
     * es un adorno informativo; la ficha, no.
     */
    const [resumenAccesos, setResumenAccesos] = useState(null);
    const anotarResumen = useCallback((r) => setResumenAccesos(r || null), []);

    /**
     * Y se pide AL CARGAR LA FICHA, no al abrir la pestaña.
     *
     * Escrito sólo como callback de las pestañas, el contador aparecía **después** de entrar en
     * ellas — es decir, cuando ya no servía para nada: un número en una pestaña existe justamente
     * para decidir si entrar.
     *
     * Las pestañas siguen llamando a `alContar` cuando recargan, para que el número se refresque
     * al registrar o revocar. Este efecto es el que lo pone al principio.
     *
     * **No bloquea nada.** Si falla o tarda, las pestañas salen sin número: un contador es un
     * adorno informativo, y la ficha no debe esperarle.
     */
    useEffect(() => {
        if (!Id) return undefined;
        let vivo = true;
        fetchAccesos(Id, tipo === 'colaboradora' ? 'colaboradora' : null)
            .then((d) => { if (vivo) setResumenAccesos(d?.resumen || null); })
            .catch(() => { if (vivo) setResumenAccesos(null); });
        return () => { vivo = false; };
    }, [Id, tipo]);
    const [bajaCreada, setBajaCreada] = useState(null);     // la que se acaba de crear, para avisar

    /**
     * Relee la persona y acepta SOLO lo que un proceso posee.
     *
     * No es «recargar la ficha»: eso pisaría lo que haya a medio escribir en el formulario. Es
     * coger de la respuesta fresca la lista blanca de arriba —estado, acceso y fechas— mas los
     * cuatro calculados que ya tenian su propia regla desde Fase 14b.
     *
     * Silenciosa a proposito: si la relectura falla, el proceso YA esta creado y decirlo aqui con
     * un error haria dudar de la baja, que si existe. Lo peor que pasa es que la ficha siga
     * enseñando lo viejo hasta que se recargue — que es exactamente donde estabamos.
     */
    const refrescarLoQueEscribioElProceso = useCallback(async () => {
        try {
            const fresca = tipo === "colaboradora" ? await fetchPersonaColaboradoraData(Id) : await fetchPersonaData(Id);
            if (!fresca || typeof fresca !== 'object') return;
            const nuevo = {};
            for (const campo of [...CAMPOS_QUE_ESCRIBE_UN_PROCESO, ...CAMPOS_QUE_RECALCULA_EL_SERVIDOR]) {
                if (campo in fresca) nuevo[campo] = fresca[campo];
            }
            // Las fechas, al formato del input, igual que en la carga inicial. Sin esto el campo
            // `date` se queda VACIO ante un `2026-09-26T00:00:00.000Z` y pareceria que no hay fecha.
            for (const campo of FECHAS_DE_ESA_LISTA) {
                if (typeof nuevo[campo] === 'string') nuevo[campo] = nuevo[campo].split('T')[0];
            }
            if (Object.keys(nuevo).length === 0) return;
            setPersonaData((anterior) => ({ ...anterior, ...nuevo }));
        } catch (e) {
            /* ver arriba */
        }
    }, [Id, tipo]);

    const [previsualizacionImg, setPrevisualizacionImg] = useState(null);
    const [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);
    const [provinciaId, setProvinciaId] = useState(null);
    const [municipios, setMunicipios] = useState([]);
    const [adjuntosPorCargo, setAdjuntosPorCargo] = useState([]);
    const [avisado, setAvisado] = useState(false);
    const [filasInternos, setFilasInternos] = useState([]);
    const [filasOrganigrama, setFilasOrganigrama] = useState([]);
    // ── Fase 12 · quién ve la pestaña de RRHH ────────────────────────────────────────────
    //
    // POR PERMISO, no por rol: `personas.datos_rrhh.ver` es lo que exige el backend. Gatear aquí
    // por rol y allí por permiso sería tener la regla en dos sitios, y en cuanto se separaran la
    // pestaña aparecería para quien la API rechaza — o al revés, se escondería a quien sí puede.
    //
    // `permisosCargados` evita el parpadeo: mientras no se sepa, no se pinta. Enseñarla y quitarla
    // es peor que tardar un instante en enseñarla.
    //
    // El contexto no viene desestructurado en este fichero —se usa como `persona.persona?.rol`—,
    // así que el permiso se pide igual: `persona.tienePermiso`.
    const tieneP = (clave) => !!persona?.permisosCargados
        && typeof persona?.tienePermiso === 'function'
        && persona.tienePermiso(clave);
    const puedeVerRrhh = tieneP('personas.datos_rrhh.ver');
    // Citas técnicas, por el mismo PERMISO que su endpoint (y que el resumen de campañas). La ficha ya
    // sólo la abren Administración, Super Administración y RRHH; la pestaña exige además esto.
    const puedeVerCitas = tieneP('intervenciones.campanas.view');
    // VER y EDITAR son permisos DISTINTOS: no es lo mismo consultar un IBAN que cambiarlo. Esto
    // sólo decide qué botones se pintan — la barrera está en el servidor, que los exige por
    // separado. Esconder «Guardar» no impide un PUT.
    const puedeEditarRrhh = tieneP('personas.datos_rrhh.editar');
    // Editar titulaciones sigue la regla de EDITAR LA FICHA, no un permiso propio: no es dato
    // confidencial. Los mismos roles que `PUT /editarPersona/:id` (rolesFicha.js).
    const puedeEditarFicha = puedeAbrirFichas(persona.persona?.rol);

    // Fase 24 — se permite aterrizar en Soporte via `?tab=3` desde el link de la ficha; el panel
    // se auto-bloquea, asi que el deep-link no expone nada.
    // Fase 12 — ese `3` se traduce a `soporte`. Los enlaces viejos siguen valiendo y el numero
    // deja de depender de que pestañas vea cada rol.
    const [tabValue, setTabValue] = useState(() => tabDeParametro(tabDesdeURL));

    // ¿Estoy en una pestaña donde no hay nada que guardar? Ver TABS_SOLO_LECTURA.
    //
    // VA AQUÍ, justo detrás de `tabValue`, y no con los demás estados de arriba: escrito antes daba
    // **`Cannot access 'tabValue' before initialization`** y la ficha salía en blanco. Es la segunda
    // vez hoy con el mismo tropiezo — el lint no lo ve, y sólo lo dice la pantalla.
    const soloLectura = TABS_SOLO_LECTURA.includes(tabValue);
    // Hotfix 3/11 · Soporte desbloqueado pero con sus datos perdidos: desde Soporte no se guarda.
    // Bloqueado (sin desbloquear) sí: el Rol vive en esta pestaña, y sus credenciales no se envían.
    // `soporteOk` y `bloqueoSoporte` se calculan más abajo, con el estado ya declarado.
    // El motivo, el de ESTA pestaña: con dos de solo lectura, uno fijo diría lo de Inventario en Citas.
    const MOTIVO_SOLO_LECTURA = {
        [TAB.INVENTARIO]: 'Esta pestaña es de solo lectura: el material se asigna y se devuelve desde Inventario.',
        [TAB.CITAS]: 'Esta pestaña es de solo lectura: las personas se gestionan en los lotes, desde el resumen de la campaña.',
    };
    const tituloBotonGuardar = soloLectura ? MOTIVO_SOLO_LECTURA[tabValue] : undefined;

    // `?tab=citas_tecnicas` sin el permiso: la pestaña no se pinta, y la ficha se quedaría sin
    // ninguna. En cuanto se sabe (permisos cargados), se vuelve a Personal.
    useEffect(() => {
        if (persona?.permisosCargados && tabValue === TAB.CITAS && !puedeVerCitas) setTabValue(TAB.PERSONAL);
    }, [persona?.permisosCargados, tabValue, puedeVerCitas]);

    // Lo mismo con `?tab=3` (Soporte) para un rol que no la tiene —Recursos Humanos abre fichas pero
    // no tiene Soporte—: la pestaña no se pinta y la página quedaba en blanco (3/11). Se decide en
    // cuanto se conoce el rol de la sesión; antes, no (vacío no es «no lo tiene»).
    const rolSesion = persona?.persona?.rol;
    useEffect(() => {
        if (rolSesion && tabValue === TAB.SOPORTE && !puedeVerSoporte(rolSesion)) setTabValue(TAB.PERSONAL);
    }, [rolSesion, tabValue]);

    // Fase 12 · §6.9 — qué pestañas tienen algo escrito y sin guardar.
    //
    // Es un `ref` y no estado a propósito: **un guard que no debe provocar un re-render no es
    // estado, es un ref.** Sólo se lee en el instante de cambiar de pestaña; si fuese estado,
    // cada tecla que se pulsa en RRHH volvería a pintar esta ficha entera, que es enorme.
    //
    // El aviso VISIBLE («Cambios sin guardar») sí es estado, pero dentro de cada pestaña, que es
    // donde se ve y donde cuesta barato.
    const cambiosSinGuardar = useRef({});
    // Identidad estable: si se recreara en cada render, el efecto que la llama desde las
    // pestañas se dispararía sin parar.
    const registrarCambios = useCallback((clave, hay) => {
        cambiosSinGuardar.current[clave] = hay;
    }, []);

    /**
     * Fase 12 · §6.10 — CÓMO GUARDA EL BOTÓN GRANDE LO QUE NO ES SUYO.
     *
     * Las pestañas que no guarda este formulario registran aquí su propia función de guardado, y
     * el botón grande llama a la de la pestaña que se esté viendo.
     *
     * Devuelven `true` si guardaron (o si no había nada que guardar) y `false` si falló. Eso es lo
     * que decide si «Guardar y Salir» sale: **salir tras un guardado fallido perdería lo escrito**,
     * que es exactamente el daño que esta sección existe para evitar.
     *
     * Un `ref` y no estado: registrarse no debe repintar la ficha, y el valor sólo se lee en el
     * instante de pulsar.
     */
    const guardadoDePestana = useRef({});
    const registrarGuardado = useCallback((clave, fn) => {
        if (fn) guardadoDePestana.current[clave] = fn;
        else delete guardadoDePestana.current[clave];
    }, []);


    const [oficinas, setOficinas] = useState([]);
    // Las razones sociales del grupo, para el desplegable de empresa contratante. No son los
    // negocios: un negocio es la marca en la que alguien trabaja, la empresa contratante es con
    // quién tiene contrato, y los datos dicen que no coinciden —34 personas tienen cargo en varias
    // marcas y hay negocios sin razón social propia—.
    const [empresasContratantes, setEmpresasContratantes] = useState([]);
    // Los tipos de contrato vienen del servidor, no de una lista aqui: una sola declaracion.
    const [tiposContrato, setTiposContrato] = useState([]);
    const [calendariosLaborales, setCalendariosLaborales] = useState([]);
    const [calendariosLaboralesColab, setCalendariosLaboralesColab] = useState([]);
    const tipoCalendario = tipo === "colaboradora" ? 'colaborador' : 'interno';
    const [empresasColaboradoras, setEmpresasColaboradoras] = useState([]);
    const [supervisores, setSupervisores] = useState([]);
    // Fase 4 · candidatos del eje COLABORADOR, servidos por el endpoint que reutiliza
    // colabPersonasDe. Estado aparte de `supervisores`, que son personas INTERNAS.
    const [candidatosSupColab, setCandidatosSupColab] = useState([]);
    // Mensaje del rechazo del servidor al guardar (400 SUPERVISION_COLAB_INVALIDA). Fallo
    // RUIDOSO: si el servidor rechaza una relación, la interfaz lo dice; no se descarta en
    // silencio, que es como RRHH acabaría creyendo que asignó un supervisor inexistente.
    const [errorSupColab, setErrorSupColab] = useState(null);
    const [datosCargando, setDatosCargando] = useState(true);
    const [erroresCargos, setErroresCargos] = useState({ internos: [], organigrama: [] });
    const [cargosProcesados, setCargosProcesados] = useState(false);
    const [soporteDesbloqueado, setSoporteDesbloqueado] = useState(false);
    // Hotfix 3/11 · la carrera de `?tab=soporte` (ver soporteFicha.js).
    //   `fichaCargada`: la carga normal de la ficha ya ha llegado; la de Soporte la espera.
    //   `soporteCargado`: los campos que devolvió Soporte EN ESTA APERTURA (null si no ha llegado).
    const [fichaCargada, setFichaCargada] = useState(false);
    const [soporteCargado, setSoporteCargado] = useState(null);
    // Fase A1 · la puerta del segundo factor y su ventana.
    const [puertaAbierta, setPuertaAbierta] = useState(false);
    const ventana2FA = useVentanaSegundoFactor();
    // Hotfix 3/11 · ¿Soporte se cargó bien en esta apertura y sus campos siguen en el estado?
    const soporteOk = soporteCargadoBien({ cargado: soporteCargado, personaData });
    const bloqueoSoporte = tabValue === TAB.SOPORTE && soporteDesbloqueado && !soporteOk;
    const MOTIVO_BLOQUEO_SOPORTE = 'Vuelve a cargar Soporte: sus datos no se han cargado bien en esta apertura de la ficha.';

    //const [setBit]
  
    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null,
        apellidos: null,
        ...(tipo !== "colaboradora" && { dni: null }),
        mail_empresa: null,
        ...(persona.persona?.rol?.toLowerCase() !== 'recursos humanos' && { Rol: null }),
        estado: null,
    });

    const [botonRenderClick, setBotonRenderClick] = useState(false);

    const [mostrarBotonDatosConexionRemota, setMostrarBotonDatosConexionRemota] = useState(false)

    ///////////////////
    const [urlEnlace, setUrlEnlace] = useState("");

    const fechasExpiracionOptions = [
    { label: '1 hora', value: 1 },
    { label: '6 horas', value: 6 },
    { label: '12 horas', value: 12 },
    { label: '1 día', value: 24 }
    ];

    const datosLinkPorDefecto = {
    nombre: "Enlace de visualización de contraseñas",
    text: "",
    notes: ``,
    password: "",
    maxAccessCount: 2,
    horasExpiracion: fechasExpiracionOptions[0].value,
    horasEliminacion: fechasExpiracionOptions[0].value,
    disabled: false,
    hideEmail: false
    };

    const [datosLink, setDatosLink] = useState(datosLinkPorDefecto);

    const handleCreateRecoveryLink = async () => {


        try {
            const now = Date.now();

            const expirationDate = new Date(
                now + (datosLink.horasExpiracion * 60 * 60 * 1000)
            ).toISOString();

            const deletionDate = new Date(
                now +
            ((datosLink.horasExpiracion + datosLink.horasEliminacion) * 60 * 60 * 1000)
            ).toISOString();

            if(!personaData.password_m365 || !datosLink.text || !datosLink.password) {
                toast.error("Para crear el enlace de BitWarden, la persona debe tener una contraseña de M365 y debes completar el campo de texto y contraseña del enlace.");
                return;
            }

            const payload = {
            nombre: datosLink.nombre,
            text: personaData.password_m365 || "sin contraseña",
            notes: datosLink.notes,
            password: datosLink.password,
            maxAccessCount: datosLink.maxAccessCount,
            deletionDate: deletionDate,
            expirationDate: expirationDate,
            disabled: datosLink.disabled,
            hideEmail: datosLink.hideEmail
            };

            const response = await fetchCrearLinkBitWarden(payload);

            setUrlEnlace(response.data.data.accessUrl);

        } catch (error) {
            console.log("Error:", error);
        }
    };
    ///////////////////

    //Copiar Soporte
    const handleMostrardatosSoporte = async (event) =>{
        const textoMostrar = `
                            <div style="text-align:left; margin-left: 20px;">
                                👤 Nombre del usuario: ${personaData.nombre || "-"}<br>
                                📧 Correo electrónico: ${personaData.mail_empresa || "-"}<br>
                                🖥 ID AnyDesk pc: ${personaData.conexion_remota || "-"}<br>
                                🔑 Contraseña AnyDesk: ${personaData.password_anydesk || "-"}<br>
                                🔒 Contraseña administrador: ${personaData.password_admin_equipo || "-"}<br>
                                🔒 Contraseña del usuario: ${personaData.password_usuario_equipo || "-"}
                            </div>
                            `;

        const textoCopiar =
        `🔐 DATOS DE CONEXIÓN REMOTA
        👤 Nombre del usuario: ${personaData.nombre || "-"}
        📧 Correo electrónico: ${personaData.mail_empresa || "-"}
        🖥 ID AnyDesk pc: ${personaData.conexion_remota || "-"}
        🔑 Contraseña AnyDesk: ${personaData.password_anydesk || "-"}
        🔒 Contraseña administrador: ${personaData.password_admin_equipo || "-"}
        🔒 Contraseña del usuario: ${personaData.password_usuario_equipo || "-"}`;


        const resultado = await Swal.fire({
            title: `🔐 DATOS DE CONEXIÓN REMOTA`, 
            html: textoMostrar,
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: 'rgb(0, 182, 39)',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Copiar',
            cancelButtonText: 'Cancelar',
        });

            // SOLO copia si el usuario pulsa "Copiar"
        if (resultado.isConfirmed) {
            await navigator.clipboard.writeText(textoCopiar);

            Swal.fire({
                icon: 'success',
                title: 'Copiado',
                text: 'Los datos se copiaron correctamente'
            });
        }
    }

    const copiarAlPortapapeles = async (texto) => {
        try {      
            await navigator.clipboard.writeText(texto);
            toast.success('Enlace copiado exitosamente');
        } catch (error) {
            toast.error('Error al copiar el enlace');
        }
    };

    // Fase A1 · aterrizar en Soporte con una ventana ya abierta no debe pedir nada. Pasa al
    // volver del perfil tras configurar el 2FA, y al entrar desde el listado con la puerta ya
    // pasada.
    //
    // Hotfix 3/11 · y ESPERA a que haya llegado la carga normal de la ficha (`fichaCargada`): las dos
    // salían a la vez, Soporte solía llegar antes, y la ficha le pasaba por encima.
    useEffect(() => {
        if (fichaCargada && tabValue === TAB.SOPORTE && !soporteDesbloqueado && ventana2FA.activa && Id) {
            cargarDatosSoporte(ventana2FA.ventana);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fichaCargada, tabValue, ventana2FA.activa, Id]);

    // Fase A1 · cuando la ventana se agota, los datos sensibles DEJAN DE ESTAR A LA VISTA.
    //
    // Es la mitad que suele olvidarse: un contador que llega a cero y no hace nada es peor que no
    // tenerlo, porque promete algo que no cumple. Se vacían del estado las seis columnas que la
    // pestaña descifra —no basta con ocultarlas, porque seguirían en memoria— y se vuelve a la
    // pestaña Personal para no dejar a nadie mirando una pantalla vacía sin saber por qué.
    useEffect(() => {
        if (!soporteDesbloqueado || ventana2FA.activa) return;
        setSoporteDesbloqueado(false);
        setSoporteCargado(null);
        setMostrarBotonDatosConexionRemota(false);
        // Todos los campos que llegaron con Soporte (soporteFicha.js), no una lista a mano.
        setPersonaData(prev => ({
            ...prev,
            ...Object.fromEntries(CAMPOS_SOPORTE.map((c) => [c, undefined])),
        }));
        setTabValue(prev => (prev === TAB.SOPORTE ? TAB.PERSONAL : prev));
        toast.info('La verificación ha caducado. Los datos de soporte se han ocultado.');
    }, [ventana2FA.activa, soporteDesbloqueado]);

    // Abrir Soporte ya no pide la contraseña propia, sino el SEGUNDO FACTOR. La puerta es un
    // componente compartido; lo que se hace con la ventana, una vez abierta, es de aquí.
    const cargarDatosSoporte = async (tokenVentana) => {
        try {
            const datos = await fetchDatosSoporte(Id, tokenVentana, tipo === "colaboradora" ? "colaboradora" : null);
            setPersonaData(prev => ({ ...prev, ...datos, password_usuario_equipo: prev.password_usuario_equipo || datos.password_usuario_equipo })); //Si se han desbloqueado los datos de soporte, pero el password_usuario_equipo ha cambiado, se añade al estado para que esté disponible en la pestaña de soporte.
            // Hotfix 3/11 · qué campos trajo Soporte en esta apertura: sin ellos en el estado, no se
            // envían al guardar y no se deja guardar desde Soporte (soporteCargadoBien).
            setSoporteCargado(Object.keys(soporteDe(datos)));
            setSoporteDesbloqueado(true);
            if (datos.tipo === "colaboradora") {
                setMostrarBotonDatosConexionRemota(true);
            }
            setEstadoCampoReque(prev => ({ ...prev, observaciones_soporte: null }));
            // Sólo AHORA se entra en la pestaña, con los datos ya en mano.
            setTabValue(TAB.SOPORTE);
            const p = new URLSearchParams(location.search);
            p.set('tab', TAB.SOPORTE);
            navigate(`${location.pathname}?${p.toString()}`, { replace: true, state: location.state });
            return true;
        } catch (error) {
            toast.error(error?.response?.data?.message || "No se han podido cargar los datos de soporte");
            return false;
        }
    };

    // Fase B · abrir la puerta es ahora una acción PROPIA, no un efecto de cambiar de pestaña.
    //
    // Antes, pulsar SOPORTE lanzaba la puerta y sólo se entraba tras pasarla — así que el panel
    // «Contenido protegido» que hay dentro era inalcanzable salvo llegando por `?tab=3`.
    //
    // Se separa porque **el bloque de segundo factor vive ahora aquí y tiene que verse sin código**:
    // exigir el segundo factor para ver quién tiene segundo factor es circular. Lo que la puerta
    // protege son las credenciales, y ésas siguen exactamente igual de protegidas.
    const abrirPuertaSoporte = async () => {
        // Si YA hay una ventana viva —abierta en el listado o en otra ficha— no se pide nada: la
        // ventana es de quien mira, no de la pantalla.
        if (ventana2FA.activa) { await cargarDatosSoporte(ventana2FA.ventana); return; }
        setPuertaAbierta(true);
    };

    /**
     * Fase 12 · §6.9 — la red de seguridad.
     *
     * El punto 1 (que el botón grande no salga en RRHH ni Formación) no alcanza a quien escribe
     * un IBAN y se va a PERSONAL sin pulsar nada: ahí no hay botón equivocado que pulsar, hay
     * una pestaña que se desmonta y un dato que desaparece.
     *
     * Va ANTES de todo lo demás y devuelve sin tocar nada si se cancela: si se hiciera después de
     * `setTabValue`, la pestaña ya habría cambiado y el aviso llegaría tarde.
     *
     * `window.confirm` y no un diálogo propio, igual que en `RecursoForm`: es una pregunta de una
     * línea, es bloqueante de verdad, y no hay forma de que se pinte «detrás» de nada.
     */
    const hayCambiosAlSalirDe = (desde, hacia) => {
        // 1 · La pestaña que se deja, si lleva su propio guardado (RRHH, Formación, Credenciales).
        if (cambiosSinGuardar.current[desde]) return true;

        // 2 · Y la ficha compartida, SÓLO al salir de su grupo.
        //
        // PERSONAL, EMPRESA, VACACIONES y SOPORTE son el mismo formulario visto por cuatro lados:
        // moverse entre ellas no abandona nada. Avisar ahí convertiría el aviso en ruido, y el
        // ruido se ignora — incluida la vez que sí importaba.
        const saleDelGrupo = TABS_QUE_GUARDA_LA_FICHA.includes(desde)
            && !TABS_QUE_GUARDA_LA_FICHA.includes(hacia);
        return saleDelGrupo && fichaTieneCambios();
    };

    /**
     * El cambio de pestaña, en dos tiempos.
     *
     * `window.confirm` era más agresivo de lo que hace falta: bloquea el navegador entero y no se
     * parece a nada del proyecto. **El aviso es una red de seguridad, no un guardián** — para eso
     * están los botones de abajo.
     *
     * Se usa el `Modal` del sistema, y eso obliga a partir el flujo: se apunta la pestaña
     * pretendida, se pregunta, y sólo si contestan que sí se completa el cambio.
     */
    const [tabPendiente, setTabPendiente] = useState(null);

    /* ── EDITAR LA BAJA DESDE EL BANNER ────────────────────────────────────────────────────
     *
     * `null` = cerrado. Al abrir se copia lo que la baja tiene AHORA, para poder comparar: el
     * aviso de abajo depende de si la fecha cruza la línea de hoy, no de cuál sea.
     */
    const [editBaja, setEditBaja] = useState(null);   // { fecha, motivo, fechaOriginal, guardando }
    const [cancelandoBaja, setCancelandoBaja] = useState(false);

    const puedeEditarBajas = (persona.persona?.rol?.toLowerCase() === 'super administrador')
        || (Array.isArray(persona.permisos) && persona.permisos.includes('bajas.editar'));

    /* `yaLlegada` y `avisoDeFecha` vivían aquí y se han ido con el diálogo a
       `EditarBajaDialog.jsx`, que es quien los usaba. No se dejan por si acaso: una función
       huérfana con un comentario que explica una decisión importante es justo lo que hace que
       alguien la vuelva a usar desde otro sitio y acabe habiendo dos reglas. */

    const handleCambioTab = async (event, newValue) => {
        if (newValue === tabValue) return;
        if (hayCambiosAlSalirDe(tabValue, newValue)) { setTabPendiente(newValue); return; }
        await cambiarDeTab(newValue);
    };

    const cambiarDeTab = async (newValue) => {

        if (newValue === TAB.SOPORTE && !soporteDesbloqueado) {
            // Se ENTRA en la pestaña. Dentro se ve el bloque de acceso y seguridad —que no enseña
            // ningún secreto— y el aviso de que lo demás está bloqueado, con su botón.
            // Si hay ventana viva, el efecto de más arriba desbloquea solo al aterrizar.
            setTabValue(newValue);
            const p = new URLSearchParams(location.search);
            p.set('tab', newValue);
            navigate(`${location.pathname}?${p.toString()}`, { replace: true, state: location.state });
            return;
        }
        if (newValue === TAB.SOPORTE) {
            // Soporte ya desbloqueado: se entra sin volver a pedir nada mientras dure la ventana.
            setEstadoCampoReque(prev => ({
                ...prev,
                observaciones_soporte: null
            }));

            setDatosLink(prevDatosLink => ({
            ...prevDatosLink,
            password: personaData.dni || "",
            notes: `Enlace de visualización para ${personaData.nombre || "persona sin nombre"}. Contiene información sensible, no compartir con nadie.`,
            text: personaData.password_m365 || "Sin contraseña"
            }));

        }else{
            setEstadoCampoReque({
                nombre: null,
                apellidos: null,
                ...(tipo !== "colaboradora" && { dni: null }),
                mail_empresa: null,
                ...(persona.persona?.rol?.toLowerCase() !== 'recursos humanos' && { Rol: null }),
                estado: null,
            });  

            setDatosLink(prevDatosLink => ({
            ...prevDatosLink,
            password: personaData.dni || "",
            notes: `Enlace de visualización para ${personaData.nombre || "persona sin nombre"}. Contiene información sensible, no compartir con nadie.`,
            text: personaData.password_m365 || "Sin contraseña",
            }));
            //setMostrarBotonDatosConexionRemota(false);
        }

        setTabValue(newValue);
        const nuevosParametrosBusqueda = new URLSearchParams(location.search);
        nuevosParametrosBusqueda.set('tab', newValue);
        navigate(`${location.pathname}?${nuevosParametrosBusqueda.toString()}`, { replace: true, state: location.state });
    };

    const [errorEnviarForm, setErrorEnviarForm] = useState({
            personaDuplicada: null
            /*refDuplicado: null*/
    
        });

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        apellidos: "Debes insertar apellidos",
        ...(tipo !== "colaboradora" && { dni: "Debes insertar un DNI" }),
        mail_empresa: "Debes insertar un mail de empresa válido",
        ...(persona.persona?.rol?.toLowerCase() !== 'recursos humanos' && { rol: "Debes seleccionar un rol" }),
        estado: "Debes insertar un estado",

        observaciones_soporte: "Iban que no se te olvide agregar los permisos de los usuarios"
    };

    const provincias = getProvincias();
    
    // Removed obtenerNombresAlternativos, buscarPorCodigoPostal, buscarCodigoPostalPorPoblacion

    const handleChange = (event, value, name) => {

        setFormCompletado(null); // Cuando se hacen cambios los datos no están listos.

            if (name === 'Oficinas') {
                setPersonaData(prevPersonaData => {
                    const nuevasOficinas = value;
                    let nuevaDireccionEnvio = prevPersonaData.direccion_envio;

                    // Si la dirección de envío era de una oficina que ya no está, resetear a personal
                    if (prevPersonaData.direccion_envio?.startsWith('oficina-')) {
                        const oficinaIdActual = parseInt(prevPersonaData.direccion_envio.split('-')[1]);
                        const oficinaExiste = nuevasOficinas.some(o => o.Id === oficinaIdActual);
                        if (!oficinaExiste) {
                            nuevaDireccionEnvio = 'personal';
                        }
                    }

                    return {
                        ...prevPersonaData,
                        Oficinas: nuevasOficinas,
                        direccion_envio: nuevaDireccionEnvio
                    };
                });
                return;
            }

            const { name: inputName, value: inputValue, type, files, checked } = event.target;
            const fieldName = name || inputName;

            let newValue;
            if (type === 'file') {
                newValue = files[0];
            } else if (type === 'checkbox') {
                newValue = checked;
            }
            else if(fieldName === 'telefono_empresa' || fieldName === 'telefono_fijo' || fieldName === 'extension_telefono' && !/^\d*$/.test(inputValue)) {
                newValue = inputValue !== '' ? parseInt(inputValue) : null;
            } 
            else if( event?.target?.name === 'ruskdesk_pc' || event?.target?.name === 'ruskdesk_movil' || event?.target?.name === 'conexion_remota_movil' || event?.target?.name === 'conexion_remota' && !/^\d*$/.test(inputValue)) {
                 newValue = inputValue !== '' ? parseInt(inputValue) : null;
            }
            else if (event?.target?.name === 'bit_locker') {
                // Eliminar todo lo que NO sea número
                const s = inputValue.replace(/\D/g, '');


                // Cada 6 números coloca un - y limita a 48 caracteres (8 grupos de 6 números)
                if (s.length > 0) {
                    const resultado = s.match(/.{1,6}/g)?.join('-');
                    newValue = resultado;
                }
            }
            else {
                newValue = inputValue;
            }
                               
            if (event?.target?.name === 'nombre' || event?.target?.name === 'apellidos' || event?.target?.name === 'dni') {

                const valorNombre = fieldName === 'nombre' ? newValue : personaData.nombre;
                const valorApellidos = fieldName === 'apellidos' ? newValue : personaData.apellidos;
                const valorDni = fieldName === 'dni' ? newValue : personaData.dni;
                const passwordGenerado = `${valorNombre ? valorNombre.trim()[0].toUpperCase() : ''}${valorApellidos ? valorApellidos.trim()[0].toUpperCase() : ''}${valorDni ? valorDni.trim().toUpperCase() : ''}`;

                setPersonaData(prev => ({
                    ...prev,
                    password_usuario_equipo: passwordGenerado
                }));
            }  
            
            // Update logic for address fields
            if (fieldName === 'codigo_postal' && inputValue.length === 5) {
                const address = buscarDireccionPorCP(inputValue);
                if (address) {
                    setPersonaData(prev => ({
                        ...prev,
                        ...address,
                        codigo_postal: inputValue
                    }));
                    setProvinciaId(address.provinciaId);
                } else {
                    setPersonaData(prev => ({ ...prev, [fieldName]: newValue }));
                }
            } else if (fieldName === 'provincia') {
                const provId = buscarProvinciaPorNombre(inputValue);
                setProvinciaId(provId);
                setPersonaData(prev => ({ ...prev, provincia: inputValue, poblacion: '', codigo_postal: '' })); // Clear poblacion and cp
            } else if (fieldName === 'poblacion' && inputValue && personaData.provincia) {
                const cp = buscarCPPorPoblacion(personaData.provincia, inputValue);
                if (cp) {
                    setPersonaData(prev => ({ ...prev, poblacion: inputValue, codigo_postal: cp }));
                } else {
                    setPersonaData(prev => ({ ...prev, [fieldName]: newValue }));
                }
            } else {
                setPersonaData(prevPersonaData => ({ ...prevPersonaData, [fieldName]: newValue }));
            }

            if (type === 'file' && files[0]) {
                const file = files[0];
                const reader = new FileReader();
    
                if (fieldName === 'imagenPersona_img') {
                    reader.onloadend = () => {
                        setPrevisualizacionImg(reader.result);
                    };
                    reader.readAsDataURL(file);
                }
            }
            
            if (fieldName === 'Empresas') {
                const selectedEmpresaIds = Array.isArray(inputValue) ? inputValue : [inputValue];
                setPersonaData(prevPersonaData => ({ 
                    ...prevPersonaData, 
                    [fieldName]: selectedEmpresaIds.map(id => ({ Id: id })) 
                }));
                
                filterDepartamentosEmpresas(selectedEmpresaIds);
            } else if (fieldName === 'Departamentos') {
                const selectedDepartamentoIds = Array.isArray(inputValue) ? inputValue : [inputValue];
                setPersonaData(prevPersonaData => ({ 
                    ...prevPersonaData, 
                    [fieldName]: selectedDepartamentoIds.map(id => ({ Id: id })) 
                }));
            } else if (fieldName === 'calendario_laboral_id') {
                const calendarioSeleccionado = calendariosLaborales.find(c => c.Id.toString() === inputValue);
                if (calendarioSeleccionado) {
                    const diasVacacionesTotales = (calendarioSeleccionado.dias_vacaciones_verano || 0) + (calendarioSeleccionado.dias_vacaciones_normal || 0);
                    const diasVeranoObligatorios = calendarioSeleccionado.dias_vacaciones_verano || 0;
                    setPersonaData(prevPersonaData => ({
                        ...prevPersonaData,
                        calendario_laboral_id: inputValue,
                        dias_vacaciones_totales: diasVacacionesTotales,
                        dias_verano_obligatorios: diasVeranoObligatorios
                    }));
                } else {
                    setPersonaData(prevPersonaData => ({
                        ...prevPersonaData,
                        calendario_laboral_id: inputValue,
                        dias_vacaciones_totales: 0,
                        dias_verano_obligatorios: 0
                    }));
                }
            } else if (fieldName === 'calendario_laboral_colab_id') {
                const calendarioSeleccionado = calendariosLaboralesColab.find(c => c.Id.toString() === inputValue);
                if (calendarioSeleccionado) {
                    const diasVacacionesTotales = (calendarioSeleccionado.dias_vacaciones_verano || 0) + (calendarioSeleccionado.dias_vacaciones_normal || 0);
                    const diasVeranoObligatorios = calendarioSeleccionado.dias_vacaciones_verano || 0;
                    setPersonaData(prevPersonaData => ({
                        ...prevPersonaData,
                        calendario_laboral_colab_id: inputValue,
                        dias_vacaciones_totales: diasVacacionesTotales,
                        dias_verano_obligatorios: diasVeranoObligatorios
                    }));
                } else {
                    setPersonaData(prevPersonaData => ({
                        ...prevPersonaData,
                        calendario_laboral_colab_id: inputValue,
                        dias_vacaciones_totales: 0,
                        dias_verano_obligatorios: 0
                    }));
                }
            }
            else if (fieldName === 'Rol') {
                setPersonaData(prevPersonaData => ({
                    ...prevPersonaData,
                    [fieldName]: { Id: inputValue },
                    rol_id: inputValue
                }));
            }
            else if (fieldName === 'Estado') {
                setPersonaData(prevPersonaData => ({ 
                    ...prevPersonaData, 
                    [fieldName]: { Id: inputValue },
                    estado: inputValue
                }));
            } 
            else {
                setPersonaData(prevPersonaData => ({ ...prevPersonaData, [fieldName]: newValue }));
            }
            
            if (fieldName in estadoCampoReque) {
                handleChangeErrors(fieldName, inputValue, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
            }
    
        };

    // ── Fase 11 §2.bis · intercepción del desplegable de estado ─────────────────────────
    // El id de "Baja" se busca POR NOMBRE en el catálogo, no se escribe un 1 a mano: el número es
    // un dato de la tabla `estados` y no del código.
    const idEstadoBaja = (() => {
        const e = (estados || []).find(x => (x.nombre || '').trim().toLowerCase() === 'baja');
        return e ? String(e.Id) : null;
    })();

    // Igual que el de «Baja»: POR NOMBRE y no escribiendo un 2. El número es un dato de la tabla
    // `estados`, y en otro entorno podría no coincidir.
    const idEstadoEnProceso = (() => {
        const e = (estados || []).find(x => (x.nombre || '').trim().toLowerCase() === 'en proceso');
        return e ? String(e.Id) : null;
    })();

    const ambitoBaja = tipo === 'colaboradora' ? 'colaborador' : 'interno';
    const nombreCompleto = `${personaData.nombre || ''} ${personaData.apellidos || ''}`.trim();

    // El proceso de salida abierto, consultado AL CARGAR la ficha.
    //
    // Va aquí y no arriba porque usa `ambitoBaja`, que se declara unas líneas antes: ponerlo antes
    // daría un ReferenceError en el render, no al ejecutar el efecto — el array de dependencias se
    // evalúa durante el render.
    //
    // Y es best-effort a propósito: si la consulta falla, la ficha se abre igual SIN el banner. Un
    // banner es un aviso; que su fallo impidiera ver la ficha sería peor que no tenerlo.
    /* ── LAS ALTAS DE ESTA PERSONA ──────────────────────────────────────────────────────
     *
     * Una peticion para las dos cosas: el banner de la cabecera y la tabla de procesos de la
     * pestaña Empresa. Miran lo mismo desde sitios distintos, y pedirlo dos veces daria la
     * posibilidad de que discrepen.
     *
     * `null` y `[]` NO son lo mismo, y aqui importa:
     *   null -> todavia no se sabe, o no hay permiso para verlo
     *   []   -> se preguntó y esta persona no tiene ninguna. Nacio a mano, y eso es informacion
     *
     * Best-effort como el de la baja: si falla, la ficha se abre igual. `sinPermiso` distingue el
     * 403 del resto para que la tabla pueda decir «no tienes acceso» en vez de «no hay procesos».
     */
    const [altas, setAltas] = useState(null);
    /* ¿El aviso del alta o de la baja que la ficha YA enseña es el proceso del que vienes? Entonces
     * no se pinta un segundo aviso que lleve al mismo sitio: su botón pasa a ser «Volver al
     * proceso» y vuelve como las demás salidas. El aviso azul de «Has venido desde…» queda sólo
     * para cuando no hay aviso de ese proceso (un alta o una baja ya cerradas, por ejemplo). Se vio
     * en TEST el 14/10: dos avisos, dos botones, un mismo destino. */
    const volverEsElAlta = !!(volver && altas && altas.abierta && volver === rutaAlta(altas.abierta.id));
    const volverEsLaBaja = !!(volver && bajaAbierta && volver === rutaBaja(bajaAbierta.id));
    const [altasSinPermiso, setAltasSinPermiso] = useState(false);
    const [editAlta, setEditAlta] = useState(null);   // el alta cuya fecha se está editando
    const [editManual, setEditManual] = useState(null);   // { tipo, fecha } de la fila MANUAL
    useEffect(() => {
        if (!Id) return undefined;
        let vivo = true;
        altasDePersona(ambitoBaja, Id)
            .then((d) => { if (vivo) { setAltas(d); setAltasSinPermiso(false); } })
            .catch((e) => {
                if (!vivo) return;
                setAltas(null);
                setAltasSinPermiso(e?.response?.status === 403);
            });
        return () => { vivo = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Id, ambitoBaja]);

    useEffect(() => {
        if (!Id) return undefined;
        let vivo = true;
        bajaAbiertaDePersona(ambitoBaja, Id)
            .then((g) => { if (vivo) setBajaAbierta(g && g.tiene_baja_abierta ? g.baja : null); })
            .catch(() => { if (vivo) setBajaAbierta(null); });
        return () => { vivo = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Id, ambitoBaja]);

    /* ── «EN PROCESO» NO SE OFRECE AQUI ─────────────────────────────────────────────────
     *
     * Ese estado lo escribe el ALTA, igual que «Baja» lo escribe el proceso de salida —que este
     * mismo desplegable ya intercepta—. La ficha no abre procesos.
     *
     * El motivo no es de estilo: a una persona en «En proceso» SIN alta no la activa nadie nunca.
     * El cron recorre `incorp_altas` y sin alta no hay fecha que mirar. Si nadie puede saber
     * cuando activarla, nadie deberia poder ponerla ahi.
     *
     * PERO SI YA ESTA EN ESE ESTADO, SE MUESTRA. Un `Form.Select` cuyo `value` no casa con ninguna
     * opcion se pinta VACIO, y guardar escribiria ''. Y ademas hay que poder SALIR de «En
     * proceso» a mano cuando el alta se cancelo: quitar la opcion sin esta salvedad dejaria a esa
     * persona atrapada.
     *
     * Y esto es comodidad, no la defensa: el servidor rechaza la transicion aunque llegue en la
     * peticion. Esconder una opcion no es prohibirla.
     */
    /* Ni «En proceso» ni «Baja» se eligen a mano: las escribe su proceso.
     *
     * Con la MISMA excepción para las dos — se muestran si son el valor ACTUAL —, y por dos
     * razones: un `Form.Select` cuyo `value` no casa con ninguna opción se pinta VACÍO y guardar
     * escribiría '', y hay que poder SALIR de ese estado. Quitar la opción sin la salvedad dejaría
     * a esa persona atrapada.
     *
     * Quitar «Baja» como DESTINO no cierra la salida: salir hacia «Alta» es otro movimiento y sus
     * opciones siguen ahí. Lo que decide si se puede salir es el servidor, que lo rechaza sólo si
     * la baja sigue abierta — entonces el camino es cancelarla.
     *
     * Y esto es comodidad, no la defensa: hasta hoy el desplegable interceptaba «Baja» y el
     * servidor la aceptaba si llegaba igual. Ahora también la rechaza. */
    /* Y «ALTA» TAMPOCO, MIENTRAS SU FECHA NO HAYA LLEGADO.
     *
     * Ponerla afirma un hecho que no ha ocurrido, y como el estado deriva el acceso, esa persona
     * entraria en la intranet antes de su primer dia. El servidor lo rechaza —ALTA_ANTES_DE_SU_FECHA—
     * y esto es SOLO comodidad: que nadie llegue a un rechazo evitable.
     *
     * La defensa no es esta linea. **Esconder una opcion del selector no es prohibirla**, y aqui
     * mismo esta escrito lo que paso la otra vez: hasta Fase 11 el desplegable interceptaba «Baja»
     * y el servidor la aceptaba si llegaba igual.
     *
     * Se compara la fecha como TEXTO `AAAA-MM-DD`, no con `new Date()`: construir una fecha de una
     * cadena suelta la interpreta en UTC y a partir de las 22:00 en Espana cae en el dia anterior
     * —el ultimo dia antes de incorporarse diria que ya llego—. */
    const hoyISO = React.useMemo(() => {
        const d = new Date();
        const dos = (x) => String(x).padStart(2, '0');
        return `${d.getFullYear()}-${dos(d.getMonth() + 1)}-${dos(d.getDate())}`;
    }, []);
    const altaTodaviaNoLlega = React.useMemo(() => {
        const f = personaData.fecha_alta ? String(personaData.fecha_alta).slice(0, 10) : null;
        return !!f && f > hoyISO;
    }, [personaData.fecha_alta, hoyISO]);

    const estadosElegibles = React.useMemo(() => (estados || []).filter((e) => {
        const n = (e.nombre || '').trim().toLowerCase();
        const loEscribeUnProceso = n === 'en proceso' || n === 'baja';
        const altaAntesDeTiempo = n === 'alta' && altaTodaviaNoLlega;
        // Si YA es su valor actual se deja: quitarlo dejaria el desplegable sin poder ensenar en
        // que estado esta, que es peor que ofrecer una opcion que el servidor va a rechazar.
        return !(loEscribeUnProceso || altaAntesDeTiempo) || String(e.Id) === String(personaData.estado);
    }), [estados, personaData.estado, altaTodaviaNoLlega]);

    const handleChangeEstado = (event) => {
        const nuevo = String(event.target.value || '');
        const esBaja = idEstadoBaja != null && nuevo === idEstadoBaja;
        const eraBaja = idEstadoBaja != null && estadoOriginal === idEstadoBaja;

        /* La intercepción de «Baja» se fue con la opción.
         *
         * Era un apaño de Fase 11: el desplegable ofrecía «Baja» y, al elegirla, en vez de
         * aplicarla abría el diálogo. Ahora la opción no está —salvo si ya es su valor— y el
         * botón vive donde viven los procesos, en la cabecera de su tabla.
         *
         * Se deja el guard por si la opción llegara por cualquier vía: cuesta dos líneas y evita
         * que un cambio futuro reabra el agujero en silencio. El servidor lo rechaza igualmente. */
        if (esBaja && !eraBaja) {
            setDlgBaja({ ambito: ambitoBaja, id: Id, nombre: nombreCompleto });
            return;
        }

        // EL CAMBIO SE APLICA PRIMERO, Y DE FORMA SÍNCRONA.
        //
        // Esta función NO puede ser `async` con el `handleChange` al final: `Form.Select` es un
        // componente CONTROLADO por `personaData.estado`, así que en cuanto se cede el turno en un
        // `await`, React vuelve a pintar el desplegable con el valor VIEJO. Al resolverse la
        // promesa, `event.target.value` ya no es lo que el usuario eligió, sino el valor
        // revertido — y el cambio se perdía en silencio, con el aviso en pantalla dando a
        // entender lo contrario.
        handleChange(event);

        // DESDE Baja hacia otro estado: se AVISA si hay proceso abierto. Va después, sin `await`,
        // porque es informativo y no condiciona nada. No se cancela nada: ver AvisoRevertirBaja.
        if (!esBaja && eraBaja) {
            bajaAbiertaDePersona(ambitoBaja, Id)
                .then((g) => { if (g && g.tiene_baja_abierta) setAvisoRevertir(g.baja); })
                // Que falle la consulta no puede impedir editar la ficha: el aviso es informativo.
                .catch((e) => console.error('[ficha][baja] comprobar baja abierta', e));
        }
    };

    const filterDepartamentosEmpresas = (empresaIds) => {
        const filteredDepts = departamentos.filter(departamento => {
            return departamento.Negocios && departamento.Negocios.some(negocio => 
                empresaIds.includes(negocio.Id.toString())
            );
        });

        setFilasInternos(prevFilas => prevFilas.map(fila => {
            let newFila = {...fila};
            
            if (newFila.empresa) {
                const deptosForEmpresa = filteredDepts.filter(dept => 
                    dept.Negocios.some(emp => emp.Id.toString() === newFila.empresa)
                );
                
                const isDeptValid = deptosForEmpresa.some(dept => 
                    dept.Id.toString() === newFila.departamento
                );
                
                if (!isDeptValid) {
                    newFila.departamento = '';
                }
            }
            
            return newFila;
        }));
        
        setFilasOrganigrama(prevFilas => prevFilas.map(fila => {
            let newFila = {...fila};
            
            if (newFila.empresa) {
                const deptosForEmpresa = filteredDepts.filter(dept => 
                    dept.Negocios.some(emp => emp.Id.toString() === newFila.empresa)
                );
                
                const isDeptValid = deptosForEmpresa.some(dept => 
                    dept.Id.toString() === newFila.departamento
                );
                
                if (!isDeptValid) {
                    newFila.departamento = '';
                }
            }
            
            return newFila;
        }));
    };

    const handleDelete = () => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        document.getElementById("imagenPersona_img").value = "";
        delete personaData.imagenPersona;
        setPersonaData(prevData => ({ ...prevData, foto: null, imagen_base64: null }));
    };

    // ── Fase 4 · supervisión colaboradora · los dos puntos compartidos por las DOS rutas ──
    //
    // Este componente guarda por DOS caminos: `handleSubmit` (validación síncrona) y el
    // useEffect gobernado por `estadosActualizados` (validación que pasa por el estado).
    // Ninguno ramifica por `tipo`, así que CUALQUIERA puede ser el que guarde una ficha de
    // colaboradora. Poner el código en uno solo daría un guardado que descarta los
    // supervisores DE FORMA INTERMITENTE, según por dónde entrase el flujo.
    //
    // Se extraen a funciones locales en vez de duplicarse: si mañana aparece una tercera
    // ruta de guardado, el helper ya existe para que la llame. Ésa es la mitad del valor de
    // extraerlo; la otra es que la regla vive en UN sitio.

    // LA CONDICIÓN `tipo === "colaboradora"` VIVE AQUÍ DENTRO, no en los puntos de llamada.
    // Deliberado: duplicar el `if` en dos sitios reintroduce exactamente la divergencia que
    // esta extracción elimina, y alguien que añadiera una tercera ruta podría olvidarlo. La
    // ficha interna NO debe mandar este campo: si lo mandara vacío, el servidor lo leería
    // como "quítalos todos".
    const aplicarSupervisoresColabAlPayload = (payload) => {
        if (tipo !== "colaboradora") return payload;
        payload.supervisores_colab = (personaData.supervisores_colab || [])
            .filter(f => f.id)                                   // filas a medio rellenar no viajan
            .map(f => ({ id: Number(f.id), nivel: f.nivel || 'gestionar' }));
        return payload;
    };

    /**
     * Fase 12 · §6.9 — la confirmación de que la ficha se guardó.
     *
     * Extraída, y no escrita dos veces, por la misma razón que los helpers de supervisión de
     * arriba: **este formulario guarda por dos rutas**, y una confirmación puesta en una sola
     * aparecería o no según por dónde hubiera entrado el flujo.
     *
     * Dice qué se ha guardado, no sólo que algo se guardó: en una pantalla donde conviven
     * pestañas con guardado propio, «Guardado correctamente» a secas volvería a ser ambiguo.
     */
    const avisarFichaGuardada = () => {
        // Lo guardado pasa a ser la referencia: seguir avisando de cambios que ya están en la base
        // es la otra forma de que el aviso deje de significar nada.
        renovarInstantaneaFicha();
        toast.success(tipo === "colaboradora"
            ? 'Ficha de la colaboradora guardada.'
            : 'Ficha de la persona guardada.');
    };

    // FALLO RUIDOSO: si el servidor rechaza una relación, se dice cuál y por qué. Descartarlo
    // en silencio es como RRHH acabaría creyendo que asignó un supervisor que no existe.
    // Devuelve true si ha atendido el error, para que un llamante futuro pueda ramificar.
    const manejarErrorSupervisionColab = (error) => {
        if (error?.response?.data?.error !== 'SUPERVISION_COLAB_INVALIDA') return false;
        const d = error.response.data;
        const ids = (d.rechazadas || []).map(r => `#${r.id} (${r.motivo})`).join(', ');
        setErrorSupColab(`${d.message}: ${ids}. ${d.detalle || ''}`);
        return true;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Hotfix 3/11 · el botón ya va desactivado, pero el formulario también se envía con Intro.
        if (bloqueoSoporte) {
            toast.error(MOTIVO_BLOQUEO_SOPORTE);
            return;
        }

        /* ── Fase 12 · §6.10 — el botón grande guarda LO DE LA PESTAÑA QUE SE ESTÁ VIENDO ──
         *
         * El fallo original nunca fue que el botón estuviera: era que **guardaba a medias y sin
         * decirlo**. Esconderlo quitaba la mentira quitando la función; esto la quita cumpliendo
         * lo que el botón siempre prometió.
         *
         * Y los tres botones vuelven a las seis pestañas: **la coherencia de la pantalla pesa más
         * que la pureza del mecanismo.** Que en cuatro haya tres botones y en dos ninguno obliga a
         * mirar dónde está cada cosa cada vez.
         *
         * Aquí se bifurca por DÓNDE vive el dato, no por qué botón se pulsó:
         *   PERSONAL, EMPRESA, VACACIONES, SOPORTE → `personas`, el PUT de siempre (sigue abajo)
         *   RRHH                                   → `PUT  /personas/:id/datos-rrhh`
         *   FORMACION                              → `POST /personas/:id/titulaciones`
         */
        // El mismo criterio que `botonRenderClick`, para que los dos botones no puedan discrepar:
        // «Guardar» lleva `name`, «Guardar y Salir» no.
        const saleAlTerminar = event.target.name !== "guardar_cambios_statico";

        if (!TABS_QUE_GUARDA_LA_FICHA.includes(tabValue)) {
            const guardarLaPestana = guardadoDePestana.current[tabValue];
            // Sin función registrada no hay nada que hacer, y desde luego no se envía el
            // formulario de la ficha: **esconder un botón no es prohibirlo**, y el `<form>` sigue
            // ahí para un Intro en un campo de texto. La misma regla que el selector de la
            // exportación, que limita el ratón y no la petición.
            if (!guardarLaPestana) return;

            const guardado = await guardarLaPestana();
            // Sólo se sale si guardó. Salir tras un error se llevaría por delante lo escrito, y el
            // aviso del fallo lo da la propia pestaña, que sabe cuál fue.
            if (guardado && saleAlTerminar) {
                if (volver) salirAlProceso();
                else navigate(`/gestionpersonas/personas${location.search}`);
            }
            return;
        }

        if (tabValue === TAB.SOPORTE) {
            if(personaData.bit_locker && personaData.bit_locker.length !== 55){
                toast.error('El número de serie del BitLocker debe tener el formato correcto (000000-000000-000000-000000-000000-000000-000000-000000) con 48 dígitos en total.');
                return;
            }
        }   

        if(event.target.name === "guardar_cambios_statico"){
            setBotonRenderClick(false);
        }else{         
            setBotonRenderClick(true);
        }
        
        setAvisado(false);
        setEstadosActualizados(false);

        const erroresInternosIdx = [];
        const erroresOrganigramaIdx = [];

        if (tipo !== "colaboradora") {
            filasInternos.forEach((fila, index) => {
                if (!fila.empresa) return;
                if (!fila.departamento || !fila.cargo) {
                    erroresInternosIdx.push(index);
                }
            });

            filasOrganigrama.forEach((fila, index) => {
                if (!fila.empresa) return;
                if (!fila.departamento || !fila.cargo) {
                    erroresOrganigramaIdx.push(index);
                }
            });
        }
        
        if (erroresInternosIdx.length > 0 || erroresOrganigramaIdx.length > 0) {
            setErroresCargos({ internos: erroresInternosIdx, organigrama: erroresOrganigramaIdx });
            toast.error('Por favor, complete los campos obligatorios de los cargos. Las empresas no colaboradoras requieren departamento y cargo.');
            return;
        }
        
        setErroresCargos({ internos: [], organigrama: [] });

        const esColab = tipo === "colaboradora";
        const cargosFormateados = [
            ...filasInternos
                .filter(fila => fila.empresa)
                .map(fila => ({
                    empresa_id: esColab ? null : fila.empresa,
                    empresa_colaboradores_id: esColab ? fila.empresa : null,
                    departamento_id: esColab ? null : fila.departamento,
                    cargo: esColab ? null : fila.cargo
                })),
            ...filasOrganigrama
                .filter(fila => fila.empresa)
                .map(fila => ({
                    empresa_id: esColab ? null : fila.empresa,
                    empresa_colaboradores_id: esColab ? fila.empresa : null,
                    departamento_id: esColab ? null : fila.departamento,
                    cargo: esColab ? null : fila.cargo,
                    responsable: fila.responsable,
                    adjunto: fila.adjunto
                }))
        ];

        const personaDataToSubmit = {
            ...personaData,
            Cargos: cargosFormateados,
            ...(esColab && {
                empresa_colaboradora_id: filasInternos.find(f => f.empresa)?.empresa ? parseInt(filasInternos.find(f => f.empresa).empresa) : null
            })
        };
        setPersonaData(personaDataToSubmit);

        handleSubmitErrorsPersonas(personaDataToSubmit, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
        
        let validacionTodosDatos = todosDatosCorrectos(personaDataToSubmit, estadoCampoReque);
        let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
        
        if (todosCamposFalse) {
            try {
                // Hotfix 3/11 · los campos de Soporte sólo viajan si Soporte se cargó bien EN ESTA
                // APERTURA y siguen en el estado (soporteFicha.js). Antes bastaba con «desbloqueado»,
                // y la carrera de `?tab=soporte` dejaba desbloqueado con los campos perdidos. La lista
                // son los doce de Soporte: la de antes no tenía bit_locker ni ruskdesk.
                let personaDataConHash = quitarSoporteSiNoCargado(personaDataToSubmit, soporteOk);

                if(personaDataConHash.fecha_nacimiento == '' || personaDataConHash.fecha_nacimiento == null ||personaDataConHash.fecha_nacimiento == undefined)
                                personaDataConHash.fecha_nacimiento = null;

                            if(personaDataConHash.fecha_alta == '' || personaDataConHash.fecha_alta == null || personaDataConHash.fecha_alta == undefined)
                                personaDataConHash.fecha_alta = null;

                            if(personaDataConHash.dni_fecha_caducidad == '' || personaDataConHash.dni_fecha_caducidad == null || personaDataConHash.dni_fecha_caducidad == undefined)
                                personaDataConHash.dni_fecha_caducidad = null;

                            if (personaDataConHash.Oficinas && Array.isArray(personaDataConHash.Oficinas)) {
                                personaDataConHash.Oficinas = personaDataConHash.Oficinas.map(oficina => oficina.Id);
                            }

                            // Fase 4 · el estado deseado COMPLETO del eje colaborador. La condición
                            // por tipo vive dentro del helper, para que no haya dos sitios donde
                            // olvidarla.
                            aplicarSupervisoresColabAlPayload(personaDataConHash);

                            const response = tipo === "colaboradora" ? await fetchEditarPersonaColaboradora(personaDataConHash) : await fetchEditarPersona(personaDataConHash);
                            setFormCompletado(true);
                            // Fase 12 · §6.9 — decir que se guardó, y decirlo DESPUÉS del 200.
                            // Antes sólo salía el modal de «Espere mientras se envían sus datos»,
                            // que aparece por haber pulsado, no por haber guardado: se ve igual
                            // cuando la petición falla. Un aviso que sale pase lo que pase no
                            // informa de nada, y aquí enseñó a dar por bueno un guardado que no
                            // había ocurrido.
                            avisarFichaGuardada();
                            // Los cuatro campos que el servidor recalcula al guardar. Sin esto la
                            // ficha se queda contradiciéndose: ver `fundirCalculados`.
                            fundirCalculados(setPersonaData, response);
                        } catch (error) {
                            console.error("Error al editar persona:", error);

                            if (error?.response?.data?.error === 'REGISTRO_DUPLICADO') {
                                setErrorEnviarForm(prevFormData => ({ ...prevFormData, personaDuplicada: true }));
                            }
                            // Fase 4 · fallo ruidoso del rechazo de supervisión (ver el helper).
                            manejarErrorSupervisionColab(error);
                            setFormCompletado(false);
                        } finally {
                            setEstadosActualizados(false);
                        }
                    } 
                 };

     useEffect(() => {
        const nuevosMunicipios = getMunicipios(provinciaId);
        setMunicipios(nuevosMunicipios);
    }, [provinciaId]);

    useEffect(() => {
        const cargarOficinas = async () => {
            try {
                const data = await fetchOficinasData();
                const oficinasOrdenadas = data.sort((a, b) => a.nombre.localeCompare(b.nombre));
                setOficinas(oficinasOrdenadas);
            } catch (error) {
                console.error('Error al cargar oficinas:', error);
            }
        };
        cargarOficinas();
    }, []);

    useEffect(() => {
        // Sin condicion de rol: el campo se enseña en las dos fichas y a todos los que editan.
        // Es un catalogo fijo, no dice nada de nadie.
        fetchTiposContrato().then(setTiposContrato).catch(() => setTiposContrato([]));
    }, []);

    useEffect(() => {
        const cargarEmpresasContratantes = async () => {
            try {
                const data = await fetchEmpresasData();
                setEmpresasContratantes((data || []).slice().sort((a, b) =>
                    (a.razon_social || '').localeCompare(b.razon_social || '')));
            } catch (error) {
                console.error('Error al cargar empresas contratantes:', error);
            }
        };
        // Sólo quien puede verla: pedir la lista a los demás sería una llamada que no lleva a
        // ninguna parte, y el servidor tampoco les manda el campo de la persona.
        if (ROLES_CON_EMPRESA_CONTRATANTE.includes(persona.persona?.rol?.toLowerCase())) {
            cargarEmpresasContratantes();
        }
    }, [persona.persona?.rol]);

    useEffect(() => {
        const cargarCalendariosLaborales = async () => {
            try {
                if (tipo === "colaboradora") {
                    const data = await fetchCalendariosLaboralesColab();
                    setCalendariosLaboralesColab(data || []);
                } else {
                    const data = await fetchCalendariosLaborales();
                    setCalendariosLaborales(data || []);
                }
            } catch (error) {
                console.error('Error al cargar calendarios laborales:', error);
            }
        };
        cargarCalendariosLaborales();
    }, [tipo]);

    useEffect(() => {
        const cargarEmpresasColaboradoras = async () => {
            try {
                const data = await fetchEmpresasColaboradorasData();
                setEmpresasColaboradoras(data || []);
            } catch (error) {
                console.error('Error al cargar empresas colaboradoras:', error);
            }
        };
        cargarEmpresasColaboradoras();
    }, []);

    useEffect(() => {
        const cargarSupervisores = async () => {
            try {
                const data = await fetchPersonasData();
                const personasOrdenadas = (data || []).sort((a, b) =>
                    `${a.nombre} ${a.apellidos}`.localeCompare(`${b.nombre} ${b.apellidos}`)
                );
                setSupervisores(personasOrdenadas);
            } catch (error) {
                console.error('Error al cargar supervisores:', error);
            }
        };
        cargarSupervisores();
    }, []);

    // Fase 4 · candidatos del eje COLABORADOR. Efecto aparte del de arriba —que carga personas
    // internas para el Autocomplete de la ficha interna— porque son dos poblaciones distintas y
    // este solo tiene sentido para una colaboradora ya existente: el endpoint filtra por SU
    // empresa, así que necesita el Id.
    useEffect(() => {
        if (tipo !== "colaboradora" || !Id) return;
        let cancelado = false;
        const cargar = async () => {
            try {
                const data = await fetchCandidatosSupervisorColab(Id);
                if (!cancelado) setCandidatosSupColab(data || []);
            } catch (error) {
                console.error('Error al cargar candidatos a supervisor colaborador:', error);
            }
        };
        cargar();
        return () => { cancelado = true; };
    }, [tipo, Id]);

    const [cargosRaw, setCargosRaw] = useState([]);

    /* ── Fase 13 · aquí abajo, y no junto a los demás refs, POR UNA RAZÓN ──────────────────
     *
     * Este bloque usa `datosCargando`, `cargosProcesados` y `cargosRaw`, y `cargosRaw` se declara
     * justo encima. Escrito más arriba daba **`Cannot access 'datosCargando' before
     * initialization`** y la ficha salía EN BLANCO.
     *
     * El lint no lo vio —0 errores— y el arnés dijo «no encuentro el campo del teléfono», que
     * parece un problema de la diana. **Lo estaba diciendo la pantalla**, en un `pageerror` que
     * ningún arnés estaba escuchando.
     */
    /**
     * Fase 13 · LOS CAMBIOS SIN GUARDAR DE LA PROPIA FICHA.
     *
     * ── EL FALLO QUE ESTO ARREGLA, QUE ES DE LA FASE ANTERIOR ─────────────────────────────
     *
     * La Fase 12 arregló que «Guardar» abandonara en silencio lo escrito en RRHH y Formación.
     * Y dejó el mismo fallo **del revés**: se escribe en PERSONAL, se cambia a FORMACIÓN, se
     * pulsa Guardar… y lo de Personal se pierde sin que nada lo diga.
     *
     * Medido: **no salía ni una petición**, porque en Formación no había formulario abierto. El
     * botón no hizo nada y no lo dijo — el mismo patrón otra vez.
     *
     * La causa: `cambiosSinGuardar` sólo lo alimentaban las dos pestañas nuevas. Las cuatro
     * viejas comparten `personaData` y no registraban nada.
     *
     * ── Y POR QUÉ NO BASTA CON UNA BANDERA POR PESTAÑA ───────────────────────────────────
     *
     * **Las cuatro viejas comparten el mismo `personaData`.** Cambiar de PERSONAL a EMPRESA no
     * abandona nada: es el mismo formulario visto por otro lado. Avisar ahí sería un aviso que
     * salta constantemente — y un aviso que salta siempre se aprende a ignorar, con lo que deja
     * de proteger justo el caso que importa.
     *
     * Así que la bandera es **del grupo**, no de la pestaña, y sólo se mira al SALIR del grupo.
     */
    const instantaneaFicha = useRef(null);
    // La instantánea se toma cuando los datos han ASENTADO, no al montar: los cargos se procesan
    // en un efecto aparte y `personaData` sigue cambiando después de la primera pintada. Es la
    // misma condición con la que el propio botón de guardar se habilita, para no tener dos
    // definiciones de «ya está cargado».
    const fichaAsentada = !datosCargando && (cargosRaw.length === 0 || cargosProcesados);
    useEffect(() => {
        if (!fichaAsentada || instantaneaFicha.current !== null) return;
        instantaneaFicha.current = JSON.stringify(personaData);
    }, [fichaAsentada, personaData]);

    // Se calcula AL PREGUNTAR, no en cada render: sólo hace falta en el instante de cambiar de
    // pestaña, y comparar el objeto entero con cada tecla sería caro en una ficha de este tamaño.
    /**
     * ¿Hay algo escrito y sin guardar en el formulario compartido de la ficha?
     *
     * ── DOS COSAS QUE NO SON CAMBIOS, Y LO PARECÍAN ───────────────────────────────────────
     *
     * La primera versión comparaba `personaData` entera contra la instantánea, y avisaba **sin que
     * nadie hubiera escrito nada**. Medido, con los campos delante:
     *
     *   · al entrar en SOPORTE — `cargarDatosSoporte` AÑADE diez claves (`usuario_nas`,
     *     `password_nas`, `observaciones_soporte`…) que la ficha no traía.
     *   · a veces al arrancar — `Departamentos` llega en una carga asíncrona posterior. Salía de
     *     forma intermitente, según qué respuesta ganara la carrera.
     *
     * Las dos son **cargas**, no ediciones. Y la regla que las distingue sin tocar los 44 sitios
     * que escriben en `personaData` es ésta:
     *
     * > **Un formulario no puede inventar campos.** Una clave que aparece después de la
     * > instantánea la trajo una petición, no una persona escribiendo.
     *
     * Así que lo que aparece **se absorbe** en la referencia, y lo que se compara son sólo las
     * claves que ya estaban. Y un valor que pasa a `undefined` tampoco es una edición: es el
     * borrado de los datos de Soporte al caducar la ventana — nadie teclea `undefined`.
     *
     * El precio de absorber: si Soporte añade `usuario_nas` y DESPUÉS alguien lo edita, ya está en
     * la referencia y el cambio se ve. No se pierde ninguna edición real.
     */
    const fichaTieneCambios = () => {
        if (instantaneaFicha.current === null) return false;
        let antes;
        try { antes = JSON.parse(instantaneaFicha.current); } catch (e) { return false; }

        // 1 · lo que APARECIÓ después: se absorbe, no es de nadie.
        const aparecidas = Object.keys(personaData).filter((k) => !(k in antes));
        // 2 · lo que se BORRÓ programáticamente (pasa a `undefined`): tampoco.
        const borradas = Object.keys(antes).filter((k) => personaData[k] === undefined && antes[k] !== undefined);
        if (aparecidas.length || borradas.length) {
            [...aparecidas, ...borradas].forEach((k) => { antes[k] = personaData[k]; });
            instantaneaFicha.current = JSON.stringify(antes);
        }

        const cambiadas = Object.keys(antes)
            .filter((k) => JSON.stringify(antes[k]) !== JSON.stringify(personaData[k]));
        if (!cambiadas.length) return false;

        // QUÉ campos, sólo sus NOMBRES. Nunca los valores: por aquí pasan `password_nas` y
        // `password_m365`, y una contraseña no va en un registro ni en desarrollo.
        console.debug('[ficha] cambios sin guardar en:', cambiadas.join(', '));
        return true;
    };

    // Tras guardar, lo guardado pasa a ser la referencia. Si no, seguiría avisando de unos cambios
    // que ya están en la base.
    const renovarInstantaneaFicha = () => { instantaneaFicha.current = JSON.stringify(personaData); };

    useEffect(() => {
        let cancelado = false;
        const fetchData = async () => {
            setDatosCargando(true);
            // Hotfix 3/11 · otra persona (o la primera vez): Soporte se vuelve a pedir, para ÉSTA, y
            // sólo cuando su ficha haya llegado.
            setFichaCargada(false);
            setSoporteCargado(null);
            setSoporteDesbloqueado(false);
            try {
                const persona = tipo === "colaboradora" ? await fetchPersonaColaboradoraData(Id) : await fetchPersonaData(Id);
                if (cancelado) return;

                // Formatear fechas al formato YYYY-MM-DD para inputs de tipo date
                if (persona.fecha_nacimiento) {
                    persona.fecha_nacimiento = persona.fecha_nacimiento.split('T')[0];
                }
                if (persona.fecha_alta) {
                    persona.fecha_alta = persona.fecha_alta.split('T')[0];
                }
                if (persona.fecha_baja) {
                    persona.fecha_baja = persona.fecha_baja.split('T')[0];
                }
                if (persona.dni_fecha_caducidad) {
                    persona.dni_fecha_caducidad = persona.dni_fecha_caducidad.split('T')[0];
                }

                persona.supervisor_ids = (persona.supervisores || []).map(s => s.Id);

                // Fase 4 · eje COLABORADOR. Campo aparte de `supervisor_ids`, que es del eje
                // interno: son dos tablas distintas y esta ficha sirve para las dos identidades.
                // El `nivel` llega en primer nivel de cada fila porque el include del servidor es
                // un hasMany sobre el modelo de la relación, no un belongsToMany.
                persona.supervisores_colab = (persona.supervisoresColab || []).map(r => ({
                    id: r.supervisor_colaboradora_id,
                    nivel: r.nivel,
                    nombre: r.supervisora ? `${r.supervisora.nombre} ${r.supervisora.apellidos}` : '(desconocida)',
                }));

                // Hotfix 3/11 · MEZCLA, no sustituye: si Soporte ya había llegado (de esta misma
                // persona), sus campos se quedan. Antes `setPersonaData(persona)` los borraba.
                setPersonaData((previo) => mezclarCargaFicha(previo, persona));
                setFichaCargada(true);
                // El estado tal y como está guardado. Se fija UNA vez, al cargar: si se
                // recalculara con cada edición, la transición dejaría de ser detectable.
                setEstadoOriginal(persona.estado != null ? String(persona.estado) : null);

                if(persona.foto){
                    const urlPrevisualizacion = `/api/persona/imagen/${persona.foto}?formato=grande`;
                    setPrevisualizacionImg(`${API_URL}${urlPrevisualizacion}` || null);
                }

                // Use utility function to find province by name
                const selectedProvince = buscarProvinciaPorNombre(persona.provincia);
                setProvinciaId(selectedProvince);

                if ((!persona.codigo_postal || persona.codigo_postal === '') && persona.provincia && persona.poblacion) {
                    // Use utility function to find CP by poblacion
                    const cpPrincipal = buscarCPPorPoblacion(persona.provincia, persona.poblacion);

                    if (cpPrincipal) {
                        setPersonaData(prevData => ({
                            ...prevData,
                            codigo_postal: cpPrincipal
                        }));
                        console.log(`Código postal autocompletado: ${cpPrincipal} para ${persona.poblacion}, ${persona.provincia}`);
                    }
                }

                // Guardar cargos sin procesar para que el useEffect los procese cuando departamentos esté listo
                const cargosNuevos = persona.Cargos || [];
                setCargosRaw(cargosNuevos);
                if (cargosNuevos.length > 0) setCargosProcesados(false);

                if (tipo === "colaboradora" && persona.empresa_colaboradora_id) {
                    const empresaId = persona.empresa_colaboradora_id.toString();
                    setFilasInternos(prev => {
                        const yaExiste = prev.some(f => f.empresa === empresaId);
                        if (!yaExiste) {
                            return [{ empresa: empresaId, departamento: '', cargo: '' }, ...prev];
                        }
                        return prev;
                    });
                }

            } catch (error) {
                console.log("Ha habido un error:", error);
                toast.error("Error al cargar los datos de la persona");
            } finally {
                if (!cancelado) setDatosCargando(false);
            }
        };

        fetchData();
        return () => { cancelado = true; };
    }, [Id]);

    // Procesar cargos cuando tanto cargosRaw como departamentos estén disponibles
    useEffect(() => {
        if (cargosRaw.length === 0 || departamentos.length === 0) return;

        const procesarCargos = async () => {
            const cargosInternos = cargosRaw.filter(cargo => {
                if (cargo.empresa_colaboradores_id) return true;
                if (!cargo.departamento_id) {
                    return true;
                }
                const dept = departamentos.find(d => d.Id.toString() === cargo.departamento_id.toString());
                return dept && dept.tipo === 'interno';
            }).map(cargo => ({
                esColaborador: !!cargo.empresa_colaboradores_id,
                empresa: cargo.empresa_colaboradores_id
                    ? cargo.empresa_colaboradores_id.toString()
                    : (cargo.empresa_id ? cargo.empresa_id.toString() : ''),
                departamento: cargo.departamento_id ? cargo.departamento_id.toString() : '',
                cargo: cargo.cargo || ''
            }));

            const cargosOrganigrama = cargosRaw.filter(cargo => {
                if (cargo.empresa_colaboradores_id) return false;
                if (!cargo.departamento_id) {
                    return false;
                }
                const dept = departamentos.find(d => d.Id.toString() === cargo.departamento_id.toString());
                return dept && dept.tipo === 'organigrama';
            }).map(cargo => ({
                esColaborador: false,
                empresa: cargo.empresa_id ? cargo.empresa_id.toString() : '',
                departamento: cargo.departamento_id ? cargo.departamento_id.toString() : '',
                cargo: cargo.cargo || '',
                responsable: cargo.responsable || false,
                adjunto: cargo.adjunto || ''
            }));

            setFilasInternos(cargosInternos);
            setFilasOrganigrama(cargosOrganigrama);

            const adjuntosPorFilaTemp = await Promise.all(
                cargosOrganigrama.map(async (cargo) => {
                    if (cargo.empresa && cargo.departamento) {
                        let adjuntosData = await fetchAdjuntosData(cargo.empresa, cargo.departamento);
                        adjuntosData = adjuntosData.filter(adj => adj.id.toString() !== Id.toString());
                        return adjuntosData;
                    }
                    return [];
                })
            );
            setAdjuntosPorCargo(adjuntosPorFilaTemp);
            setCargosProcesados(true);
        };

        procesarCargos();
    }, [cargosRaw, departamentos, Id]);


    useEffect(() => {
            const imgInput = document.getElementById("imagenPersona_img");
            const valorImg = imgInput ? imgInput.value : "";
            const f = new Date();
            const dia = ('0' + f.getDate()).slice(-2);
            const mes = ('0' + (f.getMonth() + 1)).slice(-2);
            const año = f.getFullYear();
            const hora = ('0' + f.getHours()).slice(-2);
            const minutos = ('0' + f.getMinutes()).slice(-2);
            const segundos = ('0' + f.getSeconds()).slice(-2);
    
            if ((personaData.foto == null || personaData.foto == "") && (valorImg != "")) {
                const foto = `${dia}${mes}${año}${hora}${minutos}${segundos}_persona_img`;
    
                setPersonaData(prevFormData => ({ ...prevFormData, foto: foto }));
            }
    
            if (estadosActualizados) {
                let validacionTodosDatos = todosDatosCorrectos(personaData, estadoCampoReque);
                let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
                (async () => {
                    if (todosCamposFalse === true) {
                        setFormCompletado(true);
                        setErrorEnviarForm(prevFormData => ({ ...prevFormData, personaDuplicada: false }));
                        
                        try {
                            // Hotfix 3/11 · el segundo camino de guardado sigue la MISMA regla que el
                            // primero: sin Soporte cargado bien en esta apertura, sus campos no viajan.
                            // Antes enviaba `{ ...personaData }` tal cual, con lo que hubiera de Soporte.
                            let personaDataConHash = quitarSoporteSiNoCargado(personaData, soporteOk);

                            if(personaDataConHash.fecha_nacimiento == '' || personaDataConHash.fecha_nacimiento == null ||personaDataConHash.fecha_nacimiento == undefined)
                                personaDataConHash.fecha_nacimiento = null;

                            if(personaDataConHash.fecha_alta == '' || personaDataConHash.fecha_alta == null || personaDataConHash.fecha_alta == undefined)
                                personaDataConHash.fecha_alta = null;

                            if(personaDataConHash.dni_fecha_caducidad == '' || personaDataConHash.dni_fecha_caducidad == null || personaDataConHash.dni_fecha_caducidad == undefined)
                                personaDataConHash.dni_fecha_caducidad = null;

                            if (personaDataConHash.Oficinas && Array.isArray(personaDataConHash.Oficinas)) {
                                personaDataConHash.Oficinas = personaDataConHash.Oficinas.map(oficina => oficina.Id);
                            }

                            // Fase 4 · el estado deseado COMPLETO del eje colaborador. La condición
                            // por tipo vive dentro del helper, para que no haya dos sitios donde
                            // olvidarla.
                            aplicarSupervisoresColabAlPayload(personaDataConHash);

                            const response = tipo === "colaboradora" ? await fetchEditarPersonaColaboradora(personaDataConHash) : await fetchEditarPersona(personaDataConHash);
                            // El MISMO aviso que el otro camino, por lo mismo que los supervisores
                            // de colaboradora: este formulario guarda por DOS rutas, y ponerlo en
                            // una sola daría una confirmación intermitente según por dónde entrase.
                            // Aquí importa más todavía: `setFormCompletado(true)` se llama ARRIBA,
                            // antes de la petición, así que el modal ya salió sin saber el
                            // resultado. Esto es lo único que espera al 200.
                            avisarFichaGuardada();
                            // Los cuatro campos que el servidor recalcula al guardar. Sin esto la
                            // ficha se queda contradiciéndose: ver `fundirCalculados`.
                            fundirCalculados(setPersonaData, response);
                        } catch (error) {
                            console.error("Error al editar persona:", error);

                            if (error?.response?.data?.error === 'REGISTRO_DUPLICADO') {
                                setErrorEnviarForm(prevFormData => ({ ...prevFormData, personaDuplicada: true }));
                            }
                            // Fase 4 · fallo ruidoso del rechazo de supervisión (ver el helper).
                            manejarErrorSupervisionColab(error);
                            setFormCompletado(false);
                        } finally {
                            setEstadosActualizados(false);
                        }
                    } 
                    else {
                        if(!avisado){
                            toast.error("Faltan campos por rellenar");
                            setAvisado(true);
                        }
                    }
                })();
            }
        }, [estadosActualizados, personaData, estadoCampoReque, soporteOk]);

    useEffect(() => {
        if (personaData.negocios && personaData.negocios.length > 0) {
            const empresasIds = personaData.Negocios.map(negocio => negocio.Id.toString()); //Empresas
            
            const filteredDepts = departamentos.filter(departamento => {
                return departamento.Negocios && departamento.Negocios.some(negocio => 
                    empresasIds.includes(negocio.Id.toString())
                );
            });
            
            setFilasInternos(prevFilas => prevFilas.map(fila => {
                if (fila.empresa && fila.departamento) {
                    const deptosForEmpresa = filteredDepts.filter(dept => 
                        dept.tipo === 'interno' &&
                        dept.Negocios.some(emp => emp.Id.toString() === fila.empresa)
                    );
                    
                    const esDepartamentoValido = deptosForEmpresa.some(dept => 
                        dept.Id.toString() === fila.departamento
                    );
                    
                    return {
                        ...fila,
                        departamento: esDepartamentoValido ? fila.departamento : ''
                    };
                }
                return fila;
            }));
            
            setFilasOrganigrama(prevFilas => prevFilas.map(fila => {
                if (fila.empresa && fila.departamento) {
                    const deptosForEmpresa = filteredDepts.filter(dept => 
                        dept.tipo === 'organigrama' &&
                        dept.Negocios.some(emp => emp.Id.toString() === fila.empresa)
                    );
                    
                    const isDeptValid = deptosForEmpresa.some(dept => 
                        dept.Id.toString() === fila.departamento
                    );
                    
                    return {
                        ...fila,
                        departamento: isDeptValid ? fila.departamento : ''
                    };
                }
                return fila;
            }));
            
            if (personaData.Departamentos && personaData.Departamentos.length > 0) {
                const departamentosValidos = personaData.Departamentos.filter(dep =>
                    filteredDepts.some(df => df.Id.toString() === dep.Id.toString())
                );
                
                if (departamentosValidos.length !== personaData.Departamentos.length) {
                    setPersonaData(prev => ({
                        ...prev,
                        Departamentos: departamentosValidos
                    }));
                }
            }
        } else {
            setPersonaData(prev => ({
                ...prev,
                Departamentos: []
            }));
        }
    }, [personaData.Negocios, departamentos]);
    
    const agregarFilaInterno = () => {
        setFilasInternos([...filasInternos, { empresa: '', departamento: '', cargo: '' }]);
    };

    const agregarFilaOrganigrama = () => {
        setFilasOrganigrama([...filasOrganigrama, { empresa: '', departamento: '', cargo: '', responsable: '', adjunto: '' }]);
    };

    const handleChangeFilaInterno = (index, campo, valor) => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        const nuevasFilas = [...filasInternos];
        nuevasFilas[index][campo] = valor;

        if (campo === 'empresa') {
            const empresaId = valor;

            if (tipo !== "colaboradora") {
                const departamentosEmpresa = departamentos.filter(departamento =>
                    departamento.tipo === 'interno' &&
                    departamento.Negocios && departamento.Negocios.some(empresa =>
                        empresa.Id.toString() === empresaId
                    )
                );

                const departamentoActual = nuevasFilas[index].departamento;
                const esDepartamentoValido = departamentosEmpresa.some(dept =>
                    dept.Id.toString() === departamentoActual
                );

                if (!esDepartamentoValido) {
                    nuevasFilas[index].departamento = '';
                    nuevasFilas[index].cargo = '';
                }
            }
        }

        setFilasInternos(nuevasFilas);
        setErroresCargos(prev => ({ ...prev, internos: prev.internos.filter(i => i !== index) }));
    };

    const handleChangeFilaOrganigrama = (index, campo, valor) => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo
        
        const nuevasFilas = [...filasOrganigrama];

        if (campo === 'responsable' && valor) {
            nuevasFilas[index]['responsable'] = true;
            nuevasFilas[index]['adjunto'] = '';
        } else if (campo === 'adjunto' && valor) {
            nuevasFilas[index]['adjunto'] = valor;
            nuevasFilas[index]['responsable'] = false;
        } else {
            nuevasFilas[index][campo] = valor;
        }

        if (campo === 'empresa') {
            const empresaId = valor;

            if (tipo !== "colaboradora") {
                const departamentosEmpresa = departamentos.filter(departamento =>
                    departamento.tipo === 'organigrama' &&
                    departamento.Negocios && departamento.Negocios.some(empresa =>
                        empresa.Id.toString() === empresaId
                    )
                );

                const departamentoActual = nuevasFilas[index].departamento;
                const esDepartamentoValido = departamentosEmpresa.some(dept =>
                    dept.Id.toString() === departamentoActual
                );

                if (!esDepartamentoValido) {
                    nuevasFilas[index].departamento = '';
                    nuevasFilas[index].cargo = '';
                    nuevasFilas[index].adjunto = '';
                    setAdjuntosPorCargo(prev => {
                        const copia = [...prev];
                        copia[index] = [];
                        return copia;
                    });
                }
            }
        }

        if (campo === 'departamento') {
            async function actualizarAdjuntos() {
                let adjuntosData = [];
                if (nuevasFilas[index].empresa && nuevasFilas[index].departamento) {
                    adjuntosData = await fetchAdjuntosData(nuevasFilas[index].empresa, nuevasFilas[index].departamento);
                    adjuntosData = adjuntosData.filter(adj => adj.id.toString() !== personaData.Id.toString());
                }
                setAdjuntosPorCargo(prev => {
                    const copia = [...prev];
                    copia[index] = adjuntosData;
                    return copia;
                });
                nuevasFilas[index].adjunto = '';
            }
            actualizarAdjuntos();
        }

        setFilasOrganigrama(nuevasFilas);
        setErroresCargos(prev => ({ ...prev, organigrama: prev.organigrama.filter(i => i !== index) }));
    };

    // ── Fase 4 · filas de supervisores del eje COLABORADOR ───────────────────────────────
    // Mismo modelo mental que las filas de Cargos: se edita una lista en el estado y el
    // servidor recibe el estado deseado COMPLETO. El diffing —altas, bajas y cambios de
    // nivel— lo calcula el servicio en servidor comparando con lo que hay en la tabla; el
    // cliente no manda operaciones, manda cómo debe quedar.
    const agregarFilaSupervisorColab = () => {
        setPersonaData(prev => ({
            ...prev,
            // 'gestionar' por defecto, igual que el DEFAULT de la columna: el eje interno
            // concede gestión desde la Fase 1, así que bajar a 'ver' es el acto deliberado.
            supervisores_colab: [...(prev.supervisores_colab || []), { id: '', nivel: 'gestionar' }],
        }));
        setErrorSupColab(null);
    };

    const cambiarFilaSupervisorColab = (index, campo, valor) => {
        setPersonaData(prev => {
            const filas = [...(prev.supervisores_colab || [])];
            filas[index] = { ...filas[index], [campo]: valor };
            return { ...prev, supervisores_colab: filas };
        });
        setErrorSupColab(null);
    };

    const quitarFilaSupervisorColab = (index) => {
        setPersonaData(prev => ({
            ...prev,
            supervisores_colab: (prev.supervisores_colab || []).filter((_, i) => i !== index),
        }));
        setErrorSupColab(null);
    };

    const eliminarFilaInterno = (index) => {
        const nuevasFilas = filasInternos.filter((_, i) => i !== index);
        setFilasInternos(nuevasFilas);
    };

    const eliminarFilaOrganigrama = (index) => {
        const nuevasFilas = filasOrganigrama.filter((_, i) => i !== index);
        setFilasOrganigrama(nuevasFilas);
    };

    const esMandoIntermedio = (departamentoId, empresaId) => {
        if (!departamentoId || !empresaId) return false;
        const dept = departamentos.find(d => d.Id.toString() === departamentoId.toString());
        if (!dept || !dept.Negocios) return false;
        const emp = dept.Negocios.find(e => e.Id.toString() === empresaId.toString());
        return emp && emp.DepartamentoEmpresa && emp.DepartamentoEmpresa.mando_intermedio_de_1 != null;
    };

    const getDepartamentosPorEmpresaYTipo = (empresaId, filaIndex, tipo, filasTipo) => {
        if (!empresaId) return [];
        
        const departamentosEmpresa = departamentos.filter(departamento => 
            departamento.tipo === tipo &&
            departamento.Negocios && departamento.Negocios.some(empresa => 
                empresa.Id.toString() === empresaId
            )
        );
        
        const departamentosSeleccionados = filasTipo
            .filter((fila, idx) => idx !== filaIndex && fila.empresa === empresaId && fila.departamento)
            .map(fila => fila.departamento);
        
        return departamentosEmpresa
            .filter(departamento => 
                !departamentosSeleccionados.includes(departamento.Id.toString())
            )
            .sort((a, b) => a.nombre.localeCompare(b.nombre));
    };

    const sendEmailUrlBitwarden = async () => {

        if (!personaData.mail_empresa) {
            toast.error("La persona debe tener un email para enviar el correo con el enlace del bitwarden");
            return;
        }

        if (!urlEnlace) {
            toast.error("No se puede enviar el email con la url del bitwarden porque no se ha generado una url válida");
            return;
        }

        const resultado = await Swal.fire({
            title: `🛡️Enlace de Bitwarden🛡️`, 
            html: `Estas a punto de compartir el siguiente enlace de Bitwarden con <b>${personaData.nombre || "Nombre no disponible"} ${personaData.apellidos || "Apellidos no disponibles"}</b>:<br><br><a href="${urlEnlace}" target="_blank">${urlEnlace}</a><br><br>¿Estas seguro de querer enviar el Correo?`,
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#003c66',
            cancelButtonColor: '#1c1c1d',
            confirmButtonText: 'Enviar 📫',
            cancelButtonText: 'Cancelar',
        });

            // SOLO copia si el usuario pulsa "Copiar"
        if (resultado.isConfirmed) {
            try {
                const response = await fetchSolicitarUrlBitWarden({
                    url: urlEnlace,
                    email: personaData.mail_empresa
                });

                if (response.status === 200) {
                    toast.success("Email con la url del bitwarden enviado correctamente");

                } else {
                    toast.error("No se pudo enviar el email con la url del bitwarden");
                }
            } catch (error) {
                console.error("Error al enviar el email con la url del bitwarden:", error);
                toast.error("Error al enviar el email con la url del bitwarden");
            }
        }else{
            toast.info("Operación cancelada");
        }
    };

    return (
        <>
            <Form onSubmit={handleSubmit}>
                <CabeceraForm>
                    <Titulo
                        texto={tipo === "colaboradora" ? "EDITAR UN COLABORADOR" : "EDITAR UN EMPLEADO"}
                    />
                </CabeceraForm>
                <FormContainer>
                    <ToastContainer/>
                    <Col>
                        {/* Tabs de navegación */}
                        {/* Fase 12 · §6.6 — proceso de salida abierto.
                            ENCIMA de las pestañas y fuera de los paneles: una baja abierta es de la
                            PERSONA, no de una pestaña, y quien está en Vacaciones tiene que verla
                            igual que quien está en Personal.
                            Y con enlace al proceso: un aviso que no dice dónde mirar obliga a
                            buscarlo, y quien lo busca acaba preguntando. */}
                        {/* ── DE DÓNDE VIENES (pieza 2) ─────────────────────────────────────
                            Lo primero, antes que la situación: si has llegado desde un proceso,
                            lo que tienes que saber es que al guardar vuelves allí, y cómo volver
                            sin guardar. */}
                        {volver && !volverEsElAlta && !volverEsLaBaja && (
                            <Alert
                                severity="info"
                                sx={{ mb: 2 }}
                                action={(
                                    <Button size="small" variant="outlined" onClick={salirAlProceso}>
                                        Volver al proceso
                                    </Button>
                                )}
                            >
                                Has venido desde un proceso de {volver.includes('/bajas/') ? 'baja' : 'alta'} a
                                corregir datos. Al guardar con «Guardar y volver al proceso» vuelves allí.
                            </Alert>
                        )}
                        {/* ── LA SITUACIÓN, ARRIBA DEL TODO ─────────────────────────────────
                            Encima de las pestañas y del banner: es lo primero que hay que saber de
                            una ficha, y no pertenece a ninguna pestaña. */}
                        {personaData.insignia && (
                            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                                <Chip
                                    label={personaData.insignia.texto}
                                    color={TONO_A_COLOR[personaData.insignia.tono] || 'default'}
                                    size="medium"
                                    sx={{ fontWeight: 600, fontSize: '0.875rem' }}
                                />
                                {personaData.insignia.clave === 'vacaciones' && personaData.presencia?.hasta && (
                                    <span style={{ fontSize: '0.8125rem', color: '#64748b' }}>
                                        hasta el {personaData.presencia.hasta.split('-').reverse().join('/')}
                                    </span>
                                )}
                            </Box>
                        )}

                        {/* ── LA CONTRADICCIÓN SE ENSEÑA, NO SE ESCONDE ─────────────────────
                            Hay cinco fichas heredadas donde `activo` y la situación se contradicen.
                            Enseñar «Baja» junto a acceso concedido sin decir que eso no debería
                            pasar sería mentir por omisión — y esconderlo, peor: nadie las
                            arreglaría nunca.

                            NO se arreglan desde aquí: es una decisión de datos, y tomarla de
                            refilón al guardar un teléfono sería tomarla a escondidas. */}
                        {personaData.Id && personaData.acceso_coherente === false && (
                            <Alert severity="error" icon={<AlertTriangle size={20} />} sx={{ mb: 2 }}>
                                <strong>Esta ficha está en un estado que la regla no permite.</strong>{' '}
                                La situación es <strong>{estados.find((e) => String(e.Id) === String(personaData.estado))?.nombre || '—'}</strong>
                                {' '}y el acceso a la intranet está{' '}
                                <strong>{personaData.activo ? 'concedido' : 'quitado'}</strong>, y deberían ir juntos.
                                {' '}Se arregla eligiendo de nuevo la situación y guardando.
                            </Alert>
                        )}

                        {/* ── EL BANNER DEL ALTA, EN DOS FORMAS ──────────────────────────
                            El de bajas es de AVISO —«esta persona se va»—; éste es de ACCIÓN,
                            porque el caso que lo justifica es alguien en «En proceso» al que hay
                            que ponerle la fecha, y hoy la ficha no dice ni que exista el proceso.

                            ÁMBAR si la persona no puede entrar todavía: eso es lo que urge.
                            GRIS, UNA LÍNEA, si ya está dentro y sólo queda trabajo. Va a salir en
                            muchas fichas mientras haya altas abiertas, y si compitiera con el de
                            bajas se llevaría los dos por delante.

                            Y SÓLO mientras el alta esté abierta. Una cerrada hace tres años no es
                            información que deba ocupar la cabecera; para eso está la tabla de
                            procesos de la pestaña Empresa, que responde «tuvo proceso».

                            SI COINCIDEN ALTA Y BAJA ABIERTAS —alguien que entra y se va antes de
                            cerrar su incorporación—, GANA LA BAJA y ésta no se pinta. Dos banners
                            apilados son uno de más, y de los dos el urgente es el que dice que
                            alguien se va: el del alta se puede ver en la pestaña Empresa, el de la
                            baja lleva acciones que no están en ningún otro sitio. */}
                        {!bajaAbierta && altas?.abierta && (
                            String(personaData.estado) === idEstadoEnProceso ? (
                                <Alert
                                    severity="warning"
                                    icon={<AlertTriangle size={20} />}
                                    sx={{ mb: 2, alignItems: 'center' }}
                                    action={(
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                            {/* EDITAR LA FECHA SE OFRECE AQUÍ, en el banner ámbar y no en el gris:
                                                éste es el caso en que la fecha es justo lo que falta —el texto de
                                                al lado dice «se arregla poniéndosela en el proceso»—, y hasta hoy
                                                esa frase mandaba a otra pantalla a buscar cómo. */}
                                            {/* «Editar el alta», no «Editar la fecha»: con un alta y una
                                                baja abiertas a la vez puede haber dos botones de editar en
                                                la misma ficha, y llamarse igual invita a cambiar la fecha
                                                equivocada. Cada uno nombra su proceso. */}
                                            <Button size="small" variant="outlined"
                                                onClick={() => setEditAlta(altas.abierta)}>
                                                Editar el alta
                                            </Button>
                                            <Button size="small" variant="outlined"
                                                onClick={() => (volverEsElAlta ? salirAlProceso() : navigate(rutaAlta(altas.abierta.id)))}>
                                                {volverEsElAlta ? 'Volver al proceso' : 'Ver el proceso'}
                                            </Button>
                                        </div>
                                    )}
                                >
                                    {altas.abierta.fecha_incorporacion ? (
                                        <>
                                            <strong>Todavía no puede entrar.</strong>{' '}
                                            Empieza el {String(altas.abierta.fecha_incorporacion).slice(0, 10).split('-').reverse().join('/')},
                                            y ese día pasará a «Alta» automáticamente.
                                        </>
                                    ) : (
                                        <>
                                            <strong>No puede entrar, y nadie la va a activar.</strong>{' '}
                                            Su incorporación <strong>no tiene fecha</strong>, y el paso a «Alta» lo
                                            dispara la fecha. Se arregla poniéndosela en el proceso.
                                        </>
                                    )}
                                </Alert>
                            ) : (
                                <div style={{
                                    display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12,
                                    fontSize: 13, color: '#64748b',
                                }}>
                                    <span>
                                        Incorporación <strong style={{ fontWeight: 600 }}>{altas.abierta.numero}</strong> en curso
                                        {/* «cosas», no «tareas»: el numero cuenta tambien material y credenciales.
                                            Y con cero pendientes se distingue «todo preparado» de «no habia nada
                                            que preparar», que no es lo mismo. */}
                                        {altas.abierta.tareas_pendientes > 0
                                            ? ` · ${altas.abierta.tareas_pendientes} sin preparar`
                                            : altas.abierta.tareas_total > 0
                                                ? ' · todo preparado'
                                                : ' · nada que preparar'}
                                    </span>
                                    {/* El banner gris también edita. Antes el único botón vivía en la tabla
                                        de la pestaña EMPRESA, y el banner sale en TODAS: el sitio donde se
                                        cambia la fecha no debe depender de en qué pestaña estés. */}
                                    <Button size="small" variant="text" sx={{ minWidth: 0, p: 0, textTransform: 'none' }}
                                        onClick={() => setEditAlta(altas.abierta)}>
                                        Editar el alta
                                    </Button>
                                    <Button size="small" variant="text" sx={{ minWidth: 0, p: 0, textTransform: 'none' }}
                                        onClick={() => (volverEsElAlta ? salirAlProceso() : navigate(rutaAlta(altas.abierta.id)))}>
                                        {volverEsElAlta ? 'Volver al proceso' : 'Ver'}
                                    </Button>
                                </div>
                            )
                        )}

                        {bajaAbierta && (
                            <Alert
                                severity="warning"
                                icon={<AlertTriangle size={20} />}
                                sx={{ mb: 2, alignItems: 'center', '& .MuiAlert-action': { flexShrink: 0, paddingTop: 0, alignItems: 'center' } }}
                                action={(
                                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                                        {/* Editar y cancelar sólo con `bajas.editar`. El servidor lo
                                            exige igual; esto evita ofrecer un botón que da 403. */}
                                        {puedeEditarBajas && (
                                            <>
                                                <Button
                                                    size="sm"
                                                    variant="outline-secondary"
                                                    onClick={() => setEditBaja({
                                                        fecha: bajaAbierta.fecha_baja ? String(bajaAbierta.fecha_baja).slice(0, 10) : '',
                                                        motivo: bajaAbierta.motivo || '',
                                                        fechaOriginal: bajaAbierta.fecha_baja ? String(bajaAbierta.fecha_baja).slice(0, 10) : '',
                                                        guardando: false,
                                                    })}
                                                >
                                                    Editar la baja
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    variant="outline-danger"
                                                    disabled={cancelandoBaja}
                                                    onClick={async () => {
                                                        setCancelandoBaja(true);
                                                        try {
                                                            const r = await cancelarBaja(bajaAbierta.id);
                                                            // Se dice SI la persona ha vuelto, y si no, por qué. Callarlo
                                                            // dejaría al usuario sin saber si tiene acceso otra vez.
                                                            toast.success(r?.persona_reactivada
                                                                ? `Baja cancelada. ${nombreCompleto} recupera el acceso.`
                                                                : 'Baja cancelada. La persona no estaba desactivada, así que no cambia su acceso.');
                                                            setBajaAbierta(null);
                                                            navigate(0);
                                                        } catch (e) {
                                                            toast.error(e?.response?.data?.message || 'No se ha podido cancelar la baja.');
                                                        } finally { setCancelandoBaja(false); }
                                                    }}
                                                >
                                                    Cancelar la baja
                                                </Button>
                                            </>
                                        )}
                                        <Button
                                            size="sm"
                                            variant="outline-warning"
                                            onClick={() => (volverEsLaBaja ? salirAlProceso() : navigate(rutaBaja(bajaAbierta.id)))}
                                        >
                                            <ExternalLink size={14} style={{ marginRight: 6 }} />
                                            {volverEsLaBaja ? 'Volver al proceso' : 'Ver el proceso'}
                                        </Button>
                                    </div>
                                )}
                            >
                                Esta persona tiene un <strong>proceso de salida abierto</strong>
                                {bajaAbierta.numero ? ` (${bajaAbierta.numero})` : ''}
                                {bajaAbierta.fecha_baja ? ` · con fecha ${String(bajaAbierta.fecha_baja).slice(0, 10).split('-').reverse().join('/')}` : ''}.
                            </Alert>
                        )}

                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={tabValue} onChange={handleCambioTab} aria-label="Pestañas de formulario" variant="scrollable" scrollButtons="auto" left>
                                <Tab value={TAB.PERSONAL} label="PERSONAL" icon={<IdCard size={20} />} />
                                <Tab value={TAB.EMPRESA} label="EMPRESA" icon={<Building2 size={20} />} />
                                <Tab value={TAB.VACACIONES} label="VACACIONES" icon={<Umbrella size={20} />} />
                                <Tab value={TAB.FORMACION} label="FORMACIÓN" icon={<GraduationCap size={20} />} />
                                {/* RRHH va por PERMISO, no por rol: es lo que decide el backend, con
                                    checkPermiso("personas.datos_rrhh.ver"). Gatearla por rol aquí y por permiso
                                    allí sería tener la regla en dos sitios que pueden separarse — y separándose,
                                    la pestaña aparecería para quien la API rechaza, o al revés. */}
                                {puedeVerRrhh && (
                                    <Tab value={TAB.RRHH} label="RRHH" icon={<Landmark size={20} />} />
                                )}
                                {/* Fase 13 · dejan de estar deshabilitadas. En la Fase 12 se enseñaron en gris
                                    con su tooltip, porque que exista el sitio dice que el dato vendrá; el dato
                                    ya está aquí.
                                    Los contadores salen de UNA sola lectura del servidor, la misma que alimenta
                                    las dos pestañas: ver `resumenAccesos`. Si esa lectura falla o tarda, las
                                    pestañas se pintan SIN número — un contador es un adorno informativo, y la
                                    ficha no debe esperarle. */}
                                <Tab value={TAB.CREDENCIALES} icon={<KeyRound size={20} />}
                                    label={resumenAccesos ? `CREDENCIALES (${resumenAccesos.credenciales})` : 'CREDENCIALES'} />
                                <Tab value={TAB.INVENTARIO} icon={<Boxes size={20} />}
                                    label={(() => {
                                        if (!resumenAccesos) return 'INVENTARIO';
                                        // El número va en ámbar SÓLO si hay proceso de salida abierto: es lo que
                                        // convierte «tiene material» en «tiene material que devolver».
                                        const n = resumenAccesos.material;
                                        return bajaAbierta && n > 0 ? `INVENTARIO (${n} por devolver)` : `INVENTARIO (${n})`;
                                    })()} />
                                {puedeVerCitas && (
                                    <Tab value={TAB.CITAS} label="CITAS TÉCNICAS" icon={<CalendarClock size={20} />} />
                                )}
                                {puedeVerSoporte(persona.persona?.rol) && (
                                    <Tab value={TAB.SOPORTE} label="SOPORTE" icon={<Wrench size={20} />} />
                                )}
                            </Tabs>
                        </Box>

                        {/* Fase A1 · la puerta del segundo factor y el contador de la ventana.
                            El contador va JUNTO A LAS PESTAÑAS y no dentro de Soporte, para que
                            se vea también mientras se navega por las demás: la ventana sigue
                            abierta aunque no se esté mirando. */}
                        {/* La puerta GUARDA la ventana ella misma desde Fase 12 §6.7bis.
                            `onAbierta` se queda para lo que ESTA pantalla hace después: cargar
                            los datos de soporte. Antes también persistía aquí, y tener la misma
                            llamada en tres consumidores es como uno se olvida. */}
                        <PuertaSegundoFactor
                            open={puertaAbierta}
                            onClose={() => setPuertaAbierta(false)}
                            queVasAVer="los datos de soporte de esta persona"
                            onAbierta={(token) => cargarDatosSoporte(token)}
                        />

                        {/* Contenido de la pestaña Datos Personales */}
                        <TabPanel value={tabValue} index={TAB.PERSONAL}>
                            {/* Header con Foto y Datos Básicos */}
                            <SeccionCard>
                                <PerfilHeader>
                                    <ImagenPerfilContainer>
                                        {previsualizacionImg ? (
                                            <ContenedorEncabezado>
                                                <IconosGenerales
                                                    alerta="true"
                                                    id="delete"
                                                    onClick={handleDelete}
                                                />
                                                <img
                                                    src={previsualizacionImg}
                                                    onError={(e) => {
                                                        setPersonaData(prevData => ({ ...prevData, foto: null, imagen_base64: null }));
                                                        setPrevisualizacionImg(null);
                                                    }}
                                                    alt="Foto de perfil"
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0
                                                    }}
                                                />
                                            </ContenedorEncabezado>
                                        ) : (
                                            <ImagenPerfil src={ImagenDefault} alt="Sin foto" />
                                        )}
                                    </ImagenPerfilContainer>

                                    <DatosBasicosContainer>
                                        <Form.Group>
                                            <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                                            <Form.Control type='text' name='nombre' value={personaData.nombre || ''} onChange={handleChange} />
                                            <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>Apellidos <span>*</span></TituloCategoria>
                                            <Form.Control type='text' name='apellidos' value={personaData.apellidos || ''} onChange={handleChange} />
                                            <ErrorForm mensaje={camposRequeridos.apellidos} estadoAlerta={estadoCampoReque.apellidos} />
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>DNI {tipo !== "colaboradora" && <span>*</span>}</TituloCategoria>
                                            <Form.Control type='text' name='dni' value={personaData.dni || ''} onChange={handleChange} />
                                            {tipo !== "colaboradora" && <ErrorForm mensaje={camposRequeridos.dni} estadoAlerta={estadoCampoReque.dni} />}
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>Caducidad DNI</TituloCategoria>
                                            <Form.Control type='date' name='dni_fecha_caducidad' value={personaData.dni_fecha_caducidad || ''} onChange={handleChange} />
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>Fecha de Nacimiento</TituloCategoria>
                                            <Form.Control type="date" name="fecha_nacimiento" value={personaData.fecha_nacimiento || ''} onChange={handleChange} />
                                        </Form.Group>

                                        {/* Fase 12 · §6.3 — el correo PERSONAL.
                                            Va aqui, con los datos personales, y NO en el bloque
                                            Contacto: ese bloque empieza con «Email corporativo» y
                                            es contacto de TRABAJO. Meterlo alli seria repetir lo
                                            que le pasaba a `telefono_fijo`, que parecia personal
                                            por estar rodeado de campos personales.
                                            En el listado lo ven administrador, super administrador
                                            y recursos humanos; en la exportacion va con los
                                            personales. */}
                                        <Form.Group>
                                            <TituloCategoria>Correo personal</TituloCategoria>
                                            <Form.Control type='email' name='correo_personal' value={personaData.correo_personal || ''} onChange={handleChange} />
                                        </Form.Group>

                                        {/* El telefono personal EXISTIA en la base desde el flujo
                                            de alta y no se pintaba en ninguna pantalla: se
                                            escribia y no habia donde verlo. */}
                                        <Form.Group>
                                            <TituloCategoria>Teléfono personal</TituloCategoria>
                                            <Form.Control type='text' name='telefono_personal' value={personaData.telefono_personal || ''} onChange={handleChange} />
                                        </Form.Group>

                                        {/* ── LA SITUACIÓN Y SUS DOS CONSECUENCIAS ──────────
                                            Tres campos juntos, y sólo el primero se elige. Los
                                            otros dos se deducen, y por eso se enseñan como texto
                                            y no como controles: **un campo que parece editable y
                                            no lo es, se intenta editar.** */}
                                        <Form.Group>
                                            <TituloCategoria>Situación administrativa <span>*</span></TituloCategoria>
                                            <Form.Select value={personaData.estado || ''} name="estado" onChange={handleChangeEstado}>
                                                <option value="">Seleccionar...</option>
                                                {estadosElegibles.map((estado, index) => (
                                                    <option key={index} value={estado.Id}>{estado.nombre}</option>
                                                ))}
                                            </Form.Select>
                                            <ErrorForm mensaje={camposRequeridos.estado} estadoAlerta={estadoCampoReque.estado} />
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>Acceso a la intranet</TituloCategoria>
                                            <DatoCalculado title="Se deduce de la situación: Baja y Suspendido lo quitan">
                                                {personaData.acceso === undefined ? '—' : (
                                                    <>
                                                        <Chip
                                                            size="small"
                                                            label={personaData.acceso ? 'Con acceso' : 'Sin acceso'}
                                                            color={personaData.acceso ? 'success' : 'error'}
                                                            variant="outlined"
                                                        />
                                                        <PieCalculado>
                                                            {personaData.acceso
                                                                ? 'Puede entrar en la intranet'
                                                                : 'No puede entrar. Lo quita la situación, no un interruptor'}
                                                        </PieCalculado>
                                                    </>
                                                )}
                                            </DatoCalculado>
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>Presencia hoy</TituloCategoria>
                                            <DatoCalculado title="Sale de las vacaciones aprobadas que cubren hoy">
                                                {/* A quien no puede entrar, la presencia no le
                                                    aplica: da igual si hoy tenía vacaciones
                                                    aprobadas. La situación manda, igual que en la
                                                    insignia de arriba — y decir «Trabajando» de
                                                    alguien de baja es sencillamente falso. */}
                                                {personaData.acceso === false ? (
                                                    <>
                                                        <Chip size="small" label="No aplica" variant="outlined" />
                                                        <PieCalculado>Sin acceso a la intranet</PieCalculado>
                                                    </>
                                                ) : !personaData.presencia ? '—' : (
                                                    <>
                                                        <Chip
                                                            size="small"
                                                            label={personaData.presencia.presencia === 'vacaciones' ? 'De vacaciones' : 'Trabajando'}
                                                            color={personaData.presencia.presencia === 'vacaciones' ? 'info' : 'success'}
                                                            variant="outlined"
                                                        />
                                                        <PieCalculado>
                                                            {personaData.presencia.presencia === 'vacaciones' && personaData.presencia.hasta
                                                                ? `Vacaciones aprobadas hasta el ${personaData.presencia.hasta.split('-').reverse().join('/')}`
                                                                : 'Sin ausencias registradas para hoy'}
                                                        </PieCalculado>
                                                    </>
                                                )}
                                            </DatoCalculado>
                                        </Form.Group>
                                    </DatosBasicosContainer>
                                </PerfilHeader>

                                <AccionesPerfilRow>
                                    <UploadContainer>
                                        <TituloCategoria>Cambiar foto</TituloCategoria>
                                        <Form.Control
                                            type="file"
                                            id='imagenPersona_img'
                                            accept=".jpg,.jpeg,.png,.webp"
                                            max-file-size="3072"
                                            name="imagenPersona_img"
                                            onChange={handleChange}
                                            size="sm"
                                        />
                                    </UploadContainer>

                                    {/* ── EL INTERRUPTOR DE ACTIVO/INACTIVO YA NO ESTÁ ──────────
                                        Era un campo que se pulsaba para decir algo que ya decía la
                                        situación administrativa: **dos campos para un solo hecho**,
                                        y cinco fichas donde se contradicen.

                                        Ahora el acceso SE DEDUCE. Lo decide el servidor
                                        —`estadoPersona.js`— y aquí sólo se muestra, en la pestaña
                                        PERSONAL junto a la situación y a la presencia.

                                        Quitarlo de aquí era uno de cinco caminos: el masivo del
                                        listado, su gemelo de colaboradoras, el proceso de baja y el
                                        PUT que lo aceptaba en el cuerpo. Cerrar cuatro no habría
                                        cerrado nada. */}
                                </AccionesPerfilRow>
                            </SeccionCard>

                            {/* Sección Contacto */}
                            <SeccionCard>
                                <TituloSeccion>
                                    <Phone size={20} /> Contacto
                                </TituloSeccion>
                                <CampoGrid $columnas={4}>
                                    <Form.Group>
                                        <TituloCategoria>Email corporativo <span>*</span></TituloCategoria>
                                        <Form.Control type='email' name='mail_empresa' value={personaData.mail_empresa || ''} onChange={handleChange} />
                                        <ErrorForm mensaje={camposRequeridos.mail_empresa} estadoAlerta={estadoCampoReque.mail_empresa} />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Móvil de empresa</TituloCategoria>
                                        <Form.Control type='text' name='telefono_empresa' value={personaData.telefono_empresa || ''} onChange={handleChange} />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Fijo de empresa</TituloCategoria>
                                        <Form.Control type='text' name='telefono_fijo' value={personaData.telefono_fijo || ''} onChange={handleChange} />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Extensión</TituloCategoria>
                                        <Form.Control type='text' name='extension_telefono' value={personaData.extension_telefono || ''} onChange={handleChange} />
                                    </Form.Group>
                                </CampoGrid>
                                {/* Correos (30/10): de solo lectura aquí, con su propio modal que guarda
                                    al momento. NO entra en el «Guardar» de la ficha ni toca el campo de
                                    arriba: el principal se sigue editando donde siempre. Sólo internas. */}
                                {tipo !== 'colaboradora' && Id && <BloqueCorreosFicha personaId={Id} />}
                            </SeccionCard>

                            {/* Sección Ubicación */}
                            <SeccionCard>
                                <TituloSeccion>
                                    <MapPin size={20} /> Ubicación
                                </TituloSeccion>
                                <CampoGrid $columnas={4}>
                                    <Form.Group>
                                        <TituloCategoria>Código Postal</TituloCategoria>
                                        <Form.Control type="number" name="codigo_postal" value={personaData.codigo_postal || ''} onChange={handleChange} />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Provincia</TituloCategoria>
                                        <Form.Select value={personaData.provincia || ''} name="provincia" onChange={handleChange}>
                                            <option value="">Seleccionar...</option>
                                            {provincias.sort((a, b) => a.localeCompare(b)).map((provincia, index) => (
                                                <option key={index} value={provincia}>{provincia}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Población</TituloCategoria>
                                        <Form.Select value={personaData.poblacion || ''} name="poblacion" onChange={handleChange}>
                                            <option value="">Seleccionar...</option>
                                            {municipios.map((poblaciones, index) => (
                                                <option key={index} value={poblaciones.name}>{poblaciones.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Dirección</TituloCategoria>
                                        <Form.Control type='text' name='direccion' value={personaData.direccion || ''} onChange={handleChange} />
                                    </Form.Group>
                                </CampoGrid>
                            </SeccionCard>

                        </TabPanel>
                    </Col>
                    <Col>
                        {/* Contenido de la pestaña Datos de Empresa */}
                        <TabPanel value={tabValue} index={TAB.EMPRESA}>
                            {/* Sección Información General */}
                            <SeccionCard>
                                <TituloSeccion>
                                    <Building2 size={20} /> Información General
                                </TituloSeccion>
                                <CampoGrid $columnas={3}>
                                    {/* ── Empresa ──────────────────────────────────────────────
                                        VA PRIMERA, antes de la oficina: la razón social enmarca
                                        —es con quién se firma— y la oficina es dónde se sienta.
                                        El orden de los campos dice cuál encuadra a cuál.

                                        «Empresa» a secas: el negocio se llama «Negocio» en su
                                        propio bloque de abajo, y con los dos nombres a la vista no
                                        hay ambigüedad.

                                        SÓLO TRES ROLES. Los mismos que pueden elegir el grupo
                                        `laboral` de la exportación, porque es el mismo dato. Y el
                                        servidor no manda la columna a los demás: esto es una
                                        comodidad para quien mira, no la defensa.

                                        SIN ASTERISCO, y es una decisión. Hoy 270 fichas de 270 la
                                        tienen vacía. Exigirla para guardar bloquearía corregir un
                                        teléfono hasta contestar una pregunta que sólo RRHH sabe, y
                                        una validación que llega antes que los datos acaba
                                        desactivada. Obligatoria en el ALTA, donde hay alguien
                                        delante decidiendo; opcional aquí, que es donde se rellena
                                        el atraso.

                                        El valor se guarda como NÚMERO. Un `<select>` devuelve
                                        cadenas, y la instantánea que vigila los cambios sin guardar
                                        compara con `JSON.stringify`: un 4 frente a un "4" avisaría
                                        de cambios que nadie ha hecho. */}
                                    {/* DOS condiciones, y la segunda faltaba.
                                        El ROL decide quien lo ve —es dato de la relacion laboral—.
                                        Pero el SUJETO decide si existe: `empresa_contratante_id`
                                        vive en `personas` y NO en `personas_colaboradoras`, y no es
                                        un olvido —un colaborador se contrata a traves de su empresa
                                        colaboradora—. Sin esta segunda condicion el selector se
                                        pintaba en la ficha de una colaboradora y NO HACIA NADA:
                                        Sequelize descarta en silencio un campo que el modelo no
                                        declara, asi que se guardaba sin error y sin efecto.
                                        Un campo que aparece y no hace nada es peor que no estar. */}
                                    {tipo !== "colaboradora"
                                      && ROLES_CON_EMPRESA_CONTRATANTE.includes(persona.persona?.rol?.toLowerCase()) && (
                                    <Form.Group>
                                        <TituloCategoria>Empresa</TituloCategoria>
                                        <Form.Select
                                            name="empresa_contratante_id"
                                            value={personaData.empresa_contratante_id ?? ''}
                                            onChange={(e) => setPersonaData((prev) => ({
                                                ...prev,
                                                empresa_contratante_id: e.target.value ? Number(e.target.value) : null,
                                            }))}
                                        >
                                            <option value="">Sin asignar</option>
                                            {empresasContratantes.map((emp) => (
                                                <option key={emp.Id} value={emp.Id}>{emp.razon_social}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    )}

                                    {/* LA MODALIDAD VIGENTE, no la que se firmo el dia del alta
                                        —esa se queda en el registro de la incorporacion—.
                                        Va en las DOS fichas: las dos tablas tienen la columna y las
                                        dos vias del alta la rellenan.
                                        Los valores se PIDEN por API: la pantalla no los lleva
                                        escritos, para que ampliarlos no obligue a tocarla.
                                        Sin asterisco, como la empresa: hoy nadie lo tiene y exigirlo
                                        bloquearia corregir un telefono. Obligatorio donde hay
                                        alguien decidiendo, que es el alta. */}
                                    <Form.Group>
                                        <TituloCategoria>Tipo de contrato</TituloCategoria>
                                        <Form.Select
                                            name="tipo_contrato"
                                            value={personaData.tipo_contrato ?? ''}
                                            onChange={(e) => setPersonaData((prev) => ({
                                                ...prev,
                                                tipo_contrato: e.target.value || null,
                                            }))}
                                        >
                                            <option value="">Sin asignar</option>
                                            {tiposContrato.map((t) => (
                                                <option key={t.clave} value={t.clave}>{t.etiqueta}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Oficinas</TituloCategoria>
                                        <Autocomplete
                                            multiple
                                            id="oficinas-select"
                                            options={oficinas}
                                            getOptionLabel={(option) => `${option.nombre} - ${option.poblacion}`}
                                            value={personaData.Oficinas || []}
                                            onChange={(event, newValue) => handleChange(event, newValue, 'Oficinas')}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder="Selecciona oficinas"
                                                    size="small"
                                                />
                                            )}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                    <Chip
                                                        label={option.nombre}
                                                        {...getTagProps({ index })}
                                                        key={option.Id}
                                                        size="small"
                                                    />
                                                ))
                                            }
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '4px 8px',
                                                    minHeight: '38px',
                                                }
                                            }}
                                        />
                                    </Form.Group>

                                    {/* ── LAS DOS FECHAS: QUIÉN MANDA MIENTRAS HAY UN PROCESO ────────────
                                        Estas dos columnas se escriben desde DOS SITIOS: aquí, y el
                                        proceso de alta o de baja. Mientras el proceso está abierto,
                                        manda ÉL — y editarlas aquí las dejaría discrepando de la
                                        fecha que mira el cron, que es justo el fallo que se acaba
                                        de cerrar.

                                        Así que con proceso abierto NO se quitan: se bloquean y se
                                        dice dónde se cambian. Quitarlas del todo dejaría sin fecha
                                        a las **249 personas de local que no tienen alta** —para
                                        ellas éste es el único sitio donde se pone— y no habría
                                        forma de arreglarlas.

                                        Sin proceso abierto, se editan aquí como siempre. */}
                                    {/* LAS DOS FECHAS YA NO VIVEN AQUI.

                                        Vivian en este formulario Y en la tabla de procesos, y dos
                                        copias del mismo dato acaban no coincidiendo — 25/09 en el
                                        campo y 28/09 en el proceso, que es lo que lo destapo.

                                        Ahora viven SIEMPRE en «Procesos de incorporacion y salida»:
                                        en la fila del proceso si lo hay, y en una fila MANUAL si no.
                                        Asi nadie se queda sin sitio —265 de 274 personas no tienen
                                        ningun alta— y sigue habiendo un solo sitio. */}
                                </CampoGrid>
                            </SeccionCard>

                            {/* ── PROCESOS DE INCORPORACIÓN Y SALIDA ──────────────────────────
                                Responde lo que el banner deja fuera: «¿esta persona tuvo proceso?».
                                El banner sólo sale mientras el alta está abierta —una cerrada hace
                                tres años no debe ocupar la cabecera—, así que el historial vive
                                aquí, que es donde se busca.

                                Y distingue los tres casos, que NO son el mismo:
                                  sin permiso -> «no tienes acceso», no una tabla vacía
                                  vacía       -> se preguntó y no tuvo: nació a mano. Es información
                                  con filas   -> el historial, con enlace a cada una

                                Una tabla vacía por falta de permiso diría «no tuvo proceso», que
                                es mentira — la misma distinción de siempre entre «no hay» y «no lo
                                sabemos». */}
                            <SeccionCard>
                                <SeccionHeader>
                                    <TituloSeccion style={{ margin: 0, border: 'none', paddingBottom: 0 }}>
                                        <Briefcase size={20} /> Procesos de incorporación y salida
                                    </TituloSeccion>
                                    {/* «Dar de baja» vive AQUÍ, donde viven los procesos, y no en el
                                        desplegable de situación. Hasta Fase C ese desplegable ofrecía
                                        «Baja» y la interceptaba para abrir este mismo diálogo: un apaño
                                        de Fase 11, de cuando la tabla de procesos no existía.

                                        No sale si ya tiene una baja abierta —el servidor rechaza la
                                        segunda— ni sin permiso: ofrecer un botón que da 409 o 403 es
                                        prometer algo que no se puede hacer. */}
                                    {/* `variant="outline-danger"`, de react-bootstrap, que es el
                                        Button que esta importado aqui. Lo escribi primero como
                                        `variant="outlined" color="error"` —idioma de MUI— y salio
                                        SIN BORDE Y EN NEGRO: react-bootstrap ignora esas props y no
                                        avisa. Una accion destructiva indistinguible de "Ver".
                                        El fichero tiene 17 usos mas del idioma equivocado; no se
                                        tocan aqui, pero quedan anotados. */}
                                    {!bajaAbierta && puedeEditarBajas && (
                                        <Button size="sm" variant="outline-danger"
                                            onClick={() => setDlgBaja({ ambito: ambitoBaja, id: Id, nombre: nombreCompleto })}>
                                            Dar de baja
                                        </Button>
                                    )}
                                </SeccionHeader>

                                {altasSinPermiso ? (
                                    <p style={{ fontSize: 13, color: '#64748b', margin: '8px 0 0' }}>
                                        No tienes acceso al módulo de Incorporaciones, así que no se puede
                                        comprobar si esta persona tuvo proceso.
                                    </p>
                                ) : altas === null ? (
                                    <p style={{ fontSize: 13, color: '#94a3b8', margin: '8px 0 0' }}>Cargando…</p>
                                ) : (altas.procesos || []).length === 0 ? (
                                    /* EL SILENCIO ES LA REGLA CUANDO FALTA UNA MITAD.
                                       Aquí decía «se creó directamente desde la ficha, no desde el
                                       módulo» en cuanto no había ALTAS — y eso salía en la ficha de
                                       alguien con una baja abierta, a tres centímetros del banner que
                                       la anunciaba: una afirmación falsa junto a su desmentido.
                                       249 personas no tuvieron incorporación; decirlo en cada ficha es
                                       ruido. Así que sólo se habla cuando NO HAY NINGUNO de los dos. */
                                    <p style={{ fontSize: 13, color: '#64748b', margin: '8px 0 0' }}>
                                        Esta persona no tiene procesos registrados.
                                    </p>
                                ) : (
                                    <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ textAlign: 'left', color: '#64748b' }}>
                                                <th style={{ padding: '6px 8px', fontWeight: 500 }}>Tipo</th>
                                                <th style={{ padding: '6px 8px', fontWeight: 500 }}>Proceso</th>
                                                <th style={{ padding: '6px 8px', fontWeight: 500 }}>Fecha</th>
                                                <th style={{ padding: '6px 8px', fontWeight: 500 }}>Estado</th>
                                                {/* «Preparado» y no «Tareas»: en un alta cuenta tareas,
                                                    material y credenciales. En una baja, sólo sus tareas
                                                    de devolución — NO se inventa una equivalencia entre
                                                    preparar un alta y cerrar una baja. */}
                                                <th style={{ padding: '6px 8px', fontWeight: 500 }}>Preparado</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {altas.procesos.map((pr) => {
                                                const esAlta = pr.tipo === 'alta';
                                                /* LA FILA MANUAL es la fecha de la persona cuando ningún
                                                   proceso abierto la gobierna. No es un alta: no tiene
                                                   número, ni estado, ni nada que preparar. Se edita aquí
                                                   porque aquí es donde vive ahora esa fecha. */
                                                const esManual = !!pr.manual;
                                                /* LAS ACCIONES DEL PROCESO ABIERTO VIVEN EN SU BANNER, no aquí:
                                                   el banner sale en TODAS las pestañas y esta tabla sólo en
                                                   EMPRESA, así que dejar el único botón de editar aquí sería
                                                   esconderlo.
                                                   La excepción es el caso raro: con un alta Y una baja abiertas
                                                   a la vez, el banner del alta NO se pinta —gana la baja, desde
                                                   Fase 14— y su botón se quedaría sin sitio. Entonces vive aquí.
                                                   La regla, entera: las acciones viven en el banner del proceso;
                                                   si ese banner no se pinta, viven en su fila. */
                                                const bannerDelAlta = !bajaAbierta && !!altas.abierta;
                                                const editableAqui = esAlta && pr.abierto && !bannerDelAlta;
                                                return (
                                                    <tr key={pr.tipo + (pr.id || 'manual')} style={{ borderTop: '1px solid #e2e8f0' }}>
                                                        <td style={{ padding: '6px 8px' }}>
                                                            <Chip size="small" label={esAlta ? 'Alta' : 'Baja'}
                                                                color={esAlta ? 'info' : 'default'} variant="outlined" />
                                                        </td>
                                                        <td style={{ padding: '6px 8px', fontFamily: 'monospace', color: esManual ? '#94a3b8' : undefined }}>
                                                            {esManual ? 'sin proceso' : pr.numero}
                                                        </td>
                                                        <td style={{ padding: '6px 8px' }}>
                                                            {pr.fecha
                                                                ? pr.fecha.split('-').reverse().join('/')
                                                                : <span style={{ color: '#b45309' }}>sin fecha</span>}
                                                            {/* LA DIFERENCIA SE DICE, no se deja al botón.
                                                                Una persona con su alta cerrada ve DOS filas con la
                                                                misma fecha, y son cosas distintas: una es lo que
                                                                aquel proceso planificó —histórico, ya no se toca— y
                                                                la otra el dato vivo de su ficha. Distinguirlas sólo
                                                                por «cuál tiene botón» es sutil para una diferencia
                                                                real.

                                                                Sólo se etiqueta donde hay ambigüedad: el proceso
                                                                ABIERTO no lleva nada, porque su chip ya dice «En
                                                                curso» y es el que manda — no compite con nadie. */}
                                                            {(esManual || (!pr.abierto && pr.fecha)) && (
                                                                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                                                                    {esManual ? 'dato actual de la ficha' : 'lo que planificó este proceso'}
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td style={{ padding: '6px 8px' }}>
                                                            {/* «Manual» dice de dónde se MANTIENE el dato, como
                                                                «deducida» en las credenciales. No dice quién lo
                                                                escribió: si lo puso un alta que luego se cerró,
                                                                nadie lo tecleó. */}
                                                            <Chip size="small" label={esManual ? 'Manual' : (ESTADO_PROCESO_TEXTO[pr.estado] || pr.estado)}
                                                                variant={esManual ? 'outlined' : 'filled'}
                                                                color={esManual ? 'default' : pr.abierto ? 'warning' : pr.estado === 'completada' ? 'success' : 'default'} />
                                                        </td>
                                                        <td style={{ padding: '6px 8px' }}>
                                                            {esManual
                                                                ? <span style={{ color: '#94a3b8' }}>se mantiene a mano</span>
                                                                : pr.total === 0
                                                                    ? <span style={{ color: '#94a3b8' }}>nada que preparar</span>
                                                                    : `${pr.hechas} de ${pr.total}`}
                                                        </td>
                                                        <td style={{ padding: '6px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                                                            {/* «Editar el alta» y «Editar la baja», nunca «Editar» a
                                                                secas: con los dos procesos abiertos los dos botones
                                                                pueden convivir en la misma ficha, y llamarse igual
                                                                invita a cambiar la fecha equivocada. */}
                                                            {esManual ? (
                                                                <Button size="small" variant="text" sx={{ textTransform: 'none' }}
                                                                    onClick={() => setEditManual({ tipo: pr.tipo, fecha: pr.fecha || '' })}>
                                                                    {pr.fecha ? 'Editar la fecha' : 'Poner la fecha'}
                                                                </Button>
                                                            ) : (
                                                                <>
                                                                    {editableAqui && (
                                                                        <Button size="small" variant="text" sx={{ textTransform: 'none' }}
                                                                            onClick={() => setEditAlta(altas.abierta)}>
                                                                            Editar el alta
                                                                        </Button>
                                                                    )}
                                                                    <Button size="small" variant="text" sx={{ textTransform: 'none' }}
                                                                        onClick={() => navigate(esAlta
                                                                            ? rutaAlta(pr.id)
                                                                            : rutaBaja(pr.id))}>
                                                                        Ver
                                                                    </Button>
                                                                </>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                )}
                            </SeccionCard>

                            {/* Sección de Cargos Internos (empleado) / Empresa (colaboradora) */}
                            <SeccionCard>
                                <SeccionHeader>
                                    <TituloSeccion style={{ margin: 0, border: 'none', paddingBottom: 0 }}>
                                        <Briefcase size={20} /> {tipo === "colaboradora"
                                            ? (filasInternos.length <= 1 ? 'Empresa' : 'Empresas')
                                            : (filasInternos.length <= 1 ? 'Cargo Interno' : 'Cargos Internos')}
                                    </TituloSeccion>
                                    <AddButton
                                        bonificados="true"
                                        as="button"
                                        primario="true"
                                        onClick={agregarFilaInterno}
                                        form="true"
                                        type="button"
                                    >
                                        + Añadir
                                    </AddButton>
                                </SeccionHeader>

                                {filasInternos.length === 0 ? (
                                    <EmptyState>
                                        <p>{tipo === "colaboradora" ? 'No hay empresas asignadas.' : 'No hay cargos internos asignados.'} Pulse "Añadir" para agregar uno.</p>
                                    </EmptyState>
                                ) : (
                                    filasInternos.map((fila, index) => {
                                        const tieneError = erroresCargos.internos.includes(index);

                                        return (
                                            <CargoCard key={index} $error={tieneError}>
                                                {tipo === "colaboradora" ? (
                                                    <div style={{ display: 'flex', gap: '16px', alignItems: 'end' }}>
                                                        <Form.Group style={{ flex: 1 }}>
                                                            <TituloCategoria>Empresa Colaboradora <span>*</span></TituloCategoria>
                                                            <Form.Select
                                                                value={fila.empresa}
                                                                onChange={(e) => handleChangeFilaInterno(index, 'empresa', e.target.value)}
                                                                style={tieneError && !fila.empresa ? {borderColor: '#dc3545'} : {}}
                                                            >
                                                                <option value="">Seleccionar...</option>
                                                                {empresasColaboradoras?.map((ec) => (
                                                                    <option key={ec.Id} value={ec.Id}>{ec.nombre}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                        <BotonEliminar onClick={() => eliminarFilaInterno(index)}>
                                                            <Trash2 size={18} />
                                                        </BotonEliminar>
                                                    </div>
                                                ) : (
                                                    <CargoGrid>
                                                        <Form.Group>
                                                            <TituloCategoria>Negocio <span>*</span></TituloCategoria>
                                                            <Form.Select
                                                                value={fila.empresa}
                                                                onChange={(e) => handleChangeFilaInterno(index, 'empresa', e.target.value)}
                                                                style={tieneError && !fila.empresa ? {borderColor: '#dc3545'} : {}}
                                                            >
                                                                <option value="">Seleccionar...</option>
                                                                {negocios?.map((empresa) => (
                                                                    <option key={empresa.Id} value={empresa.Id}>{empresa.nombre}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>

                                                        <Form.Group>
                                                            <TituloCategoria>Departamento <span>*</span></TituloCategoria>
                                                            <Form.Select
                                                                value={fila.departamento || ''}
                                                                onChange={(e) => handleChangeFilaInterno(index, 'departamento', e.target.value)}
                                                                disabled={!fila.empresa}
                                                                style={tieneError && !fila.departamento ? {borderColor: '#dc3545'} : {}}
                                                            >
                                                                <option value="">Seleccionar...</option>
                                                                {getDepartamentosPorEmpresaYTipo(fila.empresa, index, 'interno', filasInternos).map((departamento) => (
                                                                    <option key={departamento.Id} value={departamento.Id}>{departamento.nombre}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>

                                                        <Form.Group>
                                                            <TituloCategoria>Cargo <span>*</span></TituloCategoria>
                                                            <Form.Control
                                                                type="text"
                                                                value={fila.cargo || ''}
                                                                disabled={!fila.empresa || !fila.departamento}
                                                                onChange={(e) => handleChangeFilaInterno(index, 'cargo', e.target.value)}
                                                                style={tieneError && !fila.cargo ? {borderColor: '#dc3545'} : {}}
                                                            />
                                                        </Form.Group>

                                                        <BotonEliminar onClick={() => eliminarFilaInterno(index)}>
                                                            <Trash2 size={18} />
                                                        </BotonEliminar>
                                                    </CargoGrid>
                                                )}
                                                {tieneError && (
                                                    <small style={{ color: '#dc3545', marginTop: '8px', display: 'block' }}>
                                                        {tipo === "colaboradora" ? 'Seleccione una empresa.' : 'Esta empresa necesita departamento y cargo.'}
                                                    </small>
                                                )}
                                            </CargoCard>
                                        );
                                    })
                                )}
                            </SeccionCard>

                            {/* Sección de Cargos Organigrama - solo empleados */}
                            {tipo !== "colaboradora" && (
                            <SeccionCard>
                                <SeccionHeader>
                                    <TituloSeccion style={{ margin: 0, border: 'none', paddingBottom: 0 }}>
                                        <Users size={20} /> {filasOrganigrama.length <= 1 ? 'Cargo Organigrama' : 'Cargos Organigrama'}
                                    </TituloSeccion>
                                    <AddButton
                                        bonificados="true"
                                        as="button"
                                        primario="true"
                                        onClick={agregarFilaOrganigrama}
                                        form="true"
                                        type="button"
                                    >
                                        + Añadir
                                    </AddButton>
                                </SeccionHeader>

                                {filasOrganigrama.length === 0 ? (
                                    <EmptyState>
                                        <p>No hay cargos de organigrama asignados. Pulse "Añadir" para agregar uno.</p>
                                    </EmptyState>
                                ) : (
                                    filasOrganigrama.map((fila, index) => {
                                        const tieneError = erroresCargos.organigrama.includes(index);
                                        const esIntermedio = esMandoIntermedio(fila.departamento, fila.empresa);

                                        return (
                                            <CargoCard key={index} $error={tieneError}>
                                                <CargoGrid $organigrama>
                                                    <Form.Group>
                                                        <TituloCategoria>Negocio <span>*</span></TituloCategoria>
                                                        <Form.Select
                                                            value={fila.empresa}
                                                            onChange={(e) => handleChangeFilaOrganigrama(index, 'empresa', e.target.value)}
                                                            style={tieneError && !fila.empresa ? {borderColor: '#dc3545'} : {}}
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {negocios?.map((empresa) => (
                                                                <option key={empresa.Id} value={empresa.Id}>{empresa.nombre}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group>
                                                        <TituloCategoria>Departamento <span>*</span></TituloCategoria>
                                                        <Form.Select
                                                            value={fila.departamento}
                                                            onChange={(e) => handleChangeFilaOrganigrama(index, 'departamento', e.target.value)}
                                                            disabled={!fila.empresa}
                                                            style={tieneError && !fila.departamento ? {borderColor: '#dc3545'} : {}}
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {getDepartamentosPorEmpresaYTipo(fila.empresa, index, 'organigrama', filasOrganigrama).map((departamento) => (
                                                                <option key={departamento.Id} value={departamento.Id}>{departamento.nombre}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group>
                                                        <TituloCategoria>Cargo <span>*</span></TituloCategoria>
                                                        <Form.Control
                                                            type="text"
                                                            value={!fila.departamento ? '' : fila.cargo}
                                                            disabled={!fila.empresa || !fila.departamento}
                                                            onChange={(e) => handleChangeFilaOrganigrama(index, 'cargo', e.target.value)}
                                                            style={tieneError && !fila.cargo ? {borderColor: '#dc3545'} : {}}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group>
                                                        <TituloCategoria>Adjunto</TituloCategoria>
                                                        <Form.Select
                                                            value={esIntermedio ? '' : fila.adjunto}
                                                            onChange={(e) => handleChangeFilaOrganigrama(index, 'adjunto', e.target.value)}
                                                            disabled={!fila.empresa || esIntermedio}
                                                        >
                                                            <option value="">{esIntermedio ? 'Mando intermedio' : 'Seleccionar...'}</option>
                                                            {Array.isArray(adjuntosPorCargo[index]) && adjuntosPorCargo[index].map((adjunto) => (
                                                                <option key={adjunto.id} value={adjunto.id}>
                                                                    {adjunto.nombre} {adjunto.apellidos}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group style={{ textAlign: 'center' }}>
                                                        <TituloCategoria>Responsable</TituloCategoria>
                                                        <Switch
                                                            checked={esIntermedio ? false : Boolean(fila.responsable)}
                                                            name="responsable"
                                                            disabled={esIntermedio}
                                                            onChange={e => handleChangeFilaOrganigrama(index, 'responsable', e.target.checked)}
                                                            sx={{
                                                                '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' },
                                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' },
                                                                '& .MuiSwitch-switchBase:not(.Mui-checked)': { color: '#f44336' },
                                                                '& .MuiSwitch-switchBase:not(.Mui-checked) + .MuiSwitch-track': { backgroundColor: '#f44336' },
                                                            }}
                                                        />
                                                    </Form.Group>

                                                    <BotonEliminar onClick={() => eliminarFilaOrganigrama(index)}>
                                                        <Trash2 size={18} />
                                                    </BotonEliminar>
                                                </CargoGrid>
                                                {tieneError && (
                                                    <small style={{ color: '#dc3545', marginTop: '8px', display: 'block' }}>
                                                        Esta empresa necesita departamento y cargo.
                                                    </small>
                                                )}
                                            </CargoCard>
                                        );
                                    })
                                )}
                            </SeccionCard>
                            )}
                        </TabPanel>

                        {/* Contenido de la pestaña Vacaciones */}
                        <TabPanel value={tabValue} index={TAB.VACACIONES}>
                            {/* Sección Configuración */}
                            <SeccionCard>
                                <TituloSeccion>
                                    <Calendar size={20} /> Configuración de Vacaciones
                                </TituloSeccion>
                                <VacacionesGrid>
                                    <Form.Group>
                                        <TituloCategoria>Calendario Laboral</TituloCategoria>
                                        <Form.Select
                                            value={tipoCalendario === 'colaborador' ? (personaData.calendario_laboral_colab_id || '') : (personaData.calendario_laboral_id || '')}
                                            name={tipoCalendario === 'colaborador' ? "calendario_laboral_colab_id" : "calendario_laboral_id"}
                                            onChange={handleChange}
                                        >
                                            <option value="">{tipoCalendario === 'colaborador' ? "Seleccionar calendario colaborador" : "Seleccionar calendario laboral"}</option>
                                            {(tipoCalendario === 'colaborador' ? calendariosLaboralesColab : calendariosLaborales).map((cal) => (
                                                <option key={cal.Id} value={cal.Id}>
                                                    {cal.nombre} - {cal.provincia} ({cal.anio})
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    {/* Supervisores: OCULTO para personas colaboradoras. El servidor descarta
                                        supervisor_ids sin avisar (PersonaColaboradora_Controller.js:289) y la tabla
                                        persona_supervisores tiene las dos FK a personas.Id, asi que una colaboradora
                                        no se puede almacenar ahi. El campo prometia algo imposible desde 56037fb
                                        (11-mar-2026). La funcionalidad real es un proyecto aparte. */}
                                    {tipo !== "colaboradora" && (
                                    <Form.Group>
                                        <TituloCategoria>Supervisores</TituloCategoria>
                                        <Autocomplete
                                            multiple
                                            id="supervisor-select"
                                            size="small"
                                            options={supervisores.filter(s => s.Id !== personaData.Id)}
                                            getOptionLabel={(option) => `${option.nombre} ${option.apellidos}`}
                                            value={supervisores.filter(s => (personaData.supervisor_ids || []).includes(s.Id))}
                                            onChange={(event, newValue) => {
                                                setPersonaData(prev => ({
                                                    ...prev,
                                                    supervisor_ids: newValue.map(v => v.Id)
                                                }));
                                            }}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder={personaData.supervisor_ids?.length ? '' : 'Selecciona supervisores'}
                                                />
                                            )}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '4px 8px',
                                                    minHeight: '38px',
                                                    height: 'auto',
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '2px 0 !important',
                                                }
                                            }}
                                        />
                                    </Form.Group>
                                    )}

                                    {/* Fase 4 · Supervisores del eje COLABORADOR. Ocupa la celda
                                        derecha que 7d384a3 dejó vacía al ocultar el Autocomplete.
                                        Un Autocomplete de chips no puede alojar un selector por
                                        elemento, y aquí el nivel es POR SUPERVISOR: de ahí la lista
                                        con una fila cada uno, con el mismo patrón que los Cargos
                                        —SeccionHeader + AddButton + EmptyState + BotonEliminar—. */}
                                    {tipo === "colaboradora" && (
                                    <Form.Group>
                                        <SeccionHeader style={{ marginBottom: '12px', paddingBottom: '8px' }}>
                                            <TituloCategoria style={{ margin: 0 }}>Supervisores</TituloCategoria>
                                            <AddButton
                                                bonificados="true"
                                                as="button"
                                                primario="true"
                                                onClick={agregarFilaSupervisorColab}
                                                form="true"
                                                type="button"
                                            >
                                                + Añadir
                                            </AddButton>
                                        </SeccionHeader>

                                        {errorSupColab && (
                                            <small style={{ color: '#dc3545', display: 'block', marginBottom: '10px' }}>
                                                {errorSupColab}
                                            </small>
                                        )}

                                        {(personaData.supervisores_colab || []).length === 0 ? (
                                            <EmptyState>
                                                <p>Sin supervisores. Pulse "Añadir" para asignar uno.</p>
                                            </EmptyState>
                                        ) : (
                                            (personaData.supervisores_colab || []).map((fila, index) => (
                                                <CargoCard key={index}>
                                                    <SupervisorFilaGrid>
                                                        <Form.Group>
                                                            <TituloCategoria>Supervisor</TituloCategoria>
                                                            <Form.Select
                                                                value={fila.id || ''}
                                                                onChange={(e) => cambiarFilaSupervisorColab(index, 'id', e.target.value)}
                                                            >
                                                                <option value="">Seleccionar...</option>
                                                                {/* Si la relación existente apunta a alguien que ya no
                                                                    es candidato —cambió de empresa, o su empresa apagó
                                                                    el módulo— el nombre que vino del servidor se
                                                                    ofrece igual, para no vaciar el selector en
                                                                    silencio y hacer creer que no había nadie. */}
                                                                {fila.id && !candidatosSupColab.some(c => String(c.Id) === String(fila.id)) && (
                                                                    <option value={fila.id}>{fila.nombre || `#${fila.id}`} (fuera de tu empresa)</option>
                                                                )}
                                                                {candidatosSupColab.map((c) => (
                                                                    <option key={c.Id} value={c.Id}>{c.nombre} {c.apellidos}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>

                                                        {/* Form.Select de dos opciones, coherente con el DS v1 de esta
                                                            ficha (Bootstrap + styled-components). Un ToggleGroup de
                                                            v2.5 aquí mezclaría dos sistemas dentro del mismo card. */}
                                                        <Form.Group>
                                                            <TituloCategoria>Nivel</TituloCategoria>
                                                            <Form.Select
                                                                value={fila.nivel || 'gestionar'}
                                                                onChange={(e) => cambiarFilaSupervisorColab(index, 'nivel', e.target.value)}
                                                            >
                                                                <option value="gestionar">Gestionar</option>
                                                                <option value="ver">Solo ver</option>
                                                            </Form.Select>
                                                        </Form.Group>

                                                        <BotonEliminar type="button" onClick={() => quitarFilaSupervisorColab(index)}>
                                                            <Trash2 size={18} />
                                                        </BotonEliminar>
                                                    </SupervisorFilaGrid>
                                                </CargoCard>
                                            ))
                                        )}
                                    </Form.Group>
                                    )}
                                </VacacionesGrid>

                                {/* Información del calendario seleccionado */}
                                {(() => {
                                    let calSel = null;
                                    if (tipoCalendario === 'interno' && personaData.calendario_laboral_id) {
                                        calSel = calendariosLaborales.find(c => c.Id.toString() === personaData.calendario_laboral_id?.toString());
                                    } else if (tipoCalendario === 'colaborador' && personaData.calendario_laboral_colab_id) {
                                        calSel = calendariosLaboralesColab.find(c => c.Id.toString() === personaData.calendario_laboral_colab_id?.toString());
                                    }
                                    if (calSel) {
                                        return (
                                            <InfoCalendario>
                                                <small>
                                                    <strong>Calendario:</strong> {calSel.nombre} |
                                                    <strong> Vac. Verano:</strong> {calSel.dias_vacaciones_verano || 0} días |
                                                    <strong> Vac. Normal:</strong> {calSel.dias_vacaciones_normal || 0} días |
                                                    <strong> Horario:</strong> L-J {parseFloat(calSel.horas_lunes_jueves)}h, V {parseFloat(calSel.horas_viernes)}h
                                                    {calSel.periodoVerano && (
                                                        <> | <strong>Verano:</strong> {parseFloat(calSel.horas_verano)}h</>
                                                    )}
                                                </small>
                                            </InfoCalendario>
                                        );
                                    }
                                    return null;
                                })()}
                            </SeccionCard>

                            {/* Sección Días de Vacaciones */}
                            <SeccionCard>
                                <TituloSeccion>
                                    <Umbrella size={20} /> Días de Vacaciones
                                </TituloSeccion>
                                <CampoGrid $columnas={4}>
                                    <Form.Group>
                                        <TituloCategoria>Días Totales</TituloCategoria>
                                        <Form.Control
                                            type='number'
                                            name='dias_vacaciones_totales'
                                            min="0"
                                            value={(personaData.calendario_laboral_id || personaData.calendario_laboral_colab_id) ? (personaData.dias_vacaciones_totales ?? 0) : 0}
                                            disabled={!personaData.calendario_laboral_id && !personaData.calendario_laboral_colab_id}
                                            onChange={(e) => setPersonaData(prev => ({
                                                ...prev,
                                                dias_vacaciones_totales: parseInt(e.target.value) || 0
                                            }))}
                                        />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Obligatorios Verano</TituloCategoria>
                                        <Form.Control
                                            type='number'
                                            name='dias_verano_obligatorios'
                                            min="0"
                                            value={(personaData.calendario_laboral_id || personaData.calendario_laboral_colab_id) ? (personaData.dias_verano_obligatorios ?? 0) : 0}
                                            disabled={!personaData.calendario_laboral_id && !personaData.calendario_laboral_colab_id}
                                            onChange={(e) => setPersonaData(prev => ({
                                                ...prev,
                                                dias_verano_obligatorios: parseInt(e.target.value) || 0
                                            }))}
                                        />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Días Usados</TituloCategoria>
                                        <Form.Control
                                            type='number'
                                            name='dias_vacaciones_usados'
                                            min="0"
                                            value={personaData.dias_vacaciones_usados ?? 0}
                                            disabled
                                        />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Días Disponibles</TituloCategoria>
                                        <Form.Control
                                            type='number'
                                            value={(personaData.calendario_laboral_id || personaData.calendario_laboral_colab_id) ? ((personaData.dias_vacaciones_totales ?? 0) - (personaData.dias_vacaciones_usados ?? 0)) : 0}
                                            disabled
                                        />
                                    </Form.Group>
                                </CampoGrid>
                                <small style={{ color: '#6c757d', display: 'block', marginTop: '-10px' }}>
                                    Los valores se asignan automáticamente al seleccionar un calendario laboral, pero pueden ajustarse manualmente
                                </small>

                                <Form.Group style={{ marginTop: '20px' }}>
                                    <TituloCategoria>Observaciones</TituloCategoria>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        name="observaciones_vacaciones"
                                        value={personaData.observaciones_vacaciones || ''}
                                        onChange={(e) => setPersonaData(prev => ({
                                            ...prev,
                                            observaciones_vacaciones: e.target.value
                                        }))}
                                        placeholder="Cualquier información relevante sobre las vacaciones..."
                                    />
                                </Form.Group>
                                
                            </SeccionCard>
                        </TabPanel>
                    </Col>

                    <Col>
                        {/* Fase 12 · §6.7 — Formación. SIN puerta: no es dato confidencial. */}
                        <TabPanel value={tabValue} index={TAB.FORMACION}>
                            <PestanaFormacion
                                personaId={Id}
                                tipo={tipo === 'colaboradora' ? 'colaboradora' : null}
                                puedeEditar={puedeEditarFicha}
                                clave={TAB.FORMACION}
                                alCambiar={registrarCambios}
                                registrarGuardado={registrarGuardado}
                            />
                        </TabPanel>

                        {/* Fase 12 · §6.7 — RRHH. TRAS LA PUERTA, y sólo con el permiso.
                            El panel entero va envuelto en `puedeVerRrhh` por lo mismo que Soporte:
                            la condición vive en dos sitios —la pestaña y su panel— y abrir uno y
                            olvidar el otro deja un panel alcanzable por `?tab=rrhh`. */}
                        {puedeVerRrhh && (
                            <TabPanel value={tabValue} index={TAB.RRHH}>
                                <PestanaRrhh
                                    personaId={Id}
                                    tipo={tipo === 'colaboradora' ? 'colaboradora' : null}
                                    puedeEditar={puedeEditarRrhh}
                                    clave={TAB.RRHH}
                                    alCambiar={registrarCambios}
                                    registrarGuardado={registrarGuardado}
                                />
                            </TabPanel>
                        )}

                        {/* Fase 13 · Credenciales. SIN puerta: el `valor` es un identificador, no un
                            secreto. El único que no puede viajar —el usuario del NAS— lo tapa el
                            servidor con su lista blanca, y la fila se ve igual: «no lo puedes ver»
                            no es «no lo tiene». */}
                        <TabPanel value={tabValue} index={TAB.CREDENCIALES}>
                            <PestanaCredenciales
                                personaId={Id}
                                tipo={tipo === 'colaboradora' ? 'colaboradora' : null}
                                puedeEditar={puedeEditarFicha}
                                clave={TAB.CREDENCIALES}
                                alCambiar={registrarCambios}
                                registrarGuardado={registrarGuardado}
                                ventana={ventana2FA.activa ? ventana2FA.ventana : null}
                                alContar={anotarResumen}
                            />
                        </TabPanel>

                        {/* Fase 13 · Inventario. De SOLO LECTURA: no registra guardado, y por eso
                            los dos botones de guardar salen deshabilitados (ver TABS_SOLO_LECTURA).
                            `bajaAbierta` se le pasa en vez de que lo vuelva a preguntar: la ficha ya
                            lo sabe, y dos consultas a la misma pregunta pueden discrepar. */}
                        <TabPanel value={tabValue} index={TAB.INVENTARIO}>
                            <PestanaInventario
                                personaId={Id}
                                tipo={tipo === 'colaboradora' ? 'colaboradora' : null}
                                bajaAbierta={bajaAbierta}
                                alContar={anotarResumen}
                                puedeEditar={puedeEditarFicha}
                            />
                        </TabPanel>

                        {/* Citas técnicas (24/10). De solo lectura, como Inventario: carga lo suyo al
                            abrirse, y el ámbito sale de `tipo`. */}
                        {puedeVerCitas && (
                            <TabPanel value={tabValue} index={TAB.CITAS}>
                                <PestanaCitasTecnicas
                                    personaId={Id}
                                    tipo={tipo === 'colaboradora' ? 'colaboradora' : null}
                                />
                            </TabPanel>
                        )}
                    </Col>
                    <Col>
                        {/* Contenido de la pestaña Soporte */}
                        {puedeVerSoporte(persona.persona?.rol) && (
                            <TabPanel value={tabValue} index={TAB.SOPORTE}>
                                {/* Fase B · Acceso y seguridad, aquí y FUERA del panel bloqueado.
                                    En A1 se puso en PERSONAL para no ser circular —exigir segundo
                                    factor para ver quién tiene segundo factor—, pero ese argumento
                                    sólo obliga a que NO ESTÉ TRAS LA PUERTA, no a sacarlo de esta
                                    pestaña. Aquí queda con lo demás de sistemas, que es su sitio, y
                                    se ve al abrir la pestaña sin escribir ningún código.
                                    No enseña ningún secreto: sólo si lo tiene y desde cuándo. */}
                                {/* ── EL ROL VIVE AQUÍ, no en EMPRESA ──────────────────────────────
                                    El rol no dice en qué empresa trabaja alguien: dice qué puede
                                    hacer dentro de la intranet. Estaba en EMPRESA, que la ven los
                                    cuatro roles que editan fichas, y SOPORTE la ven sólo
                                    Administrador y Super Administrador — los mismos dos que el
                                    servidor deja cambiarlo.

                                    Y el sitio es lo de menos: el problema era que `general` PODÍA
                                    cambiarlo, medido contra la base. Eso se arregla en
                                    `services/cambioDeRol.js`, no moviendo un campo. Esto sólo hace
                                    que la pantalla diga la verdad: quien no puede, no lo ve —en vez
                                    de verlo y llevarse un 403 al guardar.

                                    Fuera del panel bloqueado, como «Acceso y seguridad»: no enseña
                                    ningún secreto. */}
                                {['administrador', 'super administrador'].includes(persona.persona?.rol?.toLowerCase()) && (
                                    <SeccionCard>
                                        <TituloSeccion>
                                            <Wrench size={20} /> Rol en la intranet
                                        </TituloSeccion>
                                        <CampoGrid $columnas={3}>
                                            <Form.Group>
                                                <TituloCategoria id="Rol">Rol <span>*</span></TituloCategoria>
                                                <Form.Select
                                                    value={personaData.Rol?.Id || ''}
                                                    name="Rol"
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {roles?.filter((rol) => {
                                                        const rolNombre = rol?.nombre?.toLowerCase();
                                                        const esSuperAdmin = rolNombre === 'super administrador';
                                                        const rolUsuario = persona.persona?.rol?.toLowerCase();
                                                        return !(esSuperAdmin && rolUsuario === 'administrador');
                                                    }).map((rol) => (
                                                        <option key={rol.Id} value={rol.Id}>
                                                            {rol?.nombre}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <ErrorForm mensaje={camposRequeridos.rol} estadoAlerta={estadoCampoReque.Rol} />
                                            </Form.Group>
                                        </CampoGrid>
                                    </SeccionCard>
                                )}

                                {['administrador', 'super administrador'].includes(persona.persona?.rol?.toLowerCase()) && (
                                    <SeccionCard>
                                        <BloqueAccesoSeguridad
                                            personaId={Id}
                                            tipo={tipo === 'colaboradora' ? 'colaboradora' : null}
                                            puedeRestablecer
                                        />
                                    </SeccionCard>
                                )}
                                {!soporteDesbloqueado ? (
                                    <SeccionCard>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '3rem 1rem',
                                            gap: '1rem',
                                            color: '#666'
                                        }}>
                                            <Lock size={48} color="#999" />
                                            <h5 style={{ margin: 0 }}>Contenido protegido</h5>
                                            <p style={{ margin: 0, textAlign: 'center' }}>
                                                Introduce tu código de verificación en dos pasos para ver
                                                los datos sensibles de soporte
                                            </p>
                                            <Button
                                                variant="primary"
                                                style={{ backgroundColor: '#336384', borderColor: '#336384', marginTop: '0.5rem' }}
                                                onClick={abrirPuertaSoporte}
                                            >
                                                <Lock size={16} style={{ marginRight: '0.5rem' }} />
                                                Desbloquear
                                            </Button>
                                        </div>
                                    </SeccionCard>
                                ) : (
                                <>
                                {/* Sección Credenciales */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Lock size={20} /> Credenciales
                                    </TituloSeccion>
                                    <VacacionesGrid>
                                        <Form.Group>
                                            <TituloCategoria>Usuario NAS</TituloCategoria>
                                            <Form.Control type='text' name='usuario_nas' value={personaData.usuario_nas || ''} onChange={handleChange} />
                                        </Form.Group>
                                        <Form.Group>
                                            <TituloCategoria>Contraseña NAS</TituloCategoria>
                                            <Form.Control type='text' name='password_nas' value={personaData.password_nas || ''} onChange={handleChange} />
                                        </Form.Group>
                                    </VacacionesGrid>
                                    <VacacionesGrid>
                                        <Form.Group>
                                            <TituloCategoria>Email Microsoft 365</TituloCategoria>
                                            <Form.Control type='email' name='mail_empresa' value={personaData.mail_empresa || ''} onChange={handleChange} />
                                        </Form.Group>
                                        <Form.Group>
                                            <TituloCategoria>Contraseña Microsoft 365</TituloCategoria>
                                            <Form.Control type='text' name='password_m365' value={personaData.password_m365 || ''} onChange={handleChange} />
                                        </Form.Group>
                                    </VacacionesGrid>
                                </SeccionCard>

                                {/* Sección Conexión Remota */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Monitor size={20} /> Conexión Remota
                                    </TituloSeccion>
                                    <SoporteGrid>
                                        <ConexionRemotaContainer>
                                            <Form.Group>
                                                <TituloCategoria>AnyDesk - PC</TituloCategoria>
                                                <Form.Control type='text' name='conexion_remota' value={personaData.conexion_remota || ''} onChange={handleChange} />
                                            </Form.Group>
                                            {personaData.conexion_remota && (
                                                <BotonAnyDesk
                                                    onClick={() => window.location.href = `anydesk://${personaData.conexion_remota.replace(/\s+/g, '')}`}
                                                >
                                                    <img src={LogoAnyDesk} alt="Conectar AnyDesk" />
                                                </BotonAnyDesk>
                                            )}
                                                                                    {/*Contraseña Big Data */}
                                            <Form.Group>
                                                <TituloCategoria>RuskDesk - PC</TituloCategoria>
                                                <Form.Control type='text' maxLength={9} name='ruskdesk_pc' value={personaData.ruskdesk_pc || ''} onChange={handleChange} />
                                            </Form.Group>

                                        </ConexionRemotaContainer>

                                        <ConexionRemotaContainer>
                                            <Form.Group>
                                                <TituloCategoria>AnyDesk - Móvil</TituloCategoria>
                                                <Form.Control type='text' name='conexion_remota_movil' value={personaData.conexion_remota_movil || ''} onChange={handleChange} />
                                            </Form.Group>
                                            {personaData.conexion_remota_movil && (
                                                <BotonAnyDesk
                                                    onClick={() => window.location.href = `anydesk://${personaData.conexion_remota_movil.replace(/\s+/g, '')}`}
                                                >
                                                    <img src={LogoAnyDeskMovil} alt="Conectar AnyDesk Móvil" style={{ width: '70%', height: '85%' }} />
                                                </BotonAnyDesk>
                                            )}

                                            <Form.Group>
                                                <TituloCategoria>RuskDesk - Móvil</TituloCategoria>
                                                <Form.Control type='text' maxLength={9} name='ruskdesk_movil' value={personaData.ruskdesk_movil || ''} onChange={handleChange} />
                                            </Form.Group>

                                        </ConexionRemotaContainer>

                                        <Form.Group>
                                            <TituloCategoria>Contraseña AnyDesk</TituloCategoria>
                                            <Form.Control type='text' name='password_anydesk' value={personaData.password_anydesk || ''} onChange={handleChange} />
                                        </Form.Group>
                                    </SoporteGrid>
                                </SeccionCard>

                                {/* Sección Equipo */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Laptop size={20} /> Equipo
                                    </TituloSeccion>
                                    <VacacionesGrid>
                                        <Form.Group>
                                            <TituloCategoria>Contraseña Administrador</TituloCategoria>
                                            <Form.Control type='text' name='password_admin_equipo' value={personaData.password_admin_equipo || ''} onChange={handleChange} />
                                        </Form.Group>
                                        <Form.Group>
                                            <TituloCategoria>Contraseña Usuario</TituloCategoria>
                                            <Form.Control type='text' name='password_usuario_equipo' value={personaData.password_usuario_equipo || ''} onChange={handleChange} />
                                        </Form.Group>
                                    </VacacionesGrid>

                                    <CampoGrid $columnas={2} >
                                        <Form.Group>
                                            <TituloCategoria>BitLocker</TituloCategoria>
                                            <Form.Control maxLength={55} type='text' name='bit_locker' value={personaData.bit_locker || ''} onChange={handleChange} />
                                        </Form.Group>

                                        {tipo === "colaboradora" && soporteDesbloqueado && (

                                            <Form.Group>
                                                <Boton title='VER DATOS DE CONEXIÓN REMOTA' onClick={handleMostrardatosSoporte}> <Eye  size={20}></Eye></Boton>
                                            </Form.Group>
                                        )}            
                                    </CampoGrid>
                                    

                                </SeccionCard>

                                {/* Sección Observaciones */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Server size={20} /> Observaciones de Soporte
                                    </TituloSeccion>
                                    <Form.Group>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            name="observaciones_soporte"
                                            value={personaData.observaciones_soporte || ''}
                                            onChange={handleChange}
                                            placeholder="Notas técnicas, configuraciones especiales, etc."
                                            style={{ resize: 'vertical' }}
                                        />

                                        <ErrorForm mensaje={camposRequeridos.observaciones_soporte} estadoAlerta={estadoCampoReque.observaciones_soporte} />
                                    </Form.Group>
                                </SeccionCard>

                                {/* Sección Gestionar Vacaciones — OCULTA en Fase 4.2: el ámbito se concede desde
                                    /configuracion/permisos → "Ámbito por empresa". Flag en config/flags.js; no se
                                    borra hasta Fase 6 (evita dos escritores de gestion_vacaciones_*). */}
                                {!OCULTAR_GESTION_VACACIONES_FICHA && tipo !== "colaboradora" && <SeccionCard>
                                    <TituloSeccion>
                                        <Umbrella size={20} /> Gestionar Vacaciones
                                    </TituloSeccion>
                                    <VacacionesGrid>
                                        <Form.Group>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={personaData.gestion_vacaciones_int !== null && personaData.gestion_vacaciones_int !== undefined}
                                                        onChange={(e) => {
                                                            if (!e.target.checked) {
                                                                setPersonaData(prev => ({ ...prev, gestion_vacaciones_int: null }));
                                                            } else {
                                                                setPersonaData(prev => ({ ...prev, gestion_vacaciones_int: '{}' }));
                                                            }
                                                        }}
                                                        sx={{ color: '#6c757d', '&.Mui-checked': { color: 'rgba(0, 60, 102, 0.9)' } }}
                                                    />
                                                }
                                                label={<span style={{ fontSize: '14px', fontWeight: 600, color: '#495057' }}>Gestionar vacaciones internas</span>}
                                            />
                                            {personaData.gestion_vacaciones_int !== null && personaData.gestion_vacaciones_int !== undefined && (() => {
                                                let parsed = {};
                                                try { parsed = JSON.parse(personaData.gestion_vacaciones_int || '{}'); } catch {}
                                                if (Array.isArray(parsed)) parsed = {};
                                                if (parsed.empresas) {
                                                    const migrated = {};
                                                    (parsed.empresas || []).forEach(eId => { migrated[eId] = []; });
                                                    (parsed.departamentos || []).forEach(dId => {
                                                        const dept = departamentos.find(d => d.Id === dId);
                                                        if (dept && dept.Negocios) {
                                                            dept.Negocios.forEach(emp => {
                                                                if (migrated[emp.Id] && !migrated[emp.Id].includes(dId)) migrated[emp.Id].push(dId);
                                                            });
                                                        }
                                                    });
                                                    parsed = migrated;
                                                }
                                                const empIds = Object.keys(parsed).map(Number);
                                                return (
                                                <>
                                                    <Autocomplete
                                                        multiple
                                                        id="gestion-vac-int-empresas"
                                                        options={negocios || []}
                                                        getOptionLabel={(option) => option.nombre || ''}
                                                        value={negocios.filter(e => empIds.includes(e.Id))}
                                                        onChange={(event, newValue) => {
                                                            const nuevoObj = {};
                                                            newValue.forEach(emp => {
                                                                nuevoObj[emp.Id] = parsed[emp.Id] || [];
                                                            });
                                                            setPersonaData(prev => ({ ...prev, gestion_vacaciones_int: JSON.stringify(nuevoObj) }));
                                                        }}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder="Selecciona Negocios"
                                                                size="small"
                                                            />
                                                        )}
                                                        renderTags={(value, getTagProps) =>
                                                            value.map((option, index) => (
                                                                <Chip
                                                                    label={option.nombre}
                                                                    {...getTagProps({ index })}
                                                                    key={option.Id}
                                                                    size="small"
                                                                />
                                                            ))
                                                        }
                                                        sx={{
                                                            mt: 1,
                                                            width: '100%',
                                                            '& .MuiOutlinedInput-root': {
                                                                padding: '4px 8px',
                                                                minHeight: '38px',
                                                            }
                                                        }}
                                                    />
                                                    {empIds.length > 0 && empIds.map(empId => {
                                                        const emp = negocios.find(e => e.Id === empId);
                                                        if (!emp) return null;
                                                        const deptIdsEmp = parsed[empId] || [];
                                                        const deptOptions = departamentos.filter(d =>
                                                            d.Negocios && d.Negocios.some(e => e.Id === empId)
                                                        );
                                                        return (
                                                            <div key={empId} style={{ marginTop: '8px', padding: '8px 0px 8px 12px', backgroundColor: '#f8f9fa', borderRadius: '6px', borderLeft: '3px solid rgba(0, 60, 102, 0.6)' }}>
                                                                <small style={{ fontWeight: 600, color: '#495057', display: 'block', marginBottom: '4px' }}>{emp.nombre}</small>
                                                                <Autocomplete
                                                                    multiple
                                                                    id={`gestion-vac-int-deptos-${empId}`}
                                                                    options={deptOptions}
                                                                    getOptionLabel={(option) => option.nombre || ''}
                                                                    value={departamentos.filter(d => deptIdsEmp.includes(d.Id))}
                                                                    onChange={(event, newValue) => {
                                                                        const ids = newValue.map(v => v.Id);
                                                                        const nuevoObj = { ...parsed, [empId]: ids };
                                                                        setPersonaData(prev => ({ ...prev, gestion_vacaciones_int: JSON.stringify(nuevoObj) }));
                                                                    }}
                                                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            variant="outlined"
                                                                            placeholder="Selecciona departamentos"
                                                                            size="small"
                                                                        />
                                                                    )}
                                                                    renderTags={(value, getTagProps) =>
                                                                        value.map((option, index) => (
                                                                            <Chip
                                                                                label={option.nombre}
                                                                                {...getTagProps({ index })}
                                                                                key={option.Id}
                                                                                size="small"
                                                                            />
                                                                        ))
                                                                    }
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            padding: '4px 8px',
                                                                            minHeight: '38px',
                                                                            backgroundColor: '#fff',
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                                );
                                            })()}
                                        </Form.Group>

                                        <Form.Group>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={personaData.gestion_vacaciones_colab !== null && personaData.gestion_vacaciones_colab !== undefined}
                                                        onChange={(e) => {
                                                            if (!e.target.checked) {
                                                                setPersonaData(prev => ({ ...prev, gestion_vacaciones_colab: null }));
                                                            } else {
                                                                setPersonaData(prev => ({ ...prev, gestion_vacaciones_colab: '[]' }));
                                                            }
                                                        }}
                                                        sx={{ color: '#6c757d', '&.Mui-checked': { color: 'rgba(0, 60, 102, 0.9)' } }}
                                                    />
                                                }
                                                label={<span style={{ fontSize: '14px', fontWeight: 600, color: '#495057' }}>Gestionar vacaciones colaboradores</span>}
                                            />
                                            {personaData.gestion_vacaciones_colab !== null && personaData.gestion_vacaciones_colab !== undefined && (
                                                <Autocomplete
                                                    multiple
                                                    id="gestion-vac-colab-select"
                                                    options={(empresasColaboradoras || []).filter(e => e.vacaciones)}
                                                    getOptionLabel={(option) => option.nombre || ''}
                                                    value={(empresasColaboradoras || []).filter(e => {
                                                        try {
                                                            const ids = JSON.parse(personaData.gestion_vacaciones_colab || '[]');
                                                            return ids.includes(e.Id);
                                                        } catch { return false; }
                                                    })}
                                                    onChange={(event, newValue) => {
                                                        const ids = newValue.map(v => v.Id);
                                                        setPersonaData(prev => ({ ...prev, gestion_vacaciones_colab: JSON.stringify(ids) }));
                                                    }}
                                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Selecciona empresas colaboradoras"
                                                            size="small"
                                                        />
                                                    )}
                                                    renderTags={(value, getTagProps) =>
                                                        value.map((option, index) => (
                                                            <Chip
                                                                label={option.nombre}
                                                                {...getTagProps({ index })}
                                                                key={option.Id}
                                                                size="small"
                                                            />
                                                        ))
                                                    }
                                                    sx={{
                                                        mt: 1,
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '4px 8px',
                                                            minHeight: '38px',
                                                        }
                                                    }}
                                                />
                                            )}
                                        </Form.Group>
                                    </VacacionesGrid>
                                </SeccionCard>}

                                {/* Sección Dirección de Envío */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Send size={20} /> Dirección de Envío
                                    </TituloSeccion>
                                    <VacacionesGrid>
                                        <Form.Group>
                                            <TituloCategoria>Tipo de Dirección</TituloCategoria>
                                            <Form.Select
                                                name="tipo_direccion_envio"
                                                value={
                                                    personaData.direccion_envio === 'personal' ? 'personal' :
                                                    personaData.direccion_envio?.startsWith('oficina-') ? personaData.direccion_envio :
                                                    'personalizado'
                                                }
                                                onChange={(e) => {
                                                    const valor = e.target.value;
                                                    if (valor === 'personalizado') {
                                                        setPersonaData(prev => ({ ...prev, direccion_envio: '' }));
                                                    } else {
                                                        setPersonaData(prev => ({ ...prev, direccion_envio: valor }));
                                                    }
                                                }}
                                            >
                                                <option value="personal">Dirección personal</option>
                                                {personaData.Oficinas && personaData.Oficinas.map((oficina) => (
                                                    <option key={oficina.Id} value={`oficina-${oficina.Id}`}>
                                                        {oficina.nombre}
                                                    </option>
                                                ))}
                                                <option value="personalizado">Personalizado</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group>
                                            <TituloCategoria>Dirección</TituloCategoria>
                                            {personaData.direccion_envio !== 'personal' && !personaData.direccion_envio?.startsWith('oficina-') ? (
                                                <Form.Control
                                                    type="text"
                                                    name="direccion_envio"
                                                    placeholder="Introduce la dirección personalizada"
                                                    value={personaData.direccion_envio || ''}
                                                    onChange={handleChange}
                                                />
                                            ) : (
                                                <Form.Control
                                                    type="text"
                                                    readOnly
                                                    value={
                                                        personaData.direccion_envio === 'personal'
                                                            ? (personaData.direccion
                                                                ? [personaData.direccion, personaData.codigo_postal, personaData.poblacion, personaData.provincia ? `(${personaData.provincia})` : ''].filter(Boolean).join(', ')
                                                                : 'No definida')
                                                            : personaData.direccion_envio?.startsWith('oficina-')
                                                                ? (() => {
                                                                    const oficinaId = parseInt(personaData.direccion_envio.split('-')[1]);
                                                                    const oficina = personaData.Oficinas?.find(o => o.Id === oficinaId);
                                                                    return oficina
                                                                        ? [oficina.direccion, oficina.cp, oficina.poblacion].filter(Boolean).join(', ') || 'No definida'
                                                                        : 'Oficina no encontrada';
                                                                })()
                                                                : 'No definida'
                                                    }
                                                    style={{ backgroundColor: '#f8f9fa' }}
                                                />
                                            )}
                                        </Form.Group>
                                    </VacacionesGrid>
                                </SeccionCard>
                                {/* Sección generador de Enlace */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Anchor size={20} /> Generar Enlace de Contraseña
                                    </TituloSeccion>

                                    <CampoGrid $columnas={2}>
                                        <CampoGrid $columnas={1}>
                                            <Form.Group>
                                                <TituloCategoria>Nombre del enlace</TituloCategoria>
                                                <Form.Control
                                                    type="text"
                                                    name="nombre"
                                                    value={datosLink.nombre}
                                                    onChange={(e) =>
                                                        setDatosLink(prev => ({
                                                            ...prev,
                                                            nombre: e.target.value
                                                        }))
                                                    }
                                                />
                                            </Form.Group>

                                             <Form.Group style={{display:"flex", alignItems:"center"}}>
                                                 <TituloCategoria style={{paddingBottom:"0px", marginBottom:"0px"}}>Ocultar correo electrónico</TituloCategoria>
                                                <Checkbox
                                                    checked={datosLink.hideEmail || false}
                                                    onChange={(e) => {
                                                        if (!e.target.checked) {
                                                            setDatosLink(prev => ({ ...prev, hideEmail: false }));
                                                        } else {
                                                            setDatosLink(prev => ({ ...prev, hideEmail: true }));
                                                        }
                                                    }}
                                                    sx={{ color: '#6c757d', '&.Mui-checked': { color: 'rgba(0, 60, 102, 0.9)' } }}
                                                />
                                            </Form.Group>

                                        </CampoGrid>
                                        <Form.Group style={{height:"72%"}}>
                                            <TituloCategoria>Notas</TituloCategoria>
                                            <Form.Control 
                                                style={{height:"100%"}}
                                                as="textarea"
                                                rows={3}
                                                name="notes"
                                                value={datosLink.notes}
                                                onChange={(e) =>
                                                    setDatosLink(prev => ({
                                                        ...prev,
                                                        notes: e.target.value
                                                    }))
                                                }
                                            />
                                        </Form.Group>
                                    </CampoGrid>

                                    <CampoGrid $columnas={3}>
                                        <Form.Group>
                                            <TituloCategoria>Tiempo de expiración</TituloCategoria>
                                            <Form.Select
                                                value={datosLink.horasExpiracion}
                                                onChange={(e) =>
                                                    setDatosLink(prev => ({
                                                        ...prev,
                                                        horasExpiracion: Number(e.target.value)
                                                    }))
                                                }
                                            >
                                                {fechasExpiracionOptions.map((opt) => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>Máximo de accesos</TituloCategoria>
                                            <Form.Control
                                                type="number"
                                                name="maxAccessCount"
                                                value={datosLink.maxAccessCount || ''}
                                                min={1}
                                                max={10}
                                                onChange={(e) =>
                                                    setDatosLink(prev => ({
                                                        ...prev,
                                                        maxAccessCount: Number(e.target.value)
                                                    }))
                                                }
                                            />
                                        </Form.Group>

                                         <Form.Group>
                                            <TituloCategoria>Tiempo de Eliminación (exp + eli)</TituloCategoria>
                                            <Form.Select
                                                value={datosLink.horasEliminacion}
                                                onChange={(e) =>
                                                    setDatosLink(prev => ({
                                                        ...prev,
                                                        horasEliminacion: Number(e.target.value)
                                                    }))
                                                }
                                            >
                                                {fechasExpiracionOptions.map((opt) => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>

                                    </CampoGrid>

                                    <CampoGrid $columnas={2}>
                                        <Form.Group>
                                            <TituloCategoria>Contraseña del enlace</TituloCategoria>
                                            <Form.Control
                                                type="text"
                                                name="password"
                                                value={datosLink.password || ''}
                                                onChange={(e) =>
                                                    setDatosLink(prev => ({
                                                        ...prev,
                                                        password: e.target.value
                                                    }))
                                                }
                                            />
                                        </Form.Group>

                                        <Form.Group>
                                            <Boton
                                                type="button"
                                                onClick={() => {handleCreateRecoveryLink()}}
                                                bonificados="true"
                                                disabled={
                                                    !datosLink.password ||
                                                    !datosLink.maxAccessCount ||
                                                    datosLink.maxAccessCount <= 0
                                                }
                                            >
                                                Generar Enlace
                                            </Boton>
                                        </Form.Group>
                                    </CampoGrid>

                                    <CampoGrid
                                        $columnas={2}
                                        style={{
                                            marginTop: '20px',
                                            width: '100%',
                                        }}
                                    >
                                        {urlEnlace && (
                                            <>
                                                <Form.Group>
                                                    <Form.Label>URL del enlace</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={urlEnlace}
                                                        readOnly
                                                    />
                                                </Form.Group>

                                                <CampoGrid $columnas={3} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                    <Boton 
                                                    bonificados="true"
                                                    type="button"
                                                    onClick={() => copiarAlPortapapeles(urlEnlace)}
                                                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                                                    title="Copiar enlace al portapapeles"
                                                    >
                                                        <Copy size={18}/>
                                                        Copiar enlace
                                                    </Boton>

                                                    {/* <Boton 
                                                    bonificados="true"
                                                    to={urlEnlace}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                                                    title={`Enviar enlace a: ${personaData.mail_empresa || 'correo no disponible'}`}
                                                    >
                                                        <Send size={18}/>
                                                        Ver enlace
                                                    </Boton> */}

                                                     <Boton 
                                                    bonificados="true"
                                                    type="button"
                                                    onClick={() => {sendEmailUrlBitwarden();}}
                                                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                                                    title={`Enviar enlace a: ${personaData.mail_empresa || 'correo no disponible'}`}
                                                    >
                                                        <Mail size={18}/>
                                                        Enviar correo
                                                    </Boton>
                                                </CampoGrid>
                                            </>
                                        )}
                                    </CampoGrid>
                                </SeccionCard>
                                </>
                                )}
                            </TabPanel>
                        )}
                    </Col>
                    <Row className="mt-4">
                            {/* Fase 13 · en las pestañas de solo lectura los dos de guardar salen en
                                gris, con su motivo. El <span> hace falta: un botón deshabilitado no
                                emite eventos de ratón, así que el Tooltip no se enteraría de que está
                                encima — el mismo detalle que con las pestañas de la Fase 12. */}
                            <ContenedorBotones >
                                {/* Fase 12 · §6.10 — LA BARRA, EN LAS SEIS PESTAÑAS.
                                    Los tres botones de siempre, en todas. Lo que cambia no es si
                                    están, sino a dónde va «Guardar»: `handleSubmit` bifurca por
                                    la pestaña visible y llama al endpoint que corresponda.
                                    En §6.9 se probó a esconderlos en RRHH y Formación. Quitaba la
                                    ambigüedad quitando la función, y dejaba dos pestañas con una
                                    pantalla distinta de las otras cuatro. */}
                                <Boton
                                    bonificados="true"
                                    title={bloqueoSoporte ? MOTIVO_BLOQUEO_SOPORTE : tituloBotonGuardar}
                                    name='guardar_cambios_statico'
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                    disabled={soloLectura || bloqueoSoporte || datosCargando || (cargosRaw.length > 0 && !cargosProcesados)}
                                    style={{ opacity: (soloLectura || bloqueoSoporte || datosCargando || (cargosRaw.length > 0 && !cargosProcesados)) ? 0.6 : 1, cursor: (soloLectura || bloqueoSoporte || datosCargando || (cargosRaw.length > 0 && !cargosProcesados)) ? 'not-allowed' : 'pointer', marginRight: '90px !important' }}
                                >
                                    {bloqueoSoporte ? 'Vuelve a cargar Soporte' : (datosCargando || (cargosRaw.length > 0 && !cargosProcesados)) ? 'Cargando datos...' : 'Guardar'}
                                </Boton>

                                <Boton
                                    bonificados="true"
                                    title={bloqueoSoporte ? MOTIVO_BLOQUEO_SOPORTE : tituloBotonGuardar}
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                    disabled={soloLectura || bloqueoSoporte || datosCargando || (cargosRaw.length > 0 && !cargosProcesados)}
                                    style={{ opacity: (soloLectura || bloqueoSoporte || datosCargando || (cargosRaw.length > 0 && !cargosProcesados)) ? 0.6 : 1, cursor: (soloLectura || bloqueoSoporte || datosCargando || (cargosRaw.length > 0 && !cargosProcesados)) ? 'not-allowed' : 'pointer' }}
                                >
                                    {bloqueoSoporte ? 'Vuelve a cargar Soporte' : (datosCargando || (cargosRaw.length > 0 && !cargosProcesados)) ? 'Cargando datos...' : volver ? 'Guardar y volver al proceso' : 'Guardar y Salir'}
                                </Boton>
                                {/* «Cancelar» es la tercera salida: con `volver`, vuelve al proceso
                                    por el mismo camino que guardar, sin guardar. */}
                                {volver ? (
                                    <Boton grande="true" as="button" type="button" onClick={salirAlProceso}>
                                        Cancelar
                                    </Boton>
                                ) : (
                                    <Boton
                                        grande="true"
                                        to={`/gestionpersonas/personas${location.search}`}
                                    >
                                        Cancelar
                                    </Boton>
                                )}
                            </ContenedorBotones>
                        </Row>
                </FormContainer>
            </Form>
            {botonRenderClick ? <DatosCorrectosPersona envioActivado={formCompletado} queryParams={location.search} volverA={volver} volverPorHistorial={vueltaPorHistorial} />          
            :             
                <DatosCorrectosPersona envioActivado={formCompletado} redirect={false}/>
            }   

            {/* Fase 13 · el aviso de cambios sin guardar, con la forma del proyecto.
                Antes era un `window.confirm`: bloquea el navegador entero y no se parece a nada de
                la intranet. Esto es una red de seguridad, no un guardián — los botones de abajo son
                los que guardan. */}
            {/* ── EDITAR LA FECHA Y EL MOTIVO DE LA BAJA ───────────────────────────────────
                Estaba escrito aquí dentro desde Fase 14, y el PANEL DEL PROCESO —donde se busca—
                no lo tenía. Ahora es un componente y lo usan los dos: copiarlo allí habría dejado
                dos diálogos avisando del mismo acto, que es como se acaba con uno diciendo la
                verdad y el otro la creencia de hace dos fases. */}
            <EditarBajaDialog
                open={!!editBaja}
                baja={bajaAbierta}
                personaNombre={nombreCompleto}
                onClose={() => setEditBaja(null)}
                // `navigate(0)` es lo que ya hacía: la baja puede haber cambiado estado, acceso y
                // fecha, y aquí se recarga entero en vez de fundir campos. No se toca ahora.
                onGuardada={() => { setEditBaja(null); navigate(0); }}
            />

            <Modal
                open={!!tabPendiente}
                onClose={() => setTabPendiente(null)}
                size="sm"
                tone="danger"
                title="Hay cambios sin guardar"
                subtitle="Si cambias de pestaña ahora, lo que has escrito y no has guardado se perderá."
                footer={(
                    <div className="flex items-center justify-end gap-2">
                        <button type="button" onClick={() => setTabPendiente(null)}
                            className="rounded-v25-md border border-v25-line bg-white px-4 py-2 text-[13px] font-semibold text-v25-ink-700 shadow-v25-btn">
                            Seguir aquí
                        </button>
                        <button type="button"
                            onClick={() => { const d = tabPendiente; setTabPendiente(null); cambiarDeTab(d); }}
                            className="rounded-v25-md bg-v25-expired-fg px-4 py-2 text-[13px] font-semibold text-white shadow-v25-btn">
                            Cambiar y perderlos
                        </button>
                    </div>
                )}
            >
                <p className="text-[13px] leading-relaxed text-v25-ink-700">
                    Para conservarlos, vuelve y pulsa <strong>Guardar</strong> al final de la ficha.
                </p>
            </Modal>

            <DatosIncorrectos envioActivado={formCompletado} duplicado={errorEnviarForm.personaDuplicada}/>
            <ServerNoCreoPersona envioActivado={errorEnviarForm.personaDuplicada} editar={true} />

            {/* ── Fase 11 §2.bis · los dos caminos, un resultado ─────────────────────────────
                El MISMO componente que la pestaña de Bajas. Si fueran dos diálogos parecidos, el
                día que cambie una regla se actualizaría uno y no el otro, y las bajas creadas
                desde la ficha saldrían distintas de las creadas desde el listado. */}
            {dlgBaja && (
                <CrearBajaDialog
                    open
                    ambito={dlgBaja.ambito}
                    personaId={dlgBaja.id}
                    personaNombre={dlgBaja.nombre}
                    onClose={() => setDlgBaja(null)}
                    onCreada={async (r) => {
                        setDlgBaja(null);
                        setBajaCreada(r);
                        /* ── LA FICHA SE ENTERA DE LO QUE ACABA DE PASAR ───────────────────────
                         *
                         * Aquí había escrito lo contrario: «el desplegable NO se deja en Baja
                         * porque el estado lo escribe el cierre del proceso». Eso era verdad
                         * ANTES de Fase 11. Desde Fase 11 lo escribe LA FECHA, así que una baja
                         * con fecha de hoy o pasada desactiva al crearla — y la ficha se quedaba
                         * diciendo «Alta» a propósito, por una razón que ya no existía.
                         *
                         * El servidor SÍ manda el dato (`persona_desactivada`) y el cliente lo
                         * tiraba. Ahora se lee, y sólo se recarga si de verdad pasó algo. */
                        if (r && r.persona_desactivada) await refrescarLoQueEscribioElProceso();
                    }}
                    onAbrirBaja={() => {
                        setDlgBaja(null);
                        navigate('/gestionpersonas/personas/bajas');
                    }}
                />
            )}

            {avisoRevertir && (
                <AvisoRevertirBaja
                    open
                    baja={avisoRevertir}
                    personaNombre={nombreCompleto}
                    onClose={() => setAvisoRevertir(null)}
                    onIrALaBaja={() => {
                        setAvisoRevertir(null);
                        navigate('/gestionpersonas/personas/bajas');
                    }}
                />
            )}

            {/* Tras crear el proceso, la ficha tiene que explicar por qué su desplegable sigue
                diciendo lo de antes. Sin esto parecería que el cambio no se ha guardado. */}
            {/* EDITAR LA FECHA DEL ALTA. El mismo componente que usa el panel del proceso: un solo
                diálogo, un solo aviso. Dos copias acaban avisando de cosas distintas del mismo acto. */}
            <EditarAltaDialog
                open={!!editAlta}
                alta={editAlta}
                personaNombre={nombreCompleto}
                estadoPersona={personaData.estado}
                onClose={() => setEditAlta(null)}
                onGuardada={async () => {
                    // La fecha puede haber cambiado el estado y el acceso: la ficha se entera por
                    // el mismo camino que la baja, con la lista blanca de lo que escribe un proceso.
                    await refrescarLoQueEscribioElProceso();
                    try {
                        const d = await altasDePersona(ambitoBaja, Id);
                        setAltas(d);
                    } catch (e) { /* el alta ya se guardó; el banner se pondrá al día al recargar */ }
                }}
            />

            {/* LA FILA MANUAL: la fecha de la persona, editada donde ahora vive.
                Va EN LÍNEA y no como componente porque tiene UN solo sitio que la abre. Los otros
                dos diálogos se extrajeron porque los abrían dos pantallas y dos copias acaban
                avisando de cosas distintas del mismo acto; aquí no hay segunda copia que evitar. */}
            <Modal
                open={!!editManual}
                onClose={() => setEditManual(null)}
                size="sm"
                title={editManual && editManual.tipo === 'baja' ? 'Fecha de baja' : 'Fecha de alta'}
                subtitle={nombreCompleto}
                footer={(
                    <div className="flex items-center justify-end gap-2">
                        <button type="button" onClick={() => setEditManual(null)}
                            className="rounded-v25-md border border-v25-line bg-white px-4 py-2 text-[13px] font-semibold text-v25-ink-700 shadow-v25-btn">
                            Cancelar
                        </button>
                        <button
                            type="button"
                            disabled={!editManual || editManual.guardando}
                            onClick={async () => {
                                const campo = editManual.tipo === 'baja' ? 'fecha_baja' : 'fecha_alta';
                                setEditManual((x) => ({ ...x, guardando: true }));
                                try {
                                    const r = await fechaManualDePersona(ambitoBaja, Id, campo, editManual.fecha || null);
                                    // El aviso lo MANDA EL SERVIDOR cuando toca: es él quien sabe que
                                    // guardar una fecha de baja no desactiva a nadie.
                                    if (r && r.aviso) toast.info(r.aviso, { autoClose: 8000 });
                                    else toast.success('Fecha guardada.');
                                    setEditManual(null);
                                    await refrescarLoQueEscribioElProceso();
                                    try { setAltas(await altasDePersona(ambitoBaja, Id)); } catch (e) { /* la fila se pondrá al día al recargar */ }
                                } catch (e) {
                                    toast.error(e?.response?.data?.message || 'No se ha podido guardar.');
                                    setEditManual((x) => ({ ...x, guardando: false }));
                                }
                            }}
                            className="rounded-v25-md bg-v25-ink-900 px-4 py-2 text-[13px] font-semibold text-white shadow-v25-btn disabled:opacity-50"
                        >
                            {editManual && editManual.guardando ? 'Guardando…' : 'Guardar'}
                        </button>
                    </div>
                )}
            >
                {editManual && (
                    <div className="space-y-3">
                        <div>
                            <label className="mb-1 block text-[12px] font-semibold text-v25-ink-700" htmlFor="fecha-manual">
                                {editManual.tipo === 'baja' ? 'Fecha de baja' : 'Fecha de incorporación'}
                            </label>
                            <input
                                id="fecha-manual"
                                type="date"
                                value={editManual.fecha || ''}
                                onChange={(ev) => setEditManual((x) => ({ ...x, fecha: ev.target.value }))}
                                className="w-full rounded-v25-md border border-v25-line px-3 py-2 text-[13px]"
                            />
                        </div>
                        <p className="rounded-v25-md border border-v25-line bg-v25-surface-sunken px-3 py-2 text-xs leading-relaxed text-v25-ink-700">
                            {editManual.tipo === 'baja' ? (
                                <>
                                    Esto guarda <strong>sólo la fecha</strong>. No le quita el acceso a nadie:
                                    quien lo hace es el proceso de salida. Es un dato histórico, no una acción.
                                </>
                            ) : (
                                <>
                                    Esta persona no tiene ningún proceso de incorporación abierto, así que su
                                    fecha <strong>se mantiene a mano</strong> desde aquí. Si algún día se le abre
                                    uno, pasará a gestionarla el proceso.
                                </>
                            )}
                        </p>
                    </div>
                )}
            </Modal>

            {bajaCreada && (
                <AvisoProcesoCreado>
                    <strong>Proceso de salida {bajaCreada.numero} creado.</strong>
                    {/* TRES RAMAS, porque son tres cosas distintas y antes se decía una sola —y la
                        equivocada—. El aviso PREVIO del diálogo ya decía la verdad; éste, el de
                        después, decía que el estado cambiaría al cerrar. La última palabra la tenía
                        el texto falso. */}
                    {bajaCreada.persona_desactivada ? (
                        <span>
                            <strong>{nombreCompleto} ya está de baja y sin acceso.</strong> La fecha ya
                            había llegado, así que el estado, la desactivación y la fecha de baja se han
                            escrito ahora, en la misma transacción que el proceso. La ficha ya lo refleja.
                            {bajaCreada.aviso_sesion ? <> {bajaCreada.aviso_sesion}</> : null}
                        </span>
                    ) : bajaCreada.motivo_no_desactivada === 'ya_desactivada' ? (
                        <span>
                            {nombreCompleto} <strong>ya estaba sin acceso</strong> antes de este proceso,
                            así que no ha cambiado nada en su cuenta.
                        </span>
                    ) : (
                        <span>
                            {nombreCompleto} <strong>sigue trabajando y conserva su acceso</strong>: la
                            fecha de baja aún no ha llegado. Se desactivará sola ese día, cierre alguien
                            el proceso o no.
                        </span>
                    )}
                    <BotonesAviso>
                        <Button size="sm" variant="outline-secondary" onClick={() => setBajaCreada(null)}>Entendido</Button>
                        <Button size="sm" variant="primary" onClick={() => navigate('/gestionpersonas/personas/bajas')}>
                            Ir al proceso
                        </Button>
                    </BotonesAviso>
                </AvisoProcesoCreado>
            )}
        </>
    );
}

// Aviso flotante del proceso creado. Styled-components y no Tailwind: este fichero es de la capa
// antigua y mezclar los dos sistemas dentro de un mismo componente hace ilegible el que quede.
const AvisoProcesoCreado = styled.div`
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 1200;
    max-width: 380px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 14px 16px;
    border-radius: 10px;
    border: 1px solid #bfdbfe;
    background: #eff6ff;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
    font-size: 13px;
    line-height: 1.5;
    color: #1e3a5f;
`

const BotonesAviso = styled.div`
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    margin-top: 4px;
`

const CabeceraForm = styled.div`
    margin: 2% 0% 0% 35%;

    @media (max-width: 576px) {
        margin: 2% 0% 0% 5%;
    }
`

const FormContainer = styled(Container)`
    @media (max-width: 576px) {
        padding-left: 8px;
        padding-right: 8px;
    }
`

const ContenedorBotones = styled.div`
    display: flex;
    gap: 15px;
    justify-content: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
`

const TituloCategoria = styled(Form.Label)`
    font-weight: 600;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 1.6;
    color: #495057;
    margin-bottom: 6px;
    display: block;

    span {
        color: #dc3545;
        font-weight: 400;
        margin-left: 2px;
    }
`

const TituloSeccion = styled.h4`
    font-weight: 700;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    margin: 0 0 20px 0;
    color: rgba(0, 60, 102, 0.9);
    border-bottom: 2px solid rgba(0, 60, 102, 0.3);
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;

    svg {
        opacity: 0.8;
    }
`

const ContenedorEncabezado = styled.div`
    width: 100%;
    height: 240px;
    border: 3px solid rgba(0, 60, 102, 0.8);
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;

    @media (max-width: 576px) {
        height: 180px;
    }
`

const SeccionCard = styled.div`
    background: ${props => props.$destacado ? 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' : '#ffffff'};
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    @media (max-width: 576px) {
        padding: 14px 10px;
        margin-bottom: 16px;
        border-radius: 8px;
    }
`

const PerfilHeader = styled.div`
    display: flex;
    gap: 30px;
    align-items: flex-start;
    margin-bottom: 30px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }

    @media (max-width: 576px) {
        gap: 16px;
        margin-bottom: 16px;
    }
`

const ImagenPerfilContainer = styled.div`
    flex-shrink: 0;
    text-align: center;
    width: 240px;

    @media (max-width: 576px) {
        width: 100%;
        max-width: 200px;
    }
`

const ImagenPerfil = styled.img`
    width: 100%;
    height: 240px;
    object-fit: cover;
    border: 3px solid rgba(0, 60, 102, 0.8);
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    @media (max-width: 576px) {
        height: 180px;
    }
`

const DatosBasicosContainer = styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }

    @media (max-width: 576px) {
        width: 100%;
        gap: 10px;
    }
`

const CampoGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(${props => props.$columnas || 4}, 1fr);
    gap: 20px;
    margin-bottom: 20px;

    @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
        gap: 12px;
        margin-bottom: 12px;
    }
`

const CargoCard = styled.div`
    background: ${props => props.$error ? '#fff5f5' : '#fafbfc'};
    border: ${props => props.$error ? '2px solid #dc3545' : '1px solid #e1e4e8'};
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 16px;
    transition: all 0.2s ease;

    &:hover {
        background: ${props => props.$error ? '#fff5f5' : '#f6f8fa'};
        border-color: ${props => props.$error ? '#dc3545' : 'rgba(0, 60, 102, 0.3)'};
    }

    @media (max-width: 576px) {
        padding: 12px 10px;
        margin-bottom: 12px;
    }
`

const CargoGrid = styled.div`
    display: grid;
    grid-template-columns: ${props => props.$organigrama ? '1fr 1fr 1fr 1fr auto auto' : '1fr 1fr 1fr auto'};
    gap: 16px;
    align-items: end;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
        gap: 10px;
    }
`

const BotonEliminar = styled(Button)`
    background-color: #dc3545 !important;
    border: none !important;
    width: 46px;
    height: 46px;
    border-radius: 8px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease !important;

    &:hover {
        background-color: #c82333 !important;
        transform: scale(1.05);
    }
`

// `FilaFechas` se fue con los dos campos de fecha: ya no hay nada que maquetar en fila.
// Una definicion huerfana con nombre bonito es una invitacion a volver a poner el campo aqui.


const InfoCalendario = styled.div`
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
    padding: 16px 20px;
    border-radius: 10px;
    margin-bottom: 24px;
    border: 1px solid #81c784;

    small {
        color: #2e7d32;
        font-size: 13px;
        line-height: 1.6;
    }

    strong {
        font-weight: 600;
    }
`

// Fase 4 · fila de supervisor: [supervisor | nivel | borrar].
//
// Grid LOCAL y no CargoGrid, a propósito. CargoGrid es de TRES columnas de contenido
// (`1fr 1fr 1fr auto`) y lo comparten tres bloques de esta ficha, incluido el de Cargos
// Internos del EJE INTERNO. Variarlo por prop tocaría la ficha interna, que el diseño de la
// Fase 4 excluye explícitamente. Aquí solo hay dos campos, así que reutilizarlo dejaría una
// columna vacía en medio.
//
// Tampoco se replica su breakpoint de 1200px: ése existe para plegar TRES columnas en dos, y
// con dos no hay nada que plegar. Sí se replica el de 576px, donde CargoGrid pasa a una
// columna, para que esta fila degrade igual que su vecina.
//
// Nota medida: la zona más apretada es 768–992px, donde VacacionesGrid sigue a dos columnas y
// esta celda mide media pantalla (~380px). Por debajo de 768 el contenedor pasa a una columna
// y la fila gana sitio. Si en la revisión visual se ve estrecha ahí, la solución es un
// `@media (min-width: 769px) and (max-width: 992px)`; no se añade a ciegas.
const SupervisorFilaGrid = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr auto;
    gap: 12px;
    align-items: end;

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
        gap: 10px;
    }
`

const VacacionesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }

    @media (max-width: 576px) {
        gap: 12px;
        margin-bottom: 12px;
    }
`

const BotonAnyDesk = styled(Button)`
    height: 55px;
    width: 55px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #e0e0e0 !important;
    border-radius: 10px !important;
    background-color: #ffffff !important;
    transition: all 0.2s ease !important;

    &:hover {
        border-color: #ef443a !important;
        transform: scale(1.05);
        box-shadow: 0 4px 12px rgba(239, 68, 58, 0.2);
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`

const SoporteGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 24px;

    @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
        gap: 12px;
        margin-bottom: 16px;
    }
`

const ConexionRemotaContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

const EmptyState = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #6c757d;
    background: #f8f9fa;
    border-radius: 10px;
    border: 2px dashed #dee2e6;

    p {
        margin: 0;
        font-size: 14px;
    }
`

const AddButton = styled(Boton)`
    font-size: 14px !important;
    padding: 10px 20px !important;
    margin: 0 !important;
    display: inline-flex !important;
    align-items: center;
    gap: 8px;
`

const SeccionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid rgba(0, 60, 102, 0.2);
`

const AccionesPerfilRow = styled.div`
    position: relative;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e9ecef;
    min-height: 110px;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
`

/* Un dato que NO se edita. Sin borde de campo y sin fondo blanco: que no parezca un `input`
   apagado, porque un control deshabilitado invita a preguntar por qué no se puede tocar. */
const DatoCalculado = styled.div`
  display: flex;
  flex-direction: column;
  /* A LA IZQUIERDA Y DEL ANCHO DE SU TEXTO. Estirado al ancho de la columna, el chip se lee como
     un campo deshabilitado, y un control que parece apagado invita a preguntar por que no se
     puede tocar. Esto no esta apagado: es que no es un control. */
  align-items: flex-start;
  gap: 4px;
  padding: 6px 0 0 0;
  min-height: 38px;
`;
/* El «por qué» del dato calculado. Gris y pequeño: acompaña, no compite con la insignia. */
const PieCalculado = styled.span`
  font-size: 0.75rem;
  color: #64748b;
  line-height: 1.35;
`;

const SwitchContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`

const UploadContainer = styled.div`
    position: absolute;
    left: 0;
    top: 20px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 2px dashed #dee2e6;
    transition: all 0.2s ease;
    width: 240px;

    &:hover {
        border-color: rgba(0, 60, 102, 0.5);
        background: #f0f4f8;
    }

    input[type="file"] {
        margin-top: 8px;
    }

    @media (max-width: 768px) {
        position: static;
        width: 100%;
    }

    @media (max-width: 576px) {
        padding: 10px;
    }
`

export default FormEditarPersona;